"use client";
import { C as e, S as t, T as n, _ as r, a as i, b as a, c as o, d as s, f as c, g as l, h as u, i as d, l as f, m as p, n as m, o as h, p as g, r as _, s as v, t as y, u as b, v as x, w as S, x as C, y as w } from "./useOpenerSoundLevel-BgfG5O7E.js";
import { a as T, i as E, n as D, r as O } from "./registration-BkPgmtZ2.js";
import { Suspense as k, createContext as A, memo as j, useCallback as M, useContext as ee, useEffect as N, useId as P, useLayoutEffect as F, useMemo as I, useRef as L, useState as R, useSyncExternalStore as te } from "react";
import { Fragment as z, jsx as B, jsxs as V } from "react/jsx-runtime";
import { animate as H, motion as ne, useMotionValue as re, useTransform as ie } from "motion/react";
import { uniformInt as ae } from "pure-rand/distribution/uniformInt";
import { QueryClient as oe, useMutation as se, useQuery as ce } from "@tanstack/react-query";
//#region ../../node_modules/zod/v4/core/core.js
var le;
function U(e, t, n) {
	function r(n, r) {
		if (n._zod || Object.defineProperty(n, "_zod", {
			value: {
				def: r,
				constr: o,
				traits: /* @__PURE__ */ new Set()
			},
			enumerable: !1
		}), n._zod.traits.has(e)) return;
		n._zod.traits.add(e), t(n, r);
		let i = o.prototype, a = Object.keys(i);
		for (let e = 0; e < a.length; e++) {
			let t = a[e];
			t in n || (n[t] = i[t].bind(n));
		}
	}
	let i = n?.Parent ?? Object;
	class a extends i {}
	Object.defineProperty(a, "name", { value: e });
	function o(e) {
		var t;
		let i = n?.Parent ? new a() : this;
		r(i, e), (t = i._zod).deferred ?? (t.deferred = []);
		for (let e of i._zod.deferred) e();
		return i;
	}
	return Object.defineProperty(o, "init", { value: r }), Object.defineProperty(o, Symbol.hasInstance, { value: (t) => n?.Parent && t instanceof n.Parent ? !0 : t?._zod?.traits?.has(e) }), Object.defineProperty(o, "name", { value: e }), o;
}
var ue = class extends Error {
	constructor() {
		super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
	}
}, de = class extends Error {
	constructor(e) {
		super(`Encountered unidirectional transform during encode: ${e}`), this.name = "ZodEncodeError";
	}
};
(le = globalThis).__zod_globalConfig ?? (le.__zod_globalConfig = {});
var fe = globalThis.__zod_globalConfig;
function pe(e) {
	return e && Object.assign(fe, e), fe;
}
//#endregion
//#region ../../node_modules/zod/v4/core/util.js
function me(e) {
	let t = Object.values(e).filter((e) => typeof e == "number");
	return Object.entries(e).filter(([e, n]) => t.indexOf(+e) === -1).map(([e, t]) => t);
}
function he(e, t) {
	return typeof t == "bigint" ? t.toString() : t;
}
function ge(e) {
	return { get value() {
		{
			let t = e();
			return Object.defineProperty(this, "value", { value: t }), t;
		}
	} };
}
function _e(e) {
	return e == null;
}
function W(e) {
	let t = +!!e.startsWith("^"), n = e.endsWith("$") ? e.length - 1 : e.length;
	return e.slice(t, n);
}
function ve(e, t) {
	let n = e / t, r = Math.round(n), i = 2 ** -52 * Math.max(Math.abs(n), 1);
	return Math.abs(n - r) < i ? 0 : n - r;
}
var ye = /* @__PURE__*/ Symbol("evaluating");
function G(e, t, n) {
	let r;
	Object.defineProperty(e, t, {
		get() {
			if (r !== ye) return r === void 0 && (r = ye, r = n()), r;
		},
		set(n) {
			Object.defineProperty(e, t, { value: n });
		},
		configurable: !0
	});
}
function be(e, t, n) {
	Object.defineProperty(e, t, {
		value: n,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}
function xe(...e) {
	let t = {};
	for (let n of e) {
		let e = Object.getOwnPropertyDescriptors(n);
		Object.assign(t, e);
	}
	return Object.defineProperties({}, t);
}
function Se(e) {
	return JSON.stringify(e);
}
function Ce(e) {
	return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
var we = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {};
function Te(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
var Ee = /* @__PURE__*/ ge(() => {
	if (fe.jitless || typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare")) return !1;
	try {
		return Function(""), !0;
	} catch {
		return !1;
	}
});
function De(e) {
	if (Te(e) === !1) return !1;
	let t = e.constructor;
	if (t === void 0 || typeof t != "function") return !0;
	let n = t.prototype;
	return Te(n) !== !1 && Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") !== !1;
}
function Oe(e) {
	return De(e) ? { ...e } : Array.isArray(e) ? [...e] : e instanceof Map ? new Map(e) : e instanceof Set ? new Set(e) : e;
}
var ke = /* @__PURE__*/ new Set([
	"string",
	"number",
	"symbol"
]);
function Ae(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function je(e, t, n) {
	let r = new e._zod.constr(t ?? e._zod.def);
	return (!t || n?.parent) && (r._zod.parent = e), r;
}
function K(e) {
	let t = e;
	if (!t) return {};
	if (typeof t == "string") return { error: () => t };
	if (t?.message !== void 0) {
		if (t?.error !== void 0) throw Error("Cannot specify both `message` and `error` params");
		t.error = t.message;
	}
	return delete t.message, typeof t.error == "string" ? {
		...t,
		error: () => t.error
	} : t;
}
function Me(e) {
	return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
var Ne = {
	safeint: [-(2 ** 53 - 1), 2 ** 53 - 1],
	int32: [-2147483648, 2147483647],
	uint32: [0, 4294967295],
	float32: [-34028234663852886e22, 34028234663852886e22],
	float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function Pe(e, t) {
	let n = e._zod.def, r = n.checks;
	if (r && r.length > 0) throw Error(".pick() cannot be used on object schemas containing refinements");
	return je(e, xe(e._zod.def, {
		get shape() {
			let e = {};
			for (let r in t) {
				if (!(r in n.shape)) throw Error(`Unrecognized key: "${r}"`);
				t[r] && (e[r] = n.shape[r]);
			}
			return be(this, "shape", e), e;
		},
		checks: []
	}));
}
function Fe(e, t) {
	let n = e._zod.def, r = n.checks;
	if (r && r.length > 0) throw Error(".omit() cannot be used on object schemas containing refinements");
	return je(e, xe(e._zod.def, {
		get shape() {
			let r = { ...e._zod.def.shape };
			for (let e in t) {
				if (!(e in n.shape)) throw Error(`Unrecognized key: "${e}"`);
				t[e] && delete r[e];
			}
			return be(this, "shape", r), r;
		},
		checks: []
	}));
}
function Ie(e, t) {
	if (!De(t)) throw Error("Invalid input to extend: expected a plain object");
	let n = e._zod.def.checks;
	if (n && n.length > 0) {
		let n = e._zod.def.shape;
		for (let e in t) if (Object.getOwnPropertyDescriptor(n, e) !== void 0) throw Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
	}
	return je(e, xe(e._zod.def, { get shape() {
		let n = {
			...e._zod.def.shape,
			...t
		};
		return be(this, "shape", n), n;
	} }));
}
function Le(e, t) {
	if (!De(t)) throw Error("Invalid input to safeExtend: expected a plain object");
	return je(e, xe(e._zod.def, { get shape() {
		let n = {
			...e._zod.def.shape,
			...t
		};
		return be(this, "shape", n), n;
	} }));
}
function Re(e, t) {
	if (e._zod.def.checks?.length) throw Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
	return je(e, xe(e._zod.def, {
		get shape() {
			let n = {
				...e._zod.def.shape,
				...t._zod.def.shape
			};
			return be(this, "shape", n), n;
		},
		get catchall() {
			return t._zod.def.catchall;
		},
		checks: t._zod.def.checks ?? []
	}));
}
function ze(e, t, n) {
	let r = t._zod.def.checks;
	if (r && r.length > 0) throw Error(".partial() cannot be used on object schemas containing refinements");
	return je(t, xe(t._zod.def, {
		get shape() {
			let r = t._zod.def.shape, i = { ...r };
			if (n) for (let t in n) {
				if (!(t in r)) throw Error(`Unrecognized key: "${t}"`);
				n[t] && (i[t] = e ? new e({
					type: "optional",
					innerType: r[t]
				}) : r[t]);
			}
			else for (let t in r) i[t] = e ? new e({
				type: "optional",
				innerType: r[t]
			}) : r[t];
			return be(this, "shape", i), i;
		},
		checks: []
	}));
}
function Be(e, t, n) {
	return je(t, xe(t._zod.def, { get shape() {
		let r = t._zod.def.shape, i = { ...r };
		if (n) for (let t in n) {
			if (!(t in i)) throw Error(`Unrecognized key: "${t}"`);
			n[t] && (i[t] = new e({
				type: "nonoptional",
				innerType: r[t]
			}));
		}
		else for (let t in r) i[t] = new e({
			type: "nonoptional",
			innerType: r[t]
		});
		return be(this, "shape", i), i;
	} }));
}
function Ve(e, t = 0) {
	if (e.aborted === !0) return !0;
	for (let n = t; n < e.issues.length; n++) if (e.issues[n]?.continue !== !0) return !0;
	return !1;
}
function He(e, t = 0) {
	if (e.aborted === !0) return !0;
	for (let n = t; n < e.issues.length; n++) if (e.issues[n]?.continue === !1) return !0;
	return !1;
}
function Ue(e, t) {
	return t.map((t) => {
		var n;
		return (n = t).path ?? (n.path = []), t.path.unshift(e), t;
	});
}
function We(e) {
	return typeof e == "string" ? e : e?.message;
}
function Ge(e, t, n) {
	let r = e.message ? e.message : We(e.inst?._zod.def?.error?.(e)) ?? We(t?.error?.(e)) ?? We(n.customError?.(e)) ?? We(n.localeError?.(e)) ?? "Invalid input", { inst: i, continue: a, input: o, ...s } = e;
	return s.path ??= [], s.message = r, t?.reportInput && (s.input = o), s;
}
function Ke(e) {
	return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function qe(...e) {
	let [t, n, r] = e;
	return typeof t == "string" ? {
		message: t,
		code: "custom",
		input: n,
		inst: r
	} : { ...t };
}
//#endregion
//#region ../../node_modules/zod/v4/core/errors.js
var Je = (e, t) => {
	e.name = "$ZodError", Object.defineProperty(e, "_zod", {
		value: e._zod,
		enumerable: !1
	}), Object.defineProperty(e, "issues", {
		value: t,
		enumerable: !1
	}), e.message = JSON.stringify(t, he, 2), Object.defineProperty(e, "toString", {
		value: () => e.message,
		enumerable: !1
	});
}, Ye = U("$ZodError", Je), Xe = U("$ZodError", Je, { Parent: Error });
function Ze(e, t = (e) => e.message) {
	let n = {}, r = [];
	for (let i of e.issues) i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
	return {
		formErrors: r,
		fieldErrors: n
	};
}
function Qe(e, t = (e) => e.message) {
	let n = { _errors: [] }, r = (e, i = []) => {
		for (let a of e.issues) if (a.code === "invalid_union" && a.errors.length) a.errors.map((e) => r({ issues: e }, [...i, ...a.path]));
		else if (a.code === "invalid_key") r({ issues: a.issues }, [...i, ...a.path]);
		else if (a.code === "invalid_element") r({ issues: a.issues }, [...i, ...a.path]);
		else {
			let e = [...i, ...a.path];
			if (e.length === 0) n._errors.push(t(a));
			else {
				let r = n, i = 0;
				for (; i < e.length;) {
					let n = e[i];
					i === e.length - 1 ? (r[n] = r[n] || { _errors: [] }, r[n]._errors.push(t(a))) : r[n] = r[n] || { _errors: [] }, r = r[n], i++;
				}
			}
		}
	};
	return r(e), n;
}
//#endregion
//#region ../../node_modules/zod/v4/core/parse.js
var $e = (e) => (t, n, r, i) => {
	let a = r ? {
		...r,
		async: !1
	} : { async: !1 }, o = t._zod.run({
		value: n,
		issues: []
	}, a);
	if (o instanceof Promise) throw new ue();
	if (o.issues.length) {
		let t = new ((i?.Err) ?? e)(o.issues.map((e) => Ge(e, a, pe())));
		throw we(t, i?.callee), t;
	}
	return o.value;
}, et = (e) => async (t, n, r, i) => {
	let a = r ? {
		...r,
		async: !0
	} : { async: !0 }, o = t._zod.run({
		value: n,
		issues: []
	}, a);
	if (o instanceof Promise && (o = await o), o.issues.length) {
		let t = new ((i?.Err) ?? e)(o.issues.map((e) => Ge(e, a, pe())));
		throw we(t, i?.callee), t;
	}
	return o.value;
}, tt = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		async: !1
	} : { async: !1 }, a = t._zod.run({
		value: n,
		issues: []
	}, i);
	if (a instanceof Promise) throw new ue();
	return a.issues.length ? {
		success: !1,
		error: new (e ?? Ye)(a.issues.map((e) => Ge(e, i, pe())))
	} : {
		success: !0,
		data: a.value
	};
}, nt = /* @__PURE__*/ tt(Xe), rt = (e) => async (t, n, r) => {
	let i = r ? {
		...r,
		async: !0
	} : { async: !0 }, a = t._zod.run({
		value: n,
		issues: []
	}, i);
	return a instanceof Promise && (a = await a), a.issues.length ? {
		success: !1,
		error: new e(a.issues.map((e) => Ge(e, i, pe())))
	} : {
		success: !0,
		data: a.value
	};
}, it = /* @__PURE__*/ rt(Xe), at = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return $e(e)(t, n, i);
}, ot = (e) => (t, n, r) => $e(e)(t, n, r), st = (e) => async (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return et(e)(t, n, i);
}, ct = (e) => async (t, n, r) => et(e)(t, n, r), lt = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return tt(e)(t, n, i);
}, ut = (e) => (t, n, r) => tt(e)(t, n, r), dt = (e) => async (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return rt(e)(t, n, i);
}, ft = (e) => async (t, n, r) => rt(e)(t, n, r), pt = /^[cC][0-9a-z]{6,}$/, mt = /^[0-9a-z]+$/, ht = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, gt = /^[0-9a-vA-V]{20}$/, _t = /^[A-Za-z0-9]{27}$/, vt = /^[a-zA-Z0-9_-]{21}$/, yt = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, bt = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, xt = (e) => e ? RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, St = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Ct = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function wt() {
	return new RegExp(Ct, "u");
}
var Tt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Et = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Dt = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Ot = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, kt = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, At = /^[A-Za-z0-9_-]*$/, jt = /^https?$/, Mt = /^\+[1-9]\d{6,14}$/, Nt = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Pt = /*@__PURE__*/ RegExp(`^${Nt}$`);
function Ft(e) {
	let t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
	return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function It(e) {
	return RegExp(`^${Ft(e)}$`);
}
function Lt(e) {
	let t = Ft({ precision: e.precision }), n = ["Z"];
	e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
	let r = `${t}(?:${n.join("|")})`;
	return RegExp(`^${Nt}T(?:${r})$`);
}
var Rt = (e) => {
	let t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
	return RegExp(`^${t}$`);
}, zt = /^-?\d+$/, Bt = /^-?\d+(?:\.\d+)?$/, Vt = /^[^A-Z]*$/, Ht = /^[^a-z]*$/, Ut = /*@__PURE__*/ U("$ZodCheck", (e, t) => {
	var n;
	e._zod ??= {}, e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), Wt = {
	number: "number",
	bigint: "bigint",
	object: "date"
}, Gt = /*@__PURE__*/ U("$ZodCheckLessThan", (e, t) => {
	Ut.init(e, t);
	let n = Wt[typeof t.value];
	e._zod.onattach.push((e) => {
		let n = e._zod.bag, r = (t.inclusive ? n.maximum : n.exclusiveMaximum) ?? Infinity;
		t.value < r && (t.inclusive ? n.maximum = t.value : n.exclusiveMaximum = t.value);
	}), e._zod.check = (r) => {
		(t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
			origin: n,
			code: "too_big",
			maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
			input: r.value,
			inclusive: t.inclusive,
			inst: e,
			continue: !t.abort
		});
	};
}), Kt = /*@__PURE__*/ U("$ZodCheckGreaterThan", (e, t) => {
	Ut.init(e, t);
	let n = Wt[typeof t.value];
	e._zod.onattach.push((e) => {
		let n = e._zod.bag, r = (t.inclusive ? n.minimum : n.exclusiveMinimum) ?? -Infinity;
		t.value > r && (t.inclusive ? n.minimum = t.value : n.exclusiveMinimum = t.value);
	}), e._zod.check = (r) => {
		(t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
			origin: n,
			code: "too_small",
			minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
			input: r.value,
			inclusive: t.inclusive,
			inst: e,
			continue: !t.abort
		});
	};
}), qt = /*@__PURE__*/ U("$ZodCheckMultipleOf", (e, t) => {
	Ut.init(e, t), e._zod.onattach.push((e) => {
		var n;
		(n = e._zod.bag).multipleOf ?? (n.multipleOf = t.value);
	}), e._zod.check = (n) => {
		if (typeof n.value != typeof t.value) throw Error("Cannot mix number and bigint in multiple_of check.");
		(typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : ve(n.value, t.value) === 0) || n.issues.push({
			origin: typeof n.value,
			code: "not_multiple_of",
			divisor: t.value,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Jt = /*@__PURE__*/ U("$ZodCheckNumberFormat", (e, t) => {
	Ut.init(e, t), t.format = t.format || "float64";
	let n = t.format?.includes("int"), r = n ? "int" : "number", [i, a] = Ne[t.format];
	e._zod.onattach.push((e) => {
		let r = e._zod.bag;
		r.format = t.format, r.minimum = i, r.maximum = a, n && (r.pattern = zt);
	}), e._zod.check = (o) => {
		let s = o.value;
		if (n) {
			if (!Number.isInteger(s)) {
				o.issues.push({
					expected: r,
					format: t.format,
					code: "invalid_type",
					continue: !1,
					input: s,
					inst: e
				});
				return;
			}
			if (!Number.isSafeInteger(s)) {
				s > 0 ? o.issues.push({
					input: s,
					code: "too_big",
					maximum: 2 ** 53 - 1,
					note: "Integers must be within the safe integer range.",
					inst: e,
					origin: r,
					inclusive: !0,
					continue: !t.abort
				}) : o.issues.push({
					input: s,
					code: "too_small",
					minimum: -(2 ** 53 - 1),
					note: "Integers must be within the safe integer range.",
					inst: e,
					origin: r,
					inclusive: !0,
					continue: !t.abort
				});
				return;
			}
		}
		s < i && o.issues.push({
			origin: "number",
			input: s,
			code: "too_small",
			minimum: i,
			inclusive: !0,
			inst: e,
			continue: !t.abort
		}), s > a && o.issues.push({
			origin: "number",
			input: s,
			code: "too_big",
			maximum: a,
			inclusive: !0,
			inst: e,
			continue: !t.abort
		});
	};
}), Yt = /*@__PURE__*/ U("$ZodCheckMaxLength", (e, t) => {
	var n;
	Ut.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !_e(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag.maximum ?? Infinity;
		t.maximum < n && (e._zod.bag.maximum = t.maximum);
	}), e._zod.check = (n) => {
		let r = n.value;
		if (r.length <= t.maximum) return;
		let i = Ke(r);
		n.issues.push({
			origin: i,
			code: "too_big",
			maximum: t.maximum,
			inclusive: !0,
			input: r,
			inst: e,
			continue: !t.abort
		});
	};
}), Xt = /*@__PURE__*/ U("$ZodCheckMinLength", (e, t) => {
	var n;
	Ut.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !_e(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag.minimum ?? -Infinity;
		t.minimum > n && (e._zod.bag.minimum = t.minimum);
	}), e._zod.check = (n) => {
		let r = n.value;
		if (r.length >= t.minimum) return;
		let i = Ke(r);
		n.issues.push({
			origin: i,
			code: "too_small",
			minimum: t.minimum,
			inclusive: !0,
			input: r,
			inst: e,
			continue: !t.abort
		});
	};
}), Zt = /*@__PURE__*/ U("$ZodCheckLengthEquals", (e, t) => {
	var n;
	Ut.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !_e(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag;
		n.minimum = t.length, n.maximum = t.length, n.length = t.length;
	}), e._zod.check = (n) => {
		let r = n.value, i = r.length;
		if (i === t.length) return;
		let a = Ke(r), o = i > t.length;
		n.issues.push({
			origin: a,
			...o ? {
				code: "too_big",
				maximum: t.length
			} : {
				code: "too_small",
				minimum: t.length
			},
			inclusive: !0,
			exact: !0,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Qt = /*@__PURE__*/ U("$ZodCheckStringFormat", (e, t) => {
	var n, r;
	Ut.init(e, t), e._zod.onattach.push((e) => {
		let n = e._zod.bag;
		n.format = t.format, t.pattern && (n.patterns ??= /* @__PURE__ */ new Set(), n.patterns.add(t.pattern));
	}), t.pattern ? (n = e._zod).check ?? (n.check = (n) => {
		t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: t.format,
			input: n.value,
			...t.pattern ? { pattern: t.pattern.toString() } : {},
			inst: e,
			continue: !t.abort
		});
	}) : (r = e._zod).check ?? (r.check = () => {});
}), $t = /*@__PURE__*/ U("$ZodCheckRegex", (e, t) => {
	Qt.init(e, t), e._zod.check = (n) => {
		t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "regex",
			input: n.value,
			pattern: t.pattern.toString(),
			inst: e,
			continue: !t.abort
		});
	};
}), en = /*@__PURE__*/ U("$ZodCheckLowerCase", (e, t) => {
	t.pattern ??= Vt, Qt.init(e, t);
}), tn = /*@__PURE__*/ U("$ZodCheckUpperCase", (e, t) => {
	t.pattern ??= Ht, Qt.init(e, t);
}), nn = /*@__PURE__*/ U("$ZodCheckIncludes", (e, t) => {
	Ut.init(e, t);
	let n = Ae(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
	t.pattern = r, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(r);
	}), e._zod.check = (n) => {
		n.value.includes(t.includes, t.position) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "includes",
			includes: t.includes,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), rn = /*@__PURE__*/ U("$ZodCheckStartsWith", (e, t) => {
	Ut.init(e, t);
	let n = RegExp(`^${Ae(t.prefix)}.*`);
	t.pattern ??= n, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(n);
	}), e._zod.check = (n) => {
		n.value.startsWith(t.prefix) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "starts_with",
			prefix: t.prefix,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), an = /*@__PURE__*/ U("$ZodCheckEndsWith", (e, t) => {
	Ut.init(e, t);
	let n = RegExp(`.*${Ae(t.suffix)}$`);
	t.pattern ??= n, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(n);
	}), e._zod.check = (n) => {
		n.value.endsWith(t.suffix) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "ends_with",
			suffix: t.suffix,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), on = /*@__PURE__*/ U("$ZodCheckOverwrite", (e, t) => {
	Ut.init(e, t), e._zod.check = (e) => {
		e.value = t.tx(e.value);
	};
}), sn = class {
	constructor(e = []) {
		this.content = [], this.indent = 0, this && (this.args = e);
	}
	indented(e) {
		this.indent += 1, e(this), --this.indent;
	}
	write(e) {
		if (typeof e == "function") {
			e(this, { execution: "sync" }), e(this, { execution: "async" });
			return;
		}
		let t = e.split("\n").filter((e) => e), n = Math.min(...t.map((e) => e.length - e.trimStart().length)), r = t.map((e) => e.slice(n)).map((e) => " ".repeat(this.indent * 2) + e);
		for (let e of r) this.content.push(e);
	}
	compile() {
		let e = Function, t = this?.args, n = [...(this?.content ?? [""]).map((e) => `  ${e}`)];
		return new e(...t, n.join("\n"));
	}
}, cn = {
	major: 4,
	minor: 4,
	patch: 3
}, ln = /*@__PURE__*/ U("$ZodType", (e, t) => {
	var n;
	e ??= {}, e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = cn;
	let r = [...e._zod.def.checks ?? []];
	e._zod.traits.has("$ZodCheck") && r.unshift(e);
	for (let t of r) for (let n of t._zod.onattach) n(e);
	if (r.length === 0) (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
		e._zod.run = e._zod.parse;
	});
	else {
		let t = (e, t, n) => {
			let r = Ve(e), i;
			for (let a of t) {
				if (a._zod.def.when) {
					if (He(e) || !a._zod.def.when(e)) continue;
				} else if (r) continue;
				let t = e.issues.length, o = a._zod.check(e);
				if (o instanceof Promise && n?.async === !1) throw new ue();
				if (i || o instanceof Promise) i = (i ?? Promise.resolve()).then(async () => {
					await o, e.issues.length !== t && (r ||= Ve(e, t));
				});
				else {
					if (e.issues.length === t) continue;
					r ||= Ve(e, t);
				}
			}
			return i ? i.then(() => e) : e;
		}, n = (n, i, a) => {
			if (Ve(n)) return n.aborted = !0, n;
			let o = t(i, r, a);
			if (o instanceof Promise) {
				if (a.async === !1) throw new ue();
				return o.then((t) => e._zod.parse(t, a));
			}
			return e._zod.parse(o, a);
		};
		e._zod.run = (i, a) => {
			if (a.skipChecks) return e._zod.parse(i, a);
			if (a.direction === "backward") {
				let t = e._zod.parse({
					value: i.value,
					issues: []
				}, {
					...a,
					skipChecks: !0
				});
				return t instanceof Promise ? t.then((e) => n(e, i, a)) : n(t, i, a);
			}
			let o = e._zod.parse(i, a);
			if (o instanceof Promise) {
				if (a.async === !1) throw new ue();
				return o.then((e) => t(e, r, a));
			}
			return t(o, r, a);
		};
	}
	G(e, "~standard", () => ({
		validate: (t) => {
			try {
				let n = nt(e, t);
				return n.success ? { value: n.data } : { issues: n.error?.issues };
			} catch {
				return it(e, t).then((e) => e.success ? { value: e.data } : { issues: e.error?.issues });
			}
		},
		vendor: "zod",
		version: 1
	}));
}), un = /*@__PURE__*/ U("$ZodString", (e, t) => {
	ln.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? Rt(e._zod.bag), e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = String(n.value);
		} catch {}
		return typeof n.value == "string" || n.issues.push({
			expected: "string",
			code: "invalid_type",
			input: n.value,
			inst: e
		}), n;
	};
}), q = /*@__PURE__*/ U("$ZodStringFormat", (e, t) => {
	Qt.init(e, t), un.init(e, t);
}), dn = /*@__PURE__*/ U("$ZodGUID", (e, t) => {
	t.pattern ??= bt, q.init(e, t);
}), fn = /*@__PURE__*/ U("$ZodUUID", (e, t) => {
	if (t.version) {
		let e = {
			v1: 1,
			v2: 2,
			v3: 3,
			v4: 4,
			v5: 5,
			v6: 6,
			v7: 7,
			v8: 8
		}[t.version];
		if (e === void 0) throw Error(`Invalid UUID version: "${t.version}"`);
		t.pattern ??= xt(e);
	} else t.pattern ??= xt();
	q.init(e, t);
}), pn = /*@__PURE__*/ U("$ZodEmail", (e, t) => {
	t.pattern ??= St, q.init(e, t);
}), mn = /*@__PURE__*/ U("$ZodURL", (e, t) => {
	q.init(e, t), e._zod.check = (n) => {
		try {
			let r = n.value.trim();
			if (!t.normalize && t.protocol?.source === jt.source && !/^https?:\/\//i.test(r)) {
				n.issues.push({
					code: "invalid_format",
					format: "url",
					note: "Invalid URL format",
					input: n.value,
					inst: e,
					continue: !t.abort
				});
				return;
			}
			let i = new URL(r);
			t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
				code: "invalid_format",
				format: "url",
				note: "Invalid hostname",
				pattern: t.hostname.source,
				input: n.value,
				inst: e,
				continue: !t.abort
			})), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
				code: "invalid_format",
				format: "url",
				note: "Invalid protocol",
				pattern: t.protocol.source,
				input: n.value,
				inst: e,
				continue: !t.abort
			})), n.value = t.normalize ? i.href : r;
			return;
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "url",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
}), hn = /*@__PURE__*/ U("$ZodEmoji", (e, t) => {
	t.pattern ??= wt(), q.init(e, t);
}), gn = /*@__PURE__*/ U("$ZodNanoID", (e, t) => {
	t.pattern ??= vt, q.init(e, t);
}), _n = /*@__PURE__*/ U("$ZodCUID", (e, t) => {
	t.pattern ??= pt, q.init(e, t);
}), vn = /*@__PURE__*/ U("$ZodCUID2", (e, t) => {
	t.pattern ??= mt, q.init(e, t);
}), yn = /*@__PURE__*/ U("$ZodULID", (e, t) => {
	t.pattern ??= ht, q.init(e, t);
}), bn = /*@__PURE__*/ U("$ZodXID", (e, t) => {
	t.pattern ??= gt, q.init(e, t);
}), xn = /*@__PURE__*/ U("$ZodKSUID", (e, t) => {
	t.pattern ??= _t, q.init(e, t);
}), Sn = /*@__PURE__*/ U("$ZodISODateTime", (e, t) => {
	t.pattern ??= Lt(t), q.init(e, t);
}), Cn = /*@__PURE__*/ U("$ZodISODate", (e, t) => {
	t.pattern ??= Pt, q.init(e, t);
}), wn = /*@__PURE__*/ U("$ZodISOTime", (e, t) => {
	t.pattern ??= It(t), q.init(e, t);
}), Tn = /*@__PURE__*/ U("$ZodISODuration", (e, t) => {
	t.pattern ??= yt, q.init(e, t);
}), En = /*@__PURE__*/ U("$ZodIPv4", (e, t) => {
	t.pattern ??= Tt, q.init(e, t), e._zod.bag.format = "ipv4";
}), Dn = /*@__PURE__*/ U("$ZodIPv6", (e, t) => {
	t.pattern ??= Et, q.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
		try {
			new URL(`http://[${n.value}]`);
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "ipv6",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
}), On = /*@__PURE__*/ U("$ZodCIDRv4", (e, t) => {
	t.pattern ??= Dt, q.init(e, t);
}), kn = /*@__PURE__*/ U("$ZodCIDRv6", (e, t) => {
	t.pattern ??= Ot, q.init(e, t), e._zod.check = (n) => {
		let r = n.value.split("/");
		try {
			if (r.length !== 2) throw Error();
			let [e, t] = r;
			if (!t) throw Error();
			let n = Number(t);
			if (`${n}` !== t || n < 0 || n > 128) throw Error();
			new URL(`http://[${e}]`);
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "cidrv6",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
});
function An(e) {
	if (e === "") return !0;
	if (/\s/.test(e) || e.length % 4 != 0) return !1;
	try {
		return atob(e), !0;
	} catch {
		return !1;
	}
}
var jn = /*@__PURE__*/ U("$ZodBase64", (e, t) => {
	t.pattern ??= kt, q.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
		An(n.value) || n.issues.push({
			code: "invalid_format",
			format: "base64",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
});
function Mn(e) {
	if (!At.test(e)) return !1;
	let t = e.replace(/[-_]/g, (e) => e === "-" ? "+" : "/");
	return An(t.padEnd(Math.ceil(t.length / 4) * 4, "="));
}
var Nn = /*@__PURE__*/ U("$ZodBase64URL", (e, t) => {
	t.pattern ??= At, q.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
		Mn(n.value) || n.issues.push({
			code: "invalid_format",
			format: "base64url",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Pn = /*@__PURE__*/ U("$ZodE164", (e, t) => {
	t.pattern ??= Mt, q.init(e, t);
});
function Fn(e, t = null) {
	try {
		let n = e.split(".");
		if (n.length !== 3) return !1;
		let [r] = n;
		if (!r) return !1;
		let i = JSON.parse(atob(r));
		return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
	} catch {
		return !1;
	}
}
var In = /*@__PURE__*/ U("$ZodJWT", (e, t) => {
	q.init(e, t), e._zod.check = (n) => {
		Fn(n.value, t.alg) || n.issues.push({
			code: "invalid_format",
			format: "jwt",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Ln = /*@__PURE__*/ U("$ZodNumber", (e, t) => {
	ln.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? Bt, e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = Number(n.value);
		} catch {}
		let i = n.value;
		if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i)) return n;
		let a = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
		return n.issues.push({
			expected: "number",
			code: "invalid_type",
			input: i,
			inst: e,
			...a ? { received: a } : {}
		}), n;
	};
}), Rn = /*@__PURE__*/ U("$ZodNumberFormat", (e, t) => {
	Jt.init(e, t), Ln.init(e, t);
}), zn = /*@__PURE__*/ U("$ZodUnknown", (e, t) => {
	ln.init(e, t), e._zod.parse = (e) => e;
}), Bn = /*@__PURE__*/ U("$ZodNever", (e, t) => {
	ln.init(e, t), e._zod.parse = (t, n) => (t.issues.push({
		expected: "never",
		code: "invalid_type",
		input: t.value,
		inst: e
	}), t);
});
function Vn(e, t, n) {
	e.issues.length && t.issues.push(...Ue(n, e.issues)), t.value[n] = e.value;
}
var Hn = /*@__PURE__*/ U("$ZodArray", (e, t) => {
	ln.init(e, t), e._zod.parse = (n, r) => {
		let i = n.value;
		if (!Array.isArray(i)) return n.issues.push({
			expected: "array",
			code: "invalid_type",
			input: i,
			inst: e
		}), n;
		n.value = Array(i.length);
		let a = [];
		for (let e = 0; e < i.length; e++) {
			let o = i[e], s = t.element._zod.run({
				value: o,
				issues: []
			}, r);
			s instanceof Promise ? a.push(s.then((t) => Vn(t, n, e))) : Vn(s, n, e);
		}
		return a.length ? Promise.all(a).then(() => n) : n;
	};
});
function Un(e, t, n, r, i, a) {
	let o = n in r;
	if (e.issues.length) {
		if (i && a && !o) return;
		t.issues.push(...Ue(n, e.issues));
	}
	if (!o && !i) {
		e.issues.length || t.issues.push({
			code: "invalid_type",
			expected: "nonoptional",
			input: void 0,
			path: [n]
		});
		return;
	}
	e.value === void 0 ? o && (t.value[n] = void 0) : t.value[n] = e.value;
}
function Wn(e) {
	let t = Object.keys(e.shape);
	for (let n of t) if (!e.shape?.[n]?._zod?.traits?.has("$ZodType")) throw Error(`Invalid element at key "${n}": expected a Zod schema`);
	let n = Me(e.shape);
	return {
		...e,
		keys: t,
		keySet: new Set(t),
		numKeys: t.length,
		optionalKeys: new Set(n)
	};
}
function Gn(e, t, n, r, i, a) {
	let o = [], s = i.keySet, c = i.catchall._zod, l = c.def.type, u = c.optin === "optional", d = c.optout === "optional";
	for (let i in t) {
		if (i === "__proto__" || s.has(i)) continue;
		if (l === "never") {
			o.push(i);
			continue;
		}
		let a = c.run({
			value: t[i],
			issues: []
		}, r);
		a instanceof Promise ? e.push(a.then((e) => Un(e, n, i, t, u, d))) : Un(a, n, i, t, u, d);
	}
	return o.length && n.issues.push({
		code: "unrecognized_keys",
		keys: o,
		input: t,
		inst: a
	}), e.length ? Promise.all(e).then(() => n) : n;
}
var Kn = /*@__PURE__*/ U("$ZodObject", (e, t) => {
	if (ln.init(e, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
		let e = t.shape;
		Object.defineProperty(t, "shape", { get: () => {
			let n = { ...e };
			return Object.defineProperty(t, "shape", { value: n }), n;
		} });
	}
	let n = ge(() => Wn(t));
	G(e._zod, "propValues", () => {
		let e = t.shape, n = {};
		for (let t in e) {
			let r = e[t]._zod;
			if (r.values) {
				n[t] ?? (n[t] = /* @__PURE__ */ new Set());
				for (let e of r.values) n[t].add(e);
			}
		}
		return n;
	});
	let r = Te, i = t.catchall, a;
	e._zod.parse = (t, o) => {
		a ??= n.value;
		let s = t.value;
		if (!r(s)) return t.issues.push({
			expected: "object",
			code: "invalid_type",
			input: s,
			inst: e
		}), t;
		t.value = {};
		let c = [], l = a.shape;
		for (let e of a.keys) {
			let n = l[e], r = n._zod.optin === "optional", i = n._zod.optout === "optional", a = n._zod.run({
				value: s[e],
				issues: []
			}, o);
			a instanceof Promise ? c.push(a.then((n) => Un(n, t, e, s, r, i))) : Un(a, t, e, s, r, i);
		}
		return i ? Gn(c, s, t, o, n.value, e) : c.length ? Promise.all(c).then(() => t) : t;
	};
}), qn = /*@__PURE__*/ U("$ZodObjectJIT", (e, t) => {
	Kn.init(e, t);
	let n = e._zod.parse, r = ge(() => Wn(t)), i = (e) => {
		let t = new sn([
			"shape",
			"payload",
			"ctx"
		]), n = r.value, i = (e) => {
			let t = Se(e);
			return `shape[${t}]._zod.run({ value: input[${t}], issues: [] }, ctx)`;
		};
		t.write("const input = payload.value;");
		let a = Object.create(null), o = 0;
		for (let e of n.keys) a[e] = `key_${o++}`;
		t.write("const newResult = {};");
		for (let r of n.keys) {
			let n = a[r], o = Se(r), s = e[r], c = s?._zod?.optin === "optional", l = s?._zod?.optout === "optional";
			t.write(`const ${n} = ${i(r)};`), c && l ? t.write(`
        if (${n}.issues.length) {
          if (${o} in input) {
            payload.issues = payload.issues.concat(${n}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${o}, ...iss.path] : [${o}]
            })));
          }
        }
        
        if (${n}.value === undefined) {
          if (${o} in input) {
            newResult[${o}] = undefined;
          }
        } else {
          newResult[${o}] = ${n}.value;
        }
        
      `) : c ? t.write(`
        if (${n}.issues.length) {
          payload.issues = payload.issues.concat(${n}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${o}, ...iss.path] : [${o}]
          })));
        }
        
        if (${n}.value === undefined) {
          if (${o} in input) {
            newResult[${o}] = undefined;
          }
        } else {
          newResult[${o}] = ${n}.value;
        }
        
      `) : t.write(`
        const ${n}_present = ${o} in input;
        if (${n}.issues.length) {
          payload.issues = payload.issues.concat(${n}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${o}, ...iss.path] : [${o}]
          })));
        }
        if (!${n}_present && !${n}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${o}]
          });
        }

        if (${n}_present) {
          if (${n}.value === undefined) {
            newResult[${o}] = undefined;
          } else {
            newResult[${o}] = ${n}.value;
          }
        }

      `);
		}
		t.write("payload.value = newResult;"), t.write("return payload;");
		let s = t.compile();
		return (t, n) => s(e, t, n);
	}, a, o = Te, s = !fe.jitless, c = s && Ee.value, l = t.catchall, u;
	e._zod.parse = (d, f) => {
		u ??= r.value;
		let p = d.value;
		return o(p) ? s && c && f?.async === !1 && f.jitless !== !0 ? (a ||= i(t.shape), d = a(d, f), l ? Gn([], p, d, f, u, e) : d) : n(d, f) : (d.issues.push({
			expected: "object",
			code: "invalid_type",
			input: p,
			inst: e
		}), d);
	};
});
function Jn(e, t, n, r) {
	for (let n of e) if (n.issues.length === 0) return t.value = n.value, t;
	let i = e.filter((e) => !Ve(e));
	return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
		code: "invalid_union",
		input: t.value,
		inst: n,
		errors: e.map((e) => e.issues.map((e) => Ge(e, r, pe())))
	}), t);
}
var Yn = /*@__PURE__*/ U("$ZodUnion", (e, t) => {
	ln.init(e, t), G(e._zod, "optin", () => t.options.some((e) => e._zod.optin === "optional") ? "optional" : void 0), G(e._zod, "optout", () => t.options.some((e) => e._zod.optout === "optional") ? "optional" : void 0), G(e._zod, "values", () => {
		if (t.options.every((e) => e._zod.values)) return new Set(t.options.flatMap((e) => Array.from(e._zod.values)));
	}), G(e._zod, "pattern", () => {
		if (t.options.every((e) => e._zod.pattern)) {
			let e = t.options.map((e) => e._zod.pattern);
			return RegExp(`^(${e.map((e) => W(e.source)).join("|")})$`);
		}
	});
	let n = t.options.length === 1 ? t.options[0]._zod.run : null;
	e._zod.parse = (r, i) => {
		if (n) return n(r, i);
		let a = !1, o = [];
		for (let e of t.options) {
			let t = e._zod.run({
				value: r.value,
				issues: []
			}, i);
			if (t instanceof Promise) o.push(t), a = !0;
			else {
				if (t.issues.length === 0) return t;
				o.push(t);
			}
		}
		return a ? Promise.all(o).then((t) => Jn(t, r, e, i)) : Jn(o, r, e, i);
	};
}), Xn = /*@__PURE__*/ U("$ZodIntersection", (e, t) => {
	ln.init(e, t), e._zod.parse = (e, n) => {
		let r = e.value, i = t.left._zod.run({
			value: r,
			issues: []
		}, n), a = t.right._zod.run({
			value: r,
			issues: []
		}, n);
		return i instanceof Promise || a instanceof Promise ? Promise.all([i, a]).then(([t, n]) => Qn(e, t, n)) : Qn(e, i, a);
	};
});
function Zn(e, t) {
	if (e === t || e instanceof Date && t instanceof Date && +e == +t) return {
		valid: !0,
		data: e
	};
	if (De(e) && De(t)) {
		let n = Object.keys(t), r = Object.keys(e).filter((e) => n.indexOf(e) !== -1), i = {
			...e,
			...t
		};
		for (let n of r) {
			let r = Zn(e[n], t[n]);
			if (!r.valid) return {
				valid: !1,
				mergeErrorPath: [n, ...r.mergeErrorPath]
			};
			i[n] = r.data;
		}
		return {
			valid: !0,
			data: i
		};
	}
	if (Array.isArray(e) && Array.isArray(t)) {
		if (e.length !== t.length) return {
			valid: !1,
			mergeErrorPath: []
		};
		let n = [];
		for (let r = 0; r < e.length; r++) {
			let i = e[r], a = t[r], o = Zn(i, a);
			if (!o.valid) return {
				valid: !1,
				mergeErrorPath: [r, ...o.mergeErrorPath]
			};
			n.push(o.data);
		}
		return {
			valid: !0,
			data: n
		};
	}
	return {
		valid: !1,
		mergeErrorPath: []
	};
}
function Qn(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i;
	for (let n of t.issues) if (n.code === "unrecognized_keys") {
		i ??= n;
		for (let e of n.keys) r.has(e) || r.set(e, {}), r.get(e).l = !0;
	} else e.issues.push(n);
	for (let t of n.issues) if (t.code === "unrecognized_keys") for (let e of t.keys) r.has(e) || r.set(e, {}), r.get(e).r = !0;
	else e.issues.push(t);
	let a = [...r].filter(([, e]) => e.l && e.r).map(([e]) => e);
	if (a.length && i && e.issues.push({
		...i,
		keys: a
	}), Ve(e)) return e;
	let o = Zn(t.value, n.value);
	if (!o.valid) throw Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
	return e.value = o.data, e;
}
var $n = /*@__PURE__*/ U("$ZodRecord", (e, t) => {
	ln.init(e, t), e._zod.parse = (n, r) => {
		let i = n.value;
		if (!De(i)) return n.issues.push({
			expected: "record",
			code: "invalid_type",
			input: i,
			inst: e
		}), n;
		let a = [], o = t.keyType._zod.values;
		if (o) {
			n.value = {};
			let s = /* @__PURE__ */ new Set();
			for (let c of o) if (typeof c == "string" || typeof c == "number" || typeof c == "symbol") {
				s.add(typeof c == "number" ? c.toString() : c);
				let o = t.keyType._zod.run({
					value: c,
					issues: []
				}, r);
				if (o instanceof Promise) throw Error("Async schemas not supported in object keys currently");
				if (o.issues.length) {
					n.issues.push({
						code: "invalid_key",
						origin: "record",
						issues: o.issues.map((e) => Ge(e, r, pe())),
						input: c,
						path: [c],
						inst: e
					});
					continue;
				}
				let l = o.value, u = t.valueType._zod.run({
					value: i[c],
					issues: []
				}, r);
				u instanceof Promise ? a.push(u.then((e) => {
					e.issues.length && n.issues.push(...Ue(c, e.issues)), n.value[l] = e.value;
				})) : (u.issues.length && n.issues.push(...Ue(c, u.issues)), n.value[l] = u.value);
			}
			let c;
			for (let e in i) s.has(e) || (c ??= [], c.push(e));
			c && c.length > 0 && n.issues.push({
				code: "unrecognized_keys",
				input: i,
				inst: e,
				keys: c
			});
		} else {
			n.value = {};
			for (let o of Reflect.ownKeys(i)) {
				if (o === "__proto__" || !Object.prototype.propertyIsEnumerable.call(i, o)) continue;
				let s = t.keyType._zod.run({
					value: o,
					issues: []
				}, r);
				if (s instanceof Promise) throw Error("Async schemas not supported in object keys currently");
				if (typeof o == "string" && Bt.test(o) && s.issues.length) {
					let e = t.keyType._zod.run({
						value: Number(o),
						issues: []
					}, r);
					if (e instanceof Promise) throw Error("Async schemas not supported in object keys currently");
					e.issues.length === 0 && (s = e);
				}
				if (s.issues.length) {
					t.mode === "loose" ? n.value[o] = i[o] : n.issues.push({
						code: "invalid_key",
						origin: "record",
						issues: s.issues.map((e) => Ge(e, r, pe())),
						input: o,
						path: [o],
						inst: e
					});
					continue;
				}
				let c = t.valueType._zod.run({
					value: i[o],
					issues: []
				}, r);
				c instanceof Promise ? a.push(c.then((e) => {
					e.issues.length && n.issues.push(...Ue(o, e.issues)), n.value[s.value] = e.value;
				})) : (c.issues.length && n.issues.push(...Ue(o, c.issues)), n.value[s.value] = c.value);
			}
		}
		return a.length ? Promise.all(a).then(() => n) : n;
	};
}), er = /*@__PURE__*/ U("$ZodEnum", (e, t) => {
	ln.init(e, t);
	let n = me(t.entries), r = new Set(n);
	e._zod.values = r, e._zod.pattern = RegExp(`^(${n.filter((e) => ke.has(typeof e)).map((e) => typeof e == "string" ? Ae(e) : e.toString()).join("|")})$`), e._zod.parse = (t, i) => {
		let a = t.value;
		return r.has(a) || t.issues.push({
			code: "invalid_value",
			values: n,
			input: a,
			inst: e
		}), t;
	};
}), tr = /*@__PURE__*/ U("$ZodLiteral", (e, t) => {
	if (ln.init(e, t), t.values.length === 0) throw Error("Cannot create literal schema with no valid values");
	let n = new Set(t.values);
	e._zod.values = n, e._zod.pattern = RegExp(`^(${t.values.map((e) => typeof e == "string" ? Ae(e) : e ? Ae(e.toString()) : String(e)).join("|")})$`), e._zod.parse = (r, i) => {
		let a = r.value;
		return n.has(a) || r.issues.push({
			code: "invalid_value",
			values: t.values,
			input: a,
			inst: e
		}), r;
	};
}), nr = /*@__PURE__*/ U("$ZodTransform", (e, t) => {
	ln.init(e, t), e._zod.optin = "optional", e._zod.parse = (n, r) => {
		if (r.direction === "backward") throw new de(e.constructor.name);
		let i = t.transform(n.value, n);
		if (r.async) return (i instanceof Promise ? i : Promise.resolve(i)).then((e) => (n.value = e, n.fallback = !0, n));
		if (i instanceof Promise) throw new ue();
		return n.value = i, n.fallback = !0, n;
	};
});
function rr(e, t) {
	return t === void 0 && (e.issues.length || e.fallback) ? {
		issues: [],
		value: void 0
	} : e;
}
var ir = /*@__PURE__*/ U("$ZodOptional", (e, t) => {
	ln.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", G(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), G(e._zod, "pattern", () => {
		let e = t.innerType._zod.pattern;
		return e ? RegExp(`^(${W(e.source)})?$`) : void 0;
	}), e._zod.parse = (e, n) => {
		if (t.innerType._zod.optin === "optional") {
			let r = e.value, i = t.innerType._zod.run(e, n);
			return i instanceof Promise ? i.then((e) => rr(e, r)) : rr(i, r);
		}
		return e.value === void 0 ? e : t.innerType._zod.run(e, n);
	};
}), ar = /*@__PURE__*/ U("$ZodExactOptional", (e, t) => {
	ir.init(e, t), G(e._zod, "values", () => t.innerType._zod.values), G(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (e, n) => t.innerType._zod.run(e, n);
}), or = /*@__PURE__*/ U("$ZodNullable", (e, t) => {
	ln.init(e, t), G(e._zod, "optin", () => t.innerType._zod.optin), G(e._zod, "optout", () => t.innerType._zod.optout), G(e._zod, "pattern", () => {
		let e = t.innerType._zod.pattern;
		return e ? RegExp(`^(${W(e.source)}|null)$`) : void 0;
	}), G(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (e, n) => e.value === null ? e : t.innerType._zod.run(e, n);
}), sr = /*@__PURE__*/ U("$ZodDefault", (e, t) => {
	ln.init(e, t), e._zod.optin = "optional", G(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		if (e.value === void 0) return e.value = t.defaultValue, e;
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then((e) => cr(e, t)) : cr(r, t);
	};
});
function cr(e, t) {
	return e.value === void 0 && (e.value = t.defaultValue), e;
}
var lr = /*@__PURE__*/ U("$ZodPrefault", (e, t) => {
	ln.init(e, t), e._zod.optin = "optional", G(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => (n.direction === "backward" || e.value === void 0 && (e.value = t.defaultValue), t.innerType._zod.run(e, n));
}), ur = /*@__PURE__*/ U("$ZodNonOptional", (e, t) => {
	ln.init(e, t), G(e._zod, "values", () => {
		let e = t.innerType._zod.values;
		return e ? new Set([...e].filter((e) => e !== void 0)) : void 0;
	}), e._zod.parse = (n, r) => {
		let i = t.innerType._zod.run(n, r);
		return i instanceof Promise ? i.then((t) => dr(t, e)) : dr(i, e);
	};
});
function dr(e, t) {
	return !e.issues.length && e.value === void 0 && e.issues.push({
		code: "invalid_type",
		expected: "nonoptional",
		input: e.value,
		inst: t
	}), e;
}
var fr = /*@__PURE__*/ U("$ZodCatch", (e, t) => {
	ln.init(e, t), e._zod.optin = "optional", G(e._zod, "optout", () => t.innerType._zod.optout), G(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then((r) => (e.value = r.value, r.issues.length && (e.value = t.catchValue({
			...e,
			error: { issues: r.issues.map((e) => Ge(e, n, pe())) },
			input: e.value
		}), e.issues = [], e.fallback = !0), e)) : (e.value = r.value, r.issues.length && (e.value = t.catchValue({
			...e,
			error: { issues: r.issues.map((e) => Ge(e, n, pe())) },
			input: e.value
		}), e.issues = [], e.fallback = !0), e);
	};
}), pr = /*@__PURE__*/ U("$ZodPipe", (e, t) => {
	ln.init(e, t), G(e._zod, "values", () => t.in._zod.values), G(e._zod, "optin", () => t.in._zod.optin), G(e._zod, "optout", () => t.out._zod.optout), G(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (e, n) => {
		if (n.direction === "backward") {
			let r = t.out._zod.run(e, n);
			return r instanceof Promise ? r.then((e) => mr(e, t.in, n)) : mr(r, t.in, n);
		}
		let r = t.in._zod.run(e, n);
		return r instanceof Promise ? r.then((e) => mr(e, t.out, n)) : mr(r, t.out, n);
	};
});
function mr(e, t, n) {
	return e.issues.length ? (e.aborted = !0, e) : t._zod.run({
		value: e.value,
		issues: e.issues,
		fallback: e.fallback
	}, n);
}
var hr = /*@__PURE__*/ U("$ZodReadonly", (e, t) => {
	ln.init(e, t), G(e._zod, "propValues", () => t.innerType._zod.propValues), G(e._zod, "values", () => t.innerType._zod.values), G(e._zod, "optin", () => t.innerType?._zod?.optin), G(e._zod, "optout", () => t.innerType?._zod?.optout), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then(gr) : gr(r);
	};
});
function gr(e) {
	return e.value = Object.freeze(e.value), e;
}
var _r = /*@__PURE__*/ U("$ZodCustom", (e, t) => {
	Ut.init(e, t), ln.init(e, t), e._zod.parse = (e, t) => e, e._zod.check = (n) => {
		let r = n.value, i = t.fn(r);
		if (i instanceof Promise) return i.then((t) => vr(t, n, r, e));
		vr(i, n, r, e);
	};
});
function vr(e, t, n, r) {
	if (!e) {
		let e = {
			code: "custom",
			input: n,
			inst: r,
			path: [...r._zod.def.path ?? []],
			continue: !r._zod.def.abort
		};
		r._zod.def.params && (e.params = r._zod.def.params), t.issues.push(qe(e));
	}
}
//#endregion
//#region ../../node_modules/zod/v4/core/registries.js
var yr, br = class {
	constructor() {
		this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
	}
	add(e, ...t) {
		let n = t[0];
		return this._map.set(e, n), n && typeof n == "object" && "id" in n && this._idmap.set(n.id, e), this;
	}
	clear() {
		return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
	}
	remove(e) {
		let t = this._map.get(e);
		return t && typeof t == "object" && "id" in t && this._idmap.delete(t.id), this._map.delete(e), this;
	}
	get(e) {
		let t = e._zod.parent;
		if (t) {
			let n = { ...this.get(t) ?? {} };
			delete n.id;
			let r = {
				...n,
				...this._map.get(e)
			};
			return Object.keys(r).length ? r : void 0;
		}
		return this._map.get(e);
	}
	has(e) {
		return this._map.has(e);
	}
};
function xr() {
	return new br();
}
(yr = globalThis).__zod_globalRegistry ?? (yr.__zod_globalRegistry = xr());
var Sr = globalThis.__zod_globalRegistry;
//#endregion
//#region ../../node_modules/zod/v4/core/api.js
// @__NO_SIDE_EFFECTS__
function Cr(e, t) {
	return new e({
		type: "string",
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function wr(e, t) {
	return new e({
		type: "string",
		format: "email",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Tr(e, t) {
	return new e({
		type: "string",
		format: "guid",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Er(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Dr(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v4",
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Or(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v6",
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function kr(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v7",
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Ar(e, t) {
	return new e({
		type: "string",
		format: "url",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function jr(e, t) {
	return new e({
		type: "string",
		format: "emoji",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Mr(e, t) {
	return new e({
		type: "string",
		format: "nanoid",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Nr(e, t) {
	return new e({
		type: "string",
		format: "cuid",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Pr(e, t) {
	return new e({
		type: "string",
		format: "cuid2",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Fr(e, t) {
	return new e({
		type: "string",
		format: "ulid",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Ir(e, t) {
	return new e({
		type: "string",
		format: "xid",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Lr(e, t) {
	return new e({
		type: "string",
		format: "ksuid",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Rr(e, t) {
	return new e({
		type: "string",
		format: "ipv4",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function zr(e, t) {
	return new e({
		type: "string",
		format: "ipv6",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Br(e, t) {
	return new e({
		type: "string",
		format: "cidrv4",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Vr(e, t) {
	return new e({
		type: "string",
		format: "cidrv6",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Hr(e, t) {
	return new e({
		type: "string",
		format: "base64",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Ur(e, t) {
	return new e({
		type: "string",
		format: "base64url",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Wr(e, t) {
	return new e({
		type: "string",
		format: "e164",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Gr(e, t) {
	return new e({
		type: "string",
		format: "jwt",
		check: "string_format",
		abort: !1,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Kr(e, t) {
	return new e({
		type: "string",
		format: "datetime",
		check: "string_format",
		offset: !1,
		local: !1,
		precision: null,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function qr(e, t) {
	return new e({
		type: "string",
		format: "date",
		check: "string_format",
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Jr(e, t) {
	return new e({
		type: "string",
		format: "time",
		check: "string_format",
		precision: null,
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Yr(e, t) {
	return new e({
		type: "string",
		format: "duration",
		check: "string_format",
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Xr(e, t) {
	return new e({
		type: "number",
		checks: [],
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Zr(e, t) {
	return new e({
		type: "number",
		check: "number_format",
		abort: !1,
		format: "safeint",
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Qr(e) {
	return new e({ type: "unknown" });
}
// @__NO_SIDE_EFFECTS__
function $r(e, t) {
	return new e({
		type: "never",
		...K(t)
	});
}
// @__NO_SIDE_EFFECTS__
function ei(e, t) {
	return new Gt({
		check: "less_than",
		...K(t),
		value: e,
		inclusive: !1
	});
}
// @__NO_SIDE_EFFECTS__
function ti(e, t) {
	return new Gt({
		check: "less_than",
		...K(t),
		value: e,
		inclusive: !0
	});
}
// @__NO_SIDE_EFFECTS__
function ni(e, t) {
	return new Kt({
		check: "greater_than",
		...K(t),
		value: e,
		inclusive: !1
	});
}
// @__NO_SIDE_EFFECTS__
function ri(e, t) {
	return new Kt({
		check: "greater_than",
		...K(t),
		value: e,
		inclusive: !0
	});
}
// @__NO_SIDE_EFFECTS__
function ii(e, t) {
	return new qt({
		check: "multiple_of",
		...K(t),
		value: e
	});
}
// @__NO_SIDE_EFFECTS__
function ai(e, t) {
	return new Yt({
		check: "max_length",
		...K(t),
		maximum: e
	});
}
// @__NO_SIDE_EFFECTS__
function oi(e, t) {
	return new Xt({
		check: "min_length",
		...K(t),
		minimum: e
	});
}
// @__NO_SIDE_EFFECTS__
function si(e, t) {
	return new Zt({
		check: "length_equals",
		...K(t),
		length: e
	});
}
// @__NO_SIDE_EFFECTS__
function ci(e, t) {
	return new $t({
		check: "string_format",
		format: "regex",
		...K(t),
		pattern: e
	});
}
// @__NO_SIDE_EFFECTS__
function li(e) {
	return new en({
		check: "string_format",
		format: "lowercase",
		...K(e)
	});
}
// @__NO_SIDE_EFFECTS__
function ui(e) {
	return new tn({
		check: "string_format",
		format: "uppercase",
		...K(e)
	});
}
// @__NO_SIDE_EFFECTS__
function di(e, t) {
	return new nn({
		check: "string_format",
		format: "includes",
		...K(t),
		includes: e
	});
}
// @__NO_SIDE_EFFECTS__
function fi(e, t) {
	return new rn({
		check: "string_format",
		format: "starts_with",
		...K(t),
		prefix: e
	});
}
// @__NO_SIDE_EFFECTS__
function pi(e, t) {
	return new an({
		check: "string_format",
		format: "ends_with",
		...K(t),
		suffix: e
	});
}
// @__NO_SIDE_EFFECTS__
function mi(e) {
	return new on({
		check: "overwrite",
		tx: e
	});
}
// @__NO_SIDE_EFFECTS__
function hi(e) {
	return /* @__PURE__ */ mi((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function gi() {
	return /* @__PURE__ */ mi((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function _i() {
	return /* @__PURE__ */ mi((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function vi() {
	return /* @__PURE__ */ mi((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function yi() {
	return /* @__PURE__ */ mi((e) => Ce(e));
}
// @__NO_SIDE_EFFECTS__
function bi(e, t, n) {
	return new e({
		type: "array",
		element: t,
		...K(n)
	});
}
// @__NO_SIDE_EFFECTS__
function xi(e, t, n) {
	return new e({
		type: "custom",
		check: "custom",
		fn: t,
		...K(n)
	});
}
// @__NO_SIDE_EFFECTS__
function Si(e, t) {
	let n = /* @__PURE__ */ Ci((t) => (t.addIssue = (e) => {
		if (typeof e == "string") t.issues.push(qe(e, t.value, n._zod.def));
		else {
			let r = e;
			r.fatal && (r.continue = !1), r.code ??= "custom", r.input ??= t.value, r.inst ??= n, r.continue ??= !n._zod.def.abort, t.issues.push(qe(r));
		}
	}, e(t.value, t)), t);
	return n;
}
// @__NO_SIDE_EFFECTS__
function Ci(e, t) {
	let n = new Ut({
		check: "custom",
		...K(t)
	});
	return n._zod.check = e, n;
}
//#endregion
//#region ../../node_modules/zod/v4/core/to-json-schema.js
function wi(e) {
	let t = e?.target ?? "draft-2020-12";
	return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
		processors: e.processors ?? {},
		metadataRegistry: e?.metadata ?? Sr,
		target: t,
		unrepresentable: e?.unrepresentable ?? "throw",
		override: e?.override ?? (() => {}),
		io: e?.io ?? "output",
		counter: 0,
		seen: /* @__PURE__ */ new Map(),
		cycles: e?.cycles ?? "ref",
		reused: e?.reused ?? "inline",
		external: e?.external ?? void 0
	};
}
function Ti(e, t, n = {
	path: [],
	schemaPath: []
}) {
	var r;
	let i = e._zod.def, a = t.seen.get(e);
	if (a) return a.count++, n.schemaPath.includes(e) && (a.cycle = n.path), a.schema;
	let o = {
		schema: {},
		count: 1,
		cycle: void 0,
		path: n.path
	};
	t.seen.set(e, o);
	let s = e._zod.toJSONSchema?.();
	if (s) o.schema = s;
	else {
		let r = {
			...n,
			schemaPath: [...n.schemaPath, e],
			path: n.path
		};
		if (e._zod.processJSONSchema) e._zod.processJSONSchema(t, o.schema, r);
		else {
			let n = o.schema, a = t.processors[i.type];
			if (!a) throw Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
			a(e, t, n, r);
		}
		let a = e._zod.parent;
		a && (o.ref ||= a, Ti(a, t, r), t.seen.get(a).isParent = !0);
	}
	let c = t.metadataRegistry.get(e);
	return c && Object.assign(o.schema, c), t.io === "input" && Oi(e) && (delete o.schema.examples, delete o.schema.default), t.io === "input" && "_prefault" in o.schema && ((r = o.schema).default ?? (r.default = o.schema._prefault)), delete o.schema._prefault, t.seen.get(e).schema;
}
function Ei(e, t) {
	let n = e.seen.get(t);
	if (!n) throw Error("Unprocessed schema. This is a bug in Zod.");
	let r = /* @__PURE__ */ new Map();
	for (let t of e.seen.entries()) {
		let n = e.metadataRegistry.get(t[0])?.id;
		if (n) {
			let e = r.get(n);
			if (e && e !== t[0]) throw Error(`Duplicate schema id "${n}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
			r.set(n, t[0]);
		}
	}
	let i = (t) => {
		let r = e.target === "draft-2020-12" ? "$defs" : "definitions";
		if (e.external) {
			let n = e.external.registry.get(t[0])?.id, i = e.external.uri ?? ((e) => e);
			if (n) return { ref: i(n) };
			let a = t[1].defId ?? t[1].schema.id ?? `schema${e.counter++}`;
			return t[1].defId = a, {
				defId: a,
				ref: `${i("__shared")}#/${r}/${a}`
			};
		}
		if (t[1] === n) return { ref: "#" };
		let i = `#/${r}/`, a = t[1].schema.id ?? `__schema${e.counter++}`;
		return {
			defId: a,
			ref: i + a
		};
	}, a = (e) => {
		if (e[1].schema.$ref) return;
		let t = e[1], { ref: n, defId: r } = i(e);
		t.def = { ...t.schema }, r && (t.defId = r);
		let a = t.schema;
		for (let e in a) delete a[e];
		a.$ref = n;
	};
	if (e.cycles === "throw") for (let t of e.seen.entries()) {
		let e = t[1];
		if (e.cycle) throw Error(`Cycle detected: #/${e.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
	}
	for (let n of e.seen.entries()) {
		let r = n[1];
		if (t === n[0]) {
			a(n);
			continue;
		}
		if (e.external) {
			let r = e.external.registry.get(n[0])?.id;
			if (t !== n[0] && r) {
				a(n);
				continue;
			}
		}
		if (e.metadataRegistry.get(n[0])?.id) {
			a(n);
			continue;
		}
		if (r.cycle) {
			a(n);
			continue;
		}
		if (r.count > 1 && e.reused === "ref") {
			a(n);
			continue;
		}
	}
}
function Di(e, t) {
	let n = e.seen.get(t);
	if (!n) throw Error("Unprocessed schema. This is a bug in Zod.");
	let r = (t) => {
		let n = e.seen.get(t);
		if (n.ref === null) return;
		let i = n.def ?? n.schema, a = { ...i }, o = n.ref;
		if (n.ref = null, o) {
			r(o);
			let n = e.seen.get(o), s = n.schema;
			if (s.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (i.allOf = i.allOf ?? [], i.allOf.push(s)) : Object.assign(i, s), Object.assign(i, a), t._zod.parent === o) for (let e in i) e !== "$ref" && e !== "allOf" && (e in a || delete i[e]);
			if (s.$ref && n.def) for (let e in i) e !== "$ref" && e !== "allOf" && e in n.def && JSON.stringify(i[e]) === JSON.stringify(n.def[e]) && delete i[e];
		}
		let s = t._zod.parent;
		if (s && s !== o) {
			r(s);
			let t = e.seen.get(s);
			if (t?.schema.$ref && (i.$ref = t.schema.$ref, t.def)) for (let e in i) e !== "$ref" && e !== "allOf" && e in t.def && JSON.stringify(i[e]) === JSON.stringify(t.def[e]) && delete i[e];
		}
		e.override({
			zodSchema: t,
			jsonSchema: i,
			path: n.path ?? []
		});
	};
	for (let t of [...e.seen.entries()].reverse()) r(t[0]);
	let i = {};
	if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, e.external?.uri) {
		let n = e.external.registry.get(t)?.id;
		if (!n) throw Error("Schema is missing an `id` property");
		i.$id = e.external.uri(n);
	}
	Object.assign(i, n.def ?? n.schema);
	let a = e.metadataRegistry.get(t)?.id;
	a !== void 0 && i.id === a && delete i.id;
	let o = e.external?.defs ?? {};
	for (let t of e.seen.entries()) {
		let e = t[1];
		e.def && e.defId && (e.def.id === e.defId && delete e.def.id, o[e.defId] = e.def);
	}
	e.external || Object.keys(o).length > 0 && (e.target === "draft-2020-12" ? i.$defs = o : i.definitions = o);
	try {
		let n = JSON.parse(JSON.stringify(i));
		return Object.defineProperty(n, "~standard", {
			value: {
				...t["~standard"],
				jsonSchema: {
					input: Ai(t, "input", e.processors),
					output: Ai(t, "output", e.processors)
				}
			},
			enumerable: !1,
			writable: !1
		}), n;
	} catch {
		throw Error("Error converting schema to JSON.");
	}
}
function Oi(e, t) {
	let n = t ?? { seen: /* @__PURE__ */ new Set() };
	if (n.seen.has(e)) return !1;
	n.seen.add(e);
	let r = e._zod.def;
	if (r.type === "transform") return !0;
	if (r.type === "array") return Oi(r.element, n);
	if (r.type === "set") return Oi(r.valueType, n);
	if (r.type === "lazy") return Oi(r.getter(), n);
	if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault") return Oi(r.innerType, n);
	if (r.type === "intersection") return Oi(r.left, n) || Oi(r.right, n);
	if (r.type === "record" || r.type === "map") return Oi(r.keyType, n) || Oi(r.valueType, n);
	if (r.type === "pipe") return e._zod.traits.has("$ZodCodec") ? !0 : Oi(r.in, n) || Oi(r.out, n);
	if (r.type === "object") {
		for (let e in r.shape) if (Oi(r.shape[e], n)) return !0;
		return !1;
	}
	if (r.type === "union") {
		for (let e of r.options) if (Oi(e, n)) return !0;
		return !1;
	}
	if (r.type === "tuple") {
		for (let e of r.items) if (Oi(e, n)) return !0;
		return !!(r.rest && Oi(r.rest, n));
	}
	return !1;
}
var ki = (e, t = {}) => (n) => {
	let r = wi({
		...n,
		processors: t
	});
	return Ti(e, r), Ei(r, e), Di(r, e);
}, Ai = (e, t, n = {}) => (r) => {
	let { libraryOptions: i, target: a } = r ?? {}, o = wi({
		...i ?? {},
		target: a,
		io: t,
		processors: n
	});
	return Ti(e, o), Ei(o, e), Di(o, e);
}, ji = {
	guid: "uuid",
	url: "uri",
	datetime: "date-time",
	json_string: "json-string",
	regex: ""
}, Mi = (e, t, n, r) => {
	let i = n;
	i.type = "string";
	let { minimum: a, maximum: o, format: s, patterns: c, contentEncoding: l } = e._zod.bag;
	if (typeof a == "number" && (i.minLength = a), typeof o == "number" && (i.maxLength = o), s && (i.format = ji[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), l && (i.contentEncoding = l), c && c.size > 0) {
		let e = [...c];
		e.length === 1 ? i.pattern = e[0].source : e.length > 1 && (i.allOf = [...e.map((e) => ({
			...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
			pattern: e.source
		}))]);
	}
}, Ni = (e, t, n, r) => {
	let i = n, { minimum: a, maximum: o, format: s, multipleOf: c, exclusiveMaximum: l, exclusiveMinimum: u } = e._zod.bag;
	i.type = typeof s == "string" && s.includes("int") ? "integer" : "number";
	let d = typeof u == "number" && u >= (a ?? -Infinity), f = typeof l == "number" && l <= (o ?? Infinity), p = t.target === "draft-04" || t.target === "openapi-3.0";
	d ? p ? (i.minimum = u, i.exclusiveMinimum = !0) : i.exclusiveMinimum = u : typeof a == "number" && (i.minimum = a), f ? p ? (i.maximum = l, i.exclusiveMaximum = !0) : i.exclusiveMaximum = l : typeof o == "number" && (i.maximum = o), typeof c == "number" && (i.multipleOf = c);
}, Pi = (e, t, n, r) => {
	n.not = {};
}, Fi = (e, t, n, r) => {
	let i = e._zod.def, a = me(i.entries);
	a.every((e) => typeof e == "number") && (n.type = "number"), a.every((e) => typeof e == "string") && (n.type = "string"), n.enum = a;
}, Ii = (e, t, n, r) => {
	let i = e._zod.def, a = [];
	for (let e of i.values) if (e === void 0) {
		if (t.unrepresentable === "throw") throw Error("Literal `undefined` cannot be represented in JSON Schema");
	} else if (typeof e == "bigint") {
		if (t.unrepresentable === "throw") throw Error("BigInt literals cannot be represented in JSON Schema");
		a.push(Number(e));
	} else a.push(e);
	if (a.length !== 0) {
		if (a.length === 1) {
			let e = a[0];
			n.type = e === null ? "null" : typeof e, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [e] : n.const = e;
		} else a.every((e) => typeof e == "number") && (n.type = "number"), a.every((e) => typeof e == "string") && (n.type = "string"), a.every((e) => typeof e == "boolean") && (n.type = "boolean"), a.every((e) => e === null) && (n.type = "null"), n.enum = a;
	}
}, Li = (e, t, n, r) => {
	if (t.unrepresentable === "throw") throw Error("Custom types cannot be represented in JSON Schema");
}, Ri = (e, t, n, r) => {
	if (t.unrepresentable === "throw") throw Error("Transforms cannot be represented in JSON Schema");
}, zi = (e, t, n, r) => {
	let i = n, a = e._zod.def, { minimum: o, maximum: s } = e._zod.bag;
	typeof o == "number" && (i.minItems = o), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = Ti(a.element, t, {
		...r,
		path: [...r.path, "items"]
	});
}, Bi = (e, t, n, r) => {
	let i = n, a = e._zod.def;
	i.type = "object", i.properties = {};
	let o = a.shape;
	for (let e in o) i.properties[e] = Ti(o[e], t, {
		...r,
		path: [
			...r.path,
			"properties",
			e
		]
	});
	let s = new Set(Object.keys(o)), c = new Set([...s].filter((e) => {
		let n = a.shape[e]._zod;
		return t.io === "input" ? n.optin === void 0 : n.optout === void 0;
	}));
	c.size > 0 && (i.required = Array.from(c)), a.catchall?._zod.def.type === "never" ? i.additionalProperties = !1 : a.catchall ? a.catchall && (i.additionalProperties = Ti(a.catchall, t, {
		...r,
		path: [...r.path, "additionalProperties"]
	})) : t.io === "output" && (i.additionalProperties = !1);
}, Vi = (e, t, n, r) => {
	let i = e._zod.def, a = i.inclusive === !1, o = i.options.map((e, n) => Ti(e, t, {
		...r,
		path: [
			...r.path,
			a ? "oneOf" : "anyOf",
			n
		]
	}));
	a ? n.oneOf = o : n.anyOf = o;
}, Hi = (e, t, n, r) => {
	let i = e._zod.def, a = Ti(i.left, t, {
		...r,
		path: [
			...r.path,
			"allOf",
			0
		]
	}), o = Ti(i.right, t, {
		...r,
		path: [
			...r.path,
			"allOf",
			1
		]
	}), s = (e) => "allOf" in e && Object.keys(e).length === 1;
	n.allOf = [...s(a) ? a.allOf : [a], ...s(o) ? o.allOf : [o]];
}, Ui = (e, t, n, r) => {
	let i = n, a = e._zod.def;
	i.type = "object";
	let o = a.keyType, s = o._zod.bag?.patterns;
	if (a.mode === "loose" && s && s.size > 0) {
		let e = Ti(a.valueType, t, {
			...r,
			path: [
				...r.path,
				"patternProperties",
				"*"
			]
		});
		i.patternProperties = {};
		for (let t of s) i.patternProperties[t.source] = e;
	} else (t.target === "draft-07" || t.target === "draft-2020-12") && (i.propertyNames = Ti(a.keyType, t, {
		...r,
		path: [...r.path, "propertyNames"]
	})), i.additionalProperties = Ti(a.valueType, t, {
		...r,
		path: [...r.path, "additionalProperties"]
	});
	let c = o._zod.values;
	if (c) {
		let e = [...c].filter((e) => typeof e == "string" || typeof e == "number");
		e.length > 0 && (i.required = e);
	}
}, Wi = (e, t, n, r) => {
	let i = e._zod.def, a = Ti(i.innerType, t, r), o = t.seen.get(e);
	t.target === "openapi-3.0" ? (o.ref = i.innerType, n.nullable = !0) : n.anyOf = [a, { type: "null" }];
}, Gi = (e, t, n, r) => {
	let i = e._zod.def;
	Ti(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
}, Ki = (e, t, n, r) => {
	let i = e._zod.def;
	Ti(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType, n.default = JSON.parse(JSON.stringify(i.defaultValue));
}, qi = (e, t, n, r) => {
	let i = e._zod.def;
	Ti(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, Ji = (e, t, n, r) => {
	let i = e._zod.def;
	Ti(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
	let o;
	try {
		o = i.catchValue(void 0);
	} catch {
		throw Error("Dynamic catch values are not supported in JSON Schema");
	}
	n.default = o;
}, Yi = (e, t, n, r) => {
	let i = e._zod.def, a = i.in._zod.traits.has("$ZodTransform"), o = t.io === "input" ? a ? i.out : i.in : i.out;
	Ti(o, t, r);
	let s = t.seen.get(e);
	s.ref = o;
}, Xi = (e, t, n, r) => {
	let i = e._zod.def;
	Ti(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType, n.readOnly = !0;
}, Zi = (e, t, n, r) => {
	let i = e._zod.def;
	Ti(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
}, Qi = /*@__PURE__*/ U("ZodISODateTime", (e, t) => {
	Sn.init(e, t), J.init(e, t);
});
function $i(e) {
	return /* @__PURE__ */ Kr(Qi, e);
}
var ea = /*@__PURE__*/ U("ZodISODate", (e, t) => {
	Cn.init(e, t), J.init(e, t);
});
function ta(e) {
	return /* @__PURE__ */ qr(ea, e);
}
var na = /*@__PURE__*/ U("ZodISOTime", (e, t) => {
	wn.init(e, t), J.init(e, t);
});
function ra(e) {
	return /* @__PURE__ */ Jr(na, e);
}
var ia = /*@__PURE__*/ U("ZodISODuration", (e, t) => {
	Tn.init(e, t), J.init(e, t);
});
function aa(e) {
	return /* @__PURE__ */ Yr(ia, e);
}
var oa = /*@__PURE__*/ U("ZodError", (e, t) => {
	Ye.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
		format: { value: (t) => Qe(e, t) },
		flatten: { value: (t) => Ze(e, t) },
		addIssue: { value: (t) => {
			e.issues.push(t), e.message = JSON.stringify(e.issues, he, 2);
		} },
		addIssues: { value: (t) => {
			e.issues.push(...t), e.message = JSON.stringify(e.issues, he, 2);
		} },
		isEmpty: { get() {
			return e.issues.length === 0;
		} }
	});
}, { Parent: Error }), sa = /* @__PURE__ */ $e(oa), ca = /* @__PURE__ */ et(oa), la = /* @__PURE__ */ tt(oa), ua = /* @__PURE__ */ rt(oa), da = /* @__PURE__ */ at(oa), fa = /* @__PURE__ */ ot(oa), pa = /* @__PURE__ */ st(oa), ma = /* @__PURE__ */ ct(oa), ha = /* @__PURE__ */ lt(oa), ga = /* @__PURE__ */ ut(oa), _a = /* @__PURE__ */ dt(oa), va = /* @__PURE__ */ ft(oa), ya = /* @__PURE__ */ new WeakMap();
function ba(e, t, n) {
	let r = Object.getPrototypeOf(e), i = ya.get(r);
	if (i || (i = /* @__PURE__ */ new Set(), ya.set(r, i)), !i.has(t)) {
		i.add(t);
		for (let e in n) {
			let t = n[e];
			Object.defineProperty(r, e, {
				configurable: !0,
				enumerable: !1,
				get() {
					let n = t.bind(this);
					return Object.defineProperty(this, e, {
						configurable: !0,
						writable: !0,
						enumerable: !0,
						value: n
					}), n;
				},
				set(t) {
					Object.defineProperty(this, e, {
						configurable: !0,
						writable: !0,
						enumerable: !0,
						value: t
					});
				}
			});
		}
	}
}
var xa = /*@__PURE__*/ U("ZodType", (e, t) => (ln.init(e, t), Object.assign(e["~standard"], { jsonSchema: {
	input: Ai(e, "input"),
	output: Ai(e, "output")
} }), e.toJSONSchema = ki(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.parse = (t, n) => sa(e, t, n, { callee: e.parse }), e.safeParse = (t, n) => la(e, t, n), e.parseAsync = async (t, n) => ca(e, t, n, { callee: e.parseAsync }), e.safeParseAsync = async (t, n) => ua(e, t, n), e.spa = e.safeParseAsync, e.encode = (t, n) => da(e, t, n), e.decode = (t, n) => fa(e, t, n), e.encodeAsync = async (t, n) => pa(e, t, n), e.decodeAsync = async (t, n) => ma(e, t, n), e.safeEncode = (t, n) => ha(e, t, n), e.safeDecode = (t, n) => ga(e, t, n), e.safeEncodeAsync = async (t, n) => _a(e, t, n), e.safeDecodeAsync = async (t, n) => va(e, t, n), ba(e, "ZodType", {
	check(...e) {
		let t = this.def;
		return this.clone(xe(t, { checks: [...t.checks ?? [], ...e.map((e) => typeof e == "function" ? { _zod: {
			check: e,
			def: { check: "custom" },
			onattach: []
		} } : e)] }), { parent: !0 });
	},
	with(...e) {
		return this.check(...e);
	},
	clone(e, t) {
		return je(this, e, t);
	},
	brand() {
		return this;
	},
	register(e, t) {
		return e.add(this, t), this;
	},
	refine(e, t) {
		return this.check(Io(e, t));
	},
	superRefine(e, t) {
		return this.check(Lo(e, t));
	},
	overwrite(e) {
		return this.check(/* @__PURE__ */ mi(e));
	},
	optional() {
		return vo(this);
	},
	exactOptional() {
		return bo(this);
	},
	nullable() {
		return So(this);
	},
	nullish() {
		return vo(So(this));
	},
	nonoptional(e) {
		return Oo(this, e);
	},
	array() {
		return eo(this);
	},
	or(e) {
		return ao([this, e]);
	},
	and(e) {
		return so(this, e);
	},
	transform(e) {
		return Mo(this, go(e));
	},
	default(e) {
		return wo(this, e);
	},
	prefault(e) {
		return Eo(this, e);
	},
	catch(e) {
		return Ao(this, e);
	},
	pipe(e) {
		return Mo(this, e);
	},
	readonly() {
		return Po(this);
	},
	describe(e) {
		let t = this.clone();
		return Sr.add(t, { description: e }), t;
	},
	meta(...e) {
		if (e.length === 0) return Sr.get(this);
		let t = this.clone();
		return Sr.add(t, e[0]), t;
	},
	isOptional() {
		return this.safeParse(void 0).success;
	},
	isNullable() {
		return this.safeParse(null).success;
	},
	apply(e) {
		return e(this);
	}
}), Object.defineProperty(e, "description", {
	get() {
		return Sr.get(e)?.description;
	},
	configurable: !0
}), e)), Sa = /*@__PURE__*/ U("_ZodString", (e, t) => {
	un.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Mi(e, t, n, r);
	let n = e._zod.bag;
	e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, ba(e, "_ZodString", {
		regex(...e) {
			return this.check(/* @__PURE__ */ ci(...e));
		},
		includes(...e) {
			return this.check(/* @__PURE__ */ di(...e));
		},
		startsWith(...e) {
			return this.check(/* @__PURE__ */ fi(...e));
		},
		endsWith(...e) {
			return this.check(/* @__PURE__ */ pi(...e));
		},
		min(...e) {
			return this.check(/* @__PURE__ */ oi(...e));
		},
		max(...e) {
			return this.check(/* @__PURE__ */ ai(...e));
		},
		length(...e) {
			return this.check(/* @__PURE__ */ si(...e));
		},
		nonempty(...e) {
			return this.check(/* @__PURE__ */ oi(1, ...e));
		},
		lowercase(e) {
			return this.check(/* @__PURE__ */ li(e));
		},
		uppercase(e) {
			return this.check(/* @__PURE__ */ ui(e));
		},
		trim() {
			return this.check(/* @__PURE__ */ gi());
		},
		normalize(...e) {
			return this.check(/* @__PURE__ */ hi(...e));
		},
		toLowerCase() {
			return this.check(/* @__PURE__ */ _i());
		},
		toUpperCase() {
			return this.check(/* @__PURE__ */ vi());
		},
		slugify() {
			return this.check(/* @__PURE__ */ yi());
		}
	});
}), Ca = /*@__PURE__*/ U("ZodString", (e, t) => {
	un.init(e, t), Sa.init(e, t), e.email = (t) => e.check(/* @__PURE__ */ wr(Ta, t)), e.url = (t) => e.check(/* @__PURE__ */ Ar(Oa, t)), e.jwt = (t) => e.check(/* @__PURE__ */ Gr(Wa, t)), e.emoji = (t) => e.check(/* @__PURE__ */ jr(Aa, t)), e.guid = (t) => e.check(/* @__PURE__ */ Tr(Ea, t)), e.uuid = (t) => e.check(/* @__PURE__ */ Er(Da, t)), e.uuidv4 = (t) => e.check(/* @__PURE__ */ Dr(Da, t)), e.uuidv6 = (t) => e.check(/* @__PURE__ */ Or(Da, t)), e.uuidv7 = (t) => e.check(/* @__PURE__ */ kr(Da, t)), e.nanoid = (t) => e.check(/* @__PURE__ */ Mr(ja, t)), e.guid = (t) => e.check(/* @__PURE__ */ Tr(Ea, t)), e.cuid = (t) => e.check(/* @__PURE__ */ Nr(Ma, t)), e.cuid2 = (t) => e.check(/* @__PURE__ */ Pr(Na, t)), e.ulid = (t) => e.check(/* @__PURE__ */ Fr(Pa, t)), e.base64 = (t) => e.check(/* @__PURE__ */ Hr(Va, t)), e.base64url = (t) => e.check(/* @__PURE__ */ Ur(Ha, t)), e.xid = (t) => e.check(/* @__PURE__ */ Ir(Fa, t)), e.ksuid = (t) => e.check(/* @__PURE__ */ Lr(Ia, t)), e.ipv4 = (t) => e.check(/* @__PURE__ */ Rr(La, t)), e.ipv6 = (t) => e.check(/* @__PURE__ */ zr(Ra, t)), e.cidrv4 = (t) => e.check(/* @__PURE__ */ Br(za, t)), e.cidrv6 = (t) => e.check(/* @__PURE__ */ Vr(Ba, t)), e.e164 = (t) => e.check(/* @__PURE__ */ Wr(Ua, t)), e.datetime = (t) => e.check($i(t)), e.date = (t) => e.check(ta(t)), e.time = (t) => e.check(ra(t)), e.duration = (t) => e.check(aa(t));
});
function wa(e) {
	return /* @__PURE__ */ Cr(Ca, e);
}
var J = /*@__PURE__*/ U("ZodStringFormat", (e, t) => {
	q.init(e, t), Sa.init(e, t);
}), Ta = /*@__PURE__*/ U("ZodEmail", (e, t) => {
	pn.init(e, t), J.init(e, t);
}), Ea = /*@__PURE__*/ U("ZodGUID", (e, t) => {
	dn.init(e, t), J.init(e, t);
}), Da = /*@__PURE__*/ U("ZodUUID", (e, t) => {
	fn.init(e, t), J.init(e, t);
}), Oa = /*@__PURE__*/ U("ZodURL", (e, t) => {
	mn.init(e, t), J.init(e, t);
});
function ka(e) {
	return /* @__PURE__ */ Ar(Oa, e);
}
var Aa = /*@__PURE__*/ U("ZodEmoji", (e, t) => {
	hn.init(e, t), J.init(e, t);
}), ja = /*@__PURE__*/ U("ZodNanoID", (e, t) => {
	gn.init(e, t), J.init(e, t);
}), Ma = /*@__PURE__*/ U("ZodCUID", (e, t) => {
	_n.init(e, t), J.init(e, t);
}), Na = /*@__PURE__*/ U("ZodCUID2", (e, t) => {
	vn.init(e, t), J.init(e, t);
}), Pa = /*@__PURE__*/ U("ZodULID", (e, t) => {
	yn.init(e, t), J.init(e, t);
}), Fa = /*@__PURE__*/ U("ZodXID", (e, t) => {
	bn.init(e, t), J.init(e, t);
}), Ia = /*@__PURE__*/ U("ZodKSUID", (e, t) => {
	xn.init(e, t), J.init(e, t);
}), La = /*@__PURE__*/ U("ZodIPv4", (e, t) => {
	En.init(e, t), J.init(e, t);
}), Ra = /*@__PURE__*/ U("ZodIPv6", (e, t) => {
	Dn.init(e, t), J.init(e, t);
}), za = /*@__PURE__*/ U("ZodCIDRv4", (e, t) => {
	On.init(e, t), J.init(e, t);
}), Ba = /*@__PURE__*/ U("ZodCIDRv6", (e, t) => {
	kn.init(e, t), J.init(e, t);
}), Va = /*@__PURE__*/ U("ZodBase64", (e, t) => {
	jn.init(e, t), J.init(e, t);
}), Ha = /*@__PURE__*/ U("ZodBase64URL", (e, t) => {
	Nn.init(e, t), J.init(e, t);
}), Ua = /*@__PURE__*/ U("ZodE164", (e, t) => {
	Pn.init(e, t), J.init(e, t);
}), Wa = /*@__PURE__*/ U("ZodJWT", (e, t) => {
	In.init(e, t), J.init(e, t);
}), Ga = /*@__PURE__*/ U("ZodNumber", (e, t) => {
	Ln.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ni(e, t, n, r), ba(e, "ZodNumber", {
		gt(e, t) {
			return this.check(/* @__PURE__ */ ni(e, t));
		},
		gte(e, t) {
			return this.check(/* @__PURE__ */ ri(e, t));
		},
		min(e, t) {
			return this.check(/* @__PURE__ */ ri(e, t));
		},
		lt(e, t) {
			return this.check(/* @__PURE__ */ ei(e, t));
		},
		lte(e, t) {
			return this.check(/* @__PURE__ */ ti(e, t));
		},
		max(e, t) {
			return this.check(/* @__PURE__ */ ti(e, t));
		},
		int(e) {
			return this.check(Ja(e));
		},
		safe(e) {
			return this.check(Ja(e));
		},
		positive(e) {
			return this.check(/* @__PURE__ */ ni(0, e));
		},
		nonnegative(e) {
			return this.check(/* @__PURE__ */ ri(0, e));
		},
		negative(e) {
			return this.check(/* @__PURE__ */ ei(0, e));
		},
		nonpositive(e) {
			return this.check(/* @__PURE__ */ ti(0, e));
		},
		multipleOf(e, t) {
			return this.check(/* @__PURE__ */ ii(e, t));
		},
		step(e, t) {
			return this.check(/* @__PURE__ */ ii(e, t));
		},
		finite() {
			return this;
		}
	});
	let n = e._zod.bag;
	e.minValue = Math.max(n.minimum ?? -Infinity, n.exclusiveMinimum ?? -Infinity) ?? null, e.maxValue = Math.min(n.maximum ?? Infinity, n.exclusiveMaximum ?? Infinity) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? .5), e.isFinite = !0, e.format = n.format ?? null;
});
function Ka(e) {
	return /* @__PURE__ */ Xr(Ga, e);
}
var qa = /*@__PURE__*/ U("ZodNumberFormat", (e, t) => {
	Rn.init(e, t), Ga.init(e, t);
});
function Ja(e) {
	return /* @__PURE__ */ Zr(qa, e);
}
var Ya = /*@__PURE__*/ U("ZodUnknown", (e, t) => {
	zn.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (e, t, n) => void 0;
});
function Xa() {
	return /* @__PURE__ */ Qr(Ya);
}
var Za = /*@__PURE__*/ U("ZodNever", (e, t) => {
	Bn.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Pi(e, t, n, r);
});
function Qa(e) {
	return /* @__PURE__ */ $r(Za, e);
}
var $a = /*@__PURE__*/ U("ZodArray", (e, t) => {
	Hn.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => zi(e, t, n, r), e.element = t.element, ba(e, "ZodArray", {
		min(e, t) {
			return this.check(/* @__PURE__ */ oi(e, t));
		},
		nonempty(e) {
			return this.check(/* @__PURE__ */ oi(1, e));
		},
		max(e, t) {
			return this.check(/* @__PURE__ */ ai(e, t));
		},
		length(e, t) {
			return this.check(/* @__PURE__ */ si(e, t));
		},
		unwrap() {
			return this.element;
		}
	});
});
function eo(e, t) {
	return /* @__PURE__ */ bi($a, e, t);
}
var to = /*@__PURE__*/ U("ZodObject", (e, t) => {
	qn.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Bi(e, t, n, r), G(e, "shape", () => t.shape), ba(e, "ZodObject", {
		keyof() {
			return fo(Object.keys(this._zod.def.shape));
		},
		catchall(e) {
			return this.clone({
				...this._zod.def,
				catchall: e
			});
		},
		passthrough() {
			return this.clone({
				...this._zod.def,
				catchall: Xa()
			});
		},
		loose() {
			return this.clone({
				...this._zod.def,
				catchall: Xa()
			});
		},
		strict() {
			return this.clone({
				...this._zod.def,
				catchall: Qa()
			});
		},
		strip() {
			return this.clone({
				...this._zod.def,
				catchall: void 0
			});
		},
		extend(e) {
			return Ie(this, e);
		},
		safeExtend(e) {
			return Le(this, e);
		},
		merge(e) {
			return Re(this, e);
		},
		pick(e) {
			return Pe(this, e);
		},
		omit(e) {
			return Fe(this, e);
		},
		partial(...e) {
			return ze(_o, this, e[0]);
		},
		required(...e) {
			return Be(Do, this, e[0]);
		}
	});
});
function no(e, t) {
	return new to({
		type: "object",
		shape: e ?? {},
		...K(t)
	});
}
function ro(e, t) {
	return new to({
		type: "object",
		shape: e,
		catchall: Qa(),
		...K(t)
	});
}
var io = /*@__PURE__*/ U("ZodUnion", (e, t) => {
	Yn.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Vi(e, t, n, r), e.options = t.options;
});
function ao(e, t) {
	return new io({
		type: "union",
		options: e,
		...K(t)
	});
}
var oo = /*@__PURE__*/ U("ZodIntersection", (e, t) => {
	Xn.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Hi(e, t, n, r);
});
function so(e, t) {
	return new oo({
		type: "intersection",
		left: e,
		right: t
	});
}
var co = /*@__PURE__*/ U("ZodRecord", (e, t) => {
	$n.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ui(e, t, n, r), e.keyType = t.keyType, e.valueType = t.valueType;
});
function lo(e, t, n) {
	let r = je(e);
	return r._zod.values = void 0, new co({
		type: "record",
		keyType: r,
		valueType: t,
		...K(n)
	});
}
var uo = /*@__PURE__*/ U("ZodEnum", (e, t) => {
	er.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Fi(e, t, n, r), e.enum = t.entries, e.options = Object.values(t.entries);
	let n = new Set(Object.keys(t.entries));
	e.extract = (e, r) => {
		let i = {};
		for (let r of e) if (n.has(r)) i[r] = t.entries[r];
		else throw Error(`Key ${r} not found in enum`);
		return new uo({
			...t,
			checks: [],
			...K(r),
			entries: i
		});
	}, e.exclude = (e, r) => {
		let i = { ...t.entries };
		for (let t of e) if (n.has(t)) delete i[t];
		else throw Error(`Key ${t} not found in enum`);
		return new uo({
			...t,
			checks: [],
			...K(r),
			entries: i
		});
	};
});
function fo(e, t) {
	return new uo({
		type: "enum",
		entries: Array.isArray(e) ? Object.fromEntries(e.map((e) => [e, e])) : e,
		...K(t)
	});
}
var po = /*@__PURE__*/ U("ZodLiteral", (e, t) => {
	tr.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ii(e, t, n, r), e.values = new Set(t.values), Object.defineProperty(e, "value", { get() {
		if (t.values.length > 1) throw Error("This schema contains multiple valid literal values. Use `.values` instead.");
		return t.values[0];
	} });
});
function mo(e, t) {
	return new po({
		type: "literal",
		values: Array.isArray(e) ? e : [e],
		...K(t)
	});
}
var ho = /*@__PURE__*/ U("ZodTransform", (e, t) => {
	nr.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ri(e, t, n, r), e._zod.parse = (n, r) => {
		if (r.direction === "backward") throw new de(e.constructor.name);
		n.addIssue = (r) => {
			if (typeof r == "string") n.issues.push(qe(r, n.value, t));
			else {
				let t = r;
				t.fatal && (t.continue = !1), t.code ??= "custom", t.input ??= n.value, t.inst ??= e, n.issues.push(qe(t));
			}
		};
		let i = t.transform(n.value, n);
		return i instanceof Promise ? i.then((e) => (n.value = e, n.fallback = !0, n)) : (n.value = i, n.fallback = !0, n);
	};
});
function go(e) {
	return new ho({
		type: "transform",
		transform: e
	});
}
var _o = /*@__PURE__*/ U("ZodOptional", (e, t) => {
	ir.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Zi(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function vo(e) {
	return new _o({
		type: "optional",
		innerType: e
	});
}
var yo = /*@__PURE__*/ U("ZodExactOptional", (e, t) => {
	ar.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Zi(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function bo(e) {
	return new yo({
		type: "optional",
		innerType: e
	});
}
var xo = /*@__PURE__*/ U("ZodNullable", (e, t) => {
	or.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Wi(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function So(e) {
	return new xo({
		type: "nullable",
		innerType: e
	});
}
var Co = /*@__PURE__*/ U("ZodDefault", (e, t) => {
	sr.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ki(e, t, n, r), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function wo(e, t) {
	return new Co({
		type: "default",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : Oe(t);
		}
	});
}
var To = /*@__PURE__*/ U("ZodPrefault", (e, t) => {
	lr.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => qi(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Eo(e, t) {
	return new To({
		type: "prefault",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : Oe(t);
		}
	});
}
var Do = /*@__PURE__*/ U("ZodNonOptional", (e, t) => {
	ur.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Gi(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Oo(e, t) {
	return new Do({
		type: "nonoptional",
		innerType: e,
		...K(t)
	});
}
var ko = /*@__PURE__*/ U("ZodCatch", (e, t) => {
	fr.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ji(e, t, n, r), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Ao(e, t) {
	return new ko({
		type: "catch",
		innerType: e,
		catchValue: typeof t == "function" ? t : () => t
	});
}
var jo = /*@__PURE__*/ U("ZodPipe", (e, t) => {
	pr.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Yi(e, t, n, r), e.in = t.in, e.out = t.out;
});
function Mo(e, t) {
	return new jo({
		type: "pipe",
		in: e,
		out: t
	});
}
var No = /*@__PURE__*/ U("ZodReadonly", (e, t) => {
	hr.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Xi(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Po(e) {
	return new No({
		type: "readonly",
		innerType: e
	});
}
var Fo = /*@__PURE__*/ U("ZodCustom", (e, t) => {
	_r.init(e, t), xa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Li(e, t, n, r);
});
function Io(e, t = {}) {
	return /* @__PURE__ */ xi(Fo, e, t);
}
function Lo(e, t) {
	return /* @__PURE__ */ Si(e, t);
}
var Ro = fo([
	"opener.spinner.tick",
	"opener.reveal.bad",
	"opener.reveal.rare",
	"opener.reveal.mega",
	"battle.spinner.tick",
	"battle.reveal.bad",
	"battle.reveal.rare",
	"battle.reveal.mega"
]), zo = [
	{
		key: "opener.spinner.tick",
		label: "Reel tick",
		description: "A reel item passes the pointer",
		group: "Box opening"
	},
	{
		key: "opener.reveal.bad",
		label: "Low pull",
		description: "A low-value pull settles",
		group: "Box opening"
	},
	{
		key: "opener.reveal.rare",
		label: "Good pull",
		description: "A good pull settles",
		group: "Box opening"
	},
	{
		key: "opener.reveal.mega",
		label: "Big win",
		description: "A top-tier pull settles",
		group: "Box opening"
	},
	{
		key: "battle.spinner.tick",
		label: "Reel tick",
		description: "A battle reel item passes the pointer",
		group: "Battles",
		fallback: "opener.spinner.tick"
	},
	{
		key: "battle.reveal.bad",
		label: "Low pull",
		description: "A low-value battle pull settles",
		group: "Battles",
		fallback: "opener.reveal.bad"
	},
	{
		key: "battle.reveal.rare",
		label: "Good pull",
		description: "A good battle pull settles",
		group: "Battles",
		fallback: "opener.reveal.rare"
	},
	{
		key: "battle.reveal.mega",
		label: "Big win",
		description: "A top-tier battle pull settles",
		group: "Battles",
		fallback: "opener.reveal.mega"
	}
];
function Bo(e) {
	let { protocol: t, hostname: n } = new URL(e);
	return t === "https:" || t === "http:" && (n === "localhost" || n === "127.0.0.1");
}
lo(Ro, ao([ro({
	url: ka({ protocol: /^https?$/ }).max(2048).refine(Bo, "the sound URL must be https"),
	gainDb: Ka().min(-24).max(6).optional()
}), ro({ off: mo(!0) })])), lo(Ro, ao([no({
	url: wa(),
	gainDb: Ka()
}), no({ off: mo(!0) })]));
function Vo(e) {
	return (Math.min(100, Math.max(0, e)) / 100) ** 2;
}
//#endregion
//#region src/utils/cx.ts
function Y(...e) {
	return e.filter(Boolean).join(" ");
}
//#endregion
//#region src/battle/BattlesIcon.tsx
function Ho({ size: e = 16, className: t }) {
	return /* @__PURE__ */ B("svg", {
		"aria-hidden": "true",
		className: t,
		width: e,
		height: e,
		viewBox: "0 0 40 40",
		fill: "currentColor",
		xmlns: "http://www.w3.org/2000/svg",
		children: /* @__PURE__ */ B("path", { d: "M25.156 2.703c-.083.11-.902 1.18-1.829 2.382-.923 1.197-1.972 2.564-2.334 3.03-.356.466-.757.98-.883 1.14l-.235.297-3.361.008-3.361.013.849.431c.465.236 1.245.632 1.728.88l.875.457-.235.553c-.13.305-.266.61-.296.684-.035.07-.222.513-.418.979s-.588 1.389-.87 2.046c-.284.658-.615 1.441-.74 1.742-.127.3-.275.64-.327.762a45 45 0 0 0-.275.63c-.418.99-1.058 2.504-1.532 3.614-.279.658-.523 1.237-.54 1.28-.013.044-.04.07-.052.061-.013-.013 0-1.119.022-2.455.143-7.532.165-9.495.113-9.548a8 8 0 0 0-.675-.322c-.348-.157-1.102-.492-1.676-.749-2.094-.936-2.386-1.066-2.408-1.066-.026 0 .035 12.782.074 15.412l.026 1.806h7.662l.144-.283c.079-.156.388-.831.693-1.502.635-1.415 1.558-3.46 1.785-3.962.087-.191.23-.509.326-.71.092-.2.166-.37.166-.378s.056-.14.126-.292.187-.413.265-.579c.079-.17.214-.47.305-.674.274-.619 1.602-3.57 1.842-4.093.126-.274.614-1.367.857-1.915.179-.405.388-.867.871-1.938.174-.383.4-.884.5-1.11s.414-.923.697-1.546l.793-1.763c.157-.348.33-.74.392-.87.06-.131.274-.614.479-1.067.204-.457.448-.993.54-1.193.19-.414.186-.396.117-.392-.03 0-.122.092-.2.2M24.32 13.187c-.832.091-1.472.257-1.981.51-.41.208-.958.787-1.206 1.275-.257.505-.296.631-.557 1.828-.122.549-.266 1.206-.327 1.459-.257 1.106-.305 1.754-.161 2.268.213.762.71 1.11 3.644 2.564 2.277 1.124 2.808 1.463 2.808 1.79 0 .178-.344 1.693-.418 1.833-.135.26-.213.274-1.628.274-1.389 0-1.454-.009-1.506-.226-.022-.075.047-.475.191-1.12.122-.548.213-1.01.2-1.023-.008-.012-1.132.2-2.49.475-1.358.27-2.512.505-2.56.514-.1.017-.157.13-.714 1.38-.052.117-.257.579-.457 1.023s-.492 1.097-.653 1.459c-.161.357-.34.761-.4.892-.061.13-.236.514-.384.849-.152.335-.413.923-.587 1.306-.31.692-1.324 2.956-1.49 3.33-.047.11-.165.358-.256.558-.096.2-.17.37-.17.383 0 .009-.07.165-.157.348-.16.331-.17.453-.021.296.047-.043.444-.553.883-1.127a1251 1251 0 0 1 2.295-2.983c.823-1.066 1.75-2.277 2.068-2.686.409-.544.587-.744.635-.723.214.088.823.244 1.198.31.383.065.831.074 3.722.074 2.93 0 3.335-.01 3.744-.079.744-.122 1.171-.244 1.602-.448.67-.322 1.145-.866 1.476-1.694.135-.348.196-.583.557-2.242.083-.37.187-.853.24-1.066.048-.218.1-.619.117-.893.04-.77-.109-1.219-.535-1.61-.462-.427-.989-.715-4.154-2.256-.97-.474-1.462-.77-1.763-1.075-.235-.235-.24-.275-.082-1.002.26-1.236.317-1.375.622-1.458.087-.022.684-.044 1.323-.044 1.29 0 1.437.022 1.494.244.026.105-.083.68-.335 1.755-.048.2-.079.374-.066.387.022.022.24-.022 2.268-.457 1.746-.374 2.473-.536 2.49-.549.014-.017.249-1.031.41-1.793.109-.527.109-1.145-.004-1.507a1.68 1.68 0 0 0-.601-.835c-.361-.244-1.05-.427-1.903-.51-.696-.065-5.781-.048-6.421.022" })
	});
}
var X = {
	root: "_root_1opuf_5",
	grid: "_grid_1opuf_20",
	column: "_column_1opuf_32",
	columnLastInRow: "_columnLastInRow_1opuf_42",
	columnLastRow: "_columnLastRow_1opuf_46",
	columnGrid: "_columnGrid_1opuf_50",
	columnInner: "_columnInner_1opuf_54",
	columnInnerCompact: "_columnInnerCompact_1opuf_70",
	columnInnerGrid: "_columnInnerGrid_1opuf_74",
	columnInnerBare: "_columnInnerBare_1opuf_78",
	header: "_header_1opuf_85",
	headerRight: "_headerRight_1opuf_97",
	headerCompact: "_headerCompact_1opuf_108",
	viewport: "_viewport_1opuf_117",
	viewportVertical: "_viewportVertical_1opuf_127",
	viewportHorizontal: "_viewportHorizontal_1opuf_131",
	viewportAbsoluteTop: "_viewportAbsoluteTop_1opuf_135",
	viewportAbsoluteCenter: "_viewportAbsoluteCenter_1opuf_140",
	fade: "_fade_1opuf_147",
	fadeLeft: "_fadeLeft_1opuf_152",
	fadeRight: "_fadeRight_1opuf_163",
	fadeTop: "_fadeTop_1opuf_174",
	fadeBottom: "_fadeBottom_1opuf_188",
	frame: "_frame_1opuf_204",
	rail: "_rail_1opuf_212",
	railStartHorizontal: "_railStartHorizontal_1opuf_216",
	railStartHorizontalFlipped: "_railStartHorizontalFlipped_1opuf_222",
	railEndHorizontal: "_railEndHorizontal_1opuf_228",
	railEndHorizontalFlipped: "_railEndHorizontalFlipped_1opuf_234",
	railStartVertical: "_railStartVertical_1opuf_240",
	railEndVertical: "_railEndVertical_1opuf_246",
	reelViewport: "_reelViewport_1opuf_254",
	reelClip: "_reelClip_1opuf_261",
	reelClipHorizontal: "_reelClipHorizontal_1opuf_266",
	reel: "_reel_1opuf_254",
	reelVertical: "_reelVertical_1opuf_281",
	slotAnchor: "_slotAnchor_1opuf_285",
	slot: "_slot_1opuf_285",
	slotCard: "_slotCard_1opuf_299",
	slotImageFrame: "_slotImageFrame_1opuf_309",
	slotImage: "_slotImage_1opuf_309",
	slotImageRevealed: "_slotImageRevealed_1opuf_327",
	slotImageMissing: "_slotImageMissing_1opuf_332",
	slotValue: "_slotValue_1opuf_340",
	slotValueCompact: "_slotValueCompact_1opuf_352",
	slotValueCompactTarget: "_slotValueCompactTarget_1opuf_357",
	glow: "_glow_1opuf_362",
	glowSmall: "_glowSmall_1opuf_371",
	glowVertical: "_glowVertical_1opuf_375",
	emptyReel: "_emptyReel_1opuf_381",
	emptyReelVertical: "_emptyReelVertical_1opuf_391",
	emptyCard: "_emptyCard_1opuf_395",
	emptyIcon: "_emptyIcon_1opuf_406",
	vsChip: "_vsChip_1opuf_412",
	vsChipBox: "_vsChipBox_1opuf_419",
	starting: "_starting_1opuf_433",
	startingLabel: "_startingLabel_1opuf_450",
	startingLuck: "_startingLuck_1opuf_458",
	startingCount: "_startingCount_1opuf_462",
	startingDigit: "_startingDigit_1opuf_471",
	startingGo: "_startingGo_1opuf_481",
	startingSeats: "_startingSeats_1opuf_486",
	results: "_results_1opuf_494",
	resultsSeat: "_resultsSeat_1opuf_500",
	resultsHeader: "_resultsHeader_1opuf_506",
	resultsTotal: "_resultsTotal_1opuf_517",
	resultsCards: "_resultsCards_1opuf_533",
	resultCard: "_resultCard_1opuf_543",
	resultCardImage: "_resultCardImage_1opuf_557",
	resultCardImageMissing: "_resultCardImageMissing_1opuf_565",
	resultCardName: "_resultCardName_1opuf_571",
	resultCardValue: "_resultCardValue_1opuf_584",
	resultPlaceholder: "_resultPlaceholder_1opuf_591",
	resultPlaceholderLabel: "_resultPlaceholderLabel_1opuf_600",
	resultPlaceholderNumber: "_resultPlaceholderNumber_1opuf_606",
	resultsMobile: "_resultsMobile_1opuf_612",
	resultsMobileSeat: "_resultsMobileSeat_1opuf_619",
	resultsMobileHeader: "_resultsMobileHeader_1opuf_626",
	resultsMobileTotal: "_resultsMobileTotal_1opuf_634",
	resultsMobileStrip: "_resultsMobileStrip_1opuf_641",
	laneReel: "_laneReel_1opuf_655",
	laneViewport: "_laneViewport_1opuf_662",
	viewportBareHorizontal: "_viewportBareHorizontal_1opuf_667",
	viewportBareVertical: "_viewportBareVertical_1opuf_668"
}, Uo = .68, Wo = .25, Go = 1, Ko = 1, qo = 107 / 128, Jo = 96 / 128, Yo = .5, Xo = .3, Zo = 68, Qo = 108, $o = 81, es = 52, ts = 44, ns = 70, rs = 51, is = 37, as = 6, os = 22, ss = 79, cs = 126, ls = 42, us = 54, ds = 162, fs = 64, ps = -95, ms = 1, hs = 8, gs = 6, _s = 32, vs = 16, ys = 111, bs = 100, xs = 83, Ss = 81, Cs = 51, ws = 24, Ts = 65 / 80, Es = 60 / 71, Ds = .25, Os = 8, ks = 6;
function As(e, t) {
	let n = [], r = 0;
	for (let i of e) n.push(r), r += i + t;
	return n;
}
function js({ index: e, endingItemIdx: t, isHorizontal: n, itemHeight: r, itemWidth: i }) {
	return n ? i <= 60 ? e === t ? Ss : Cs : e === t ? i : i <= 100 ? xs : Math.abs(e - t) === 1 ? ys : bs : e === t ? ds : e === t - 1 ? us : e === t + 1 ? fs : r;
}
function Ms({ isHorizontal: e, itemWidth: t }) {
	return e ? t <= 60 ? ws : t <= 100 ? vs : _s : ls;
}
function Ns({ index: e, endingItemIdx: t, isHorizontal: n, itemWidth: r }) {
	return n ? e === t && r <= 60 ? -3 : e === t && r >= 120 ? 6 : 0 : e === t ? -28 : e === t - 1 ? ps : e === t + 1 ? ms : 0;
}
function Ps({ offset: e, index: t, endingItemIdx: n, isHorizontal: r, itemHeight: i, itemWidth: a, slotMainSize: o }) {
	return r ? e + o / 2 : e + Ns({
		index: t,
		endingItemIdx: n,
		isHorizontal: r,
		itemWidth: a
	}) + i / 2;
}
function Fs(e) {
	return 68 + e / 2;
}
function Is(e) {
	return Uo + .31999999999999995 * e;
}
function Ls(e) {
	return Wo + .75 * e;
}
function Rs({ distance: e, itemWidth: t }) {
	let n = Bs(t);
	return Vs({
		distance: e,
		nearDistance: n.nearDistance,
		farDistance: n.farDistance,
		centerValue: Go,
		nearValue: n.nearScale,
		farValue: n.farScale,
		baseValue: Uo
	});
}
function zs({ distance: e, itemWidth: t }) {
	let n = Bs(t);
	return Vs({
		distance: e,
		nearDistance: n.nearDistance,
		farDistance: n.farDistance,
		centerValue: Ko,
		nearValue: n.nearOpacity,
		farValue: n.farOpacity,
		baseValue: Wo
	});
}
function Bs(e) {
	let t = e <= 100, n = e <= 60, r = Ms({
		isHorizontal: !0,
		itemWidth: e
	}), i = n ? Cs : t ? xs : ys, a = n ? Cs : t ? xs : bs, o = n ? Ts : e === 71 ? Es : qo, s = n ? Ts : e === 71 ? Es : t ? qo : Jo, c = n ? Ds : Yo, l = n ? Ds : t ? Yo : Xo, u = e / 2 + r + i / 2;
	return {
		nearDistance: u,
		farDistance: u + i / 2 + r + a / 2,
		nearScale: o,
		farScale: s,
		nearOpacity: c,
		farOpacity: l
	};
}
function Vs({ distance: e, nearDistance: t, farDistance: n, centerValue: r, nearValue: i, farValue: a, baseValue: o }) {
	return Hs(e <= t ? {
		progress: e / t,
		from: r,
		to: i
	} : e <= n ? {
		progress: (e - t) / (n - t),
		from: i,
		to: a
	} : {
		progress: Math.min(1, (e - n) / t),
		from: a,
		to: o
	});
}
function Hs({ progress: e, from: t, to: n }) {
	return t + (n - t) * e;
}
function Us({ isHorizontal: e, itemWidth: t }) {
	return e ? t <= 60 ? {
		width: rs,
		height: is
	} : t === 71 ? {
		width: ts,
		height: ns
	} : t <= 100 ? {
		width: $o,
		height: es
	} : {
		width: Zo,
		height: Qo
	} : {
		width: ss,
		height: cs
	};
}
function Ws(e) {
	return e === 71 ? as : e <= 60 ? os : 40;
}
function Gs({ index: e, endingItemIdx: t, isHorizontal: n, itemWidth: r }) {
	return n ? r === 71 ? e === t ? Os : ks : e === t && r <= 60 ? 9 : 4 : e === t ? hs : gs;
}
//#endregion
//#region src/battle/BattleEmptyReel.tsx
var Ks = [
	.12,
	.2,
	.36,
	.58,
	.36,
	.2,
	.12
];
function qs({ orientation: e, item: t }) {
	return /* @__PURE__ */ B("div", {
		"aria-hidden": !0,
		className: Y(X.emptyReel, e === "vertical" && X.emptyReelVertical),
		style: { gap: 12 },
		"data-los-battle-empty-reel": !0,
		children: Ks.map((e, n) => /* @__PURE__ */ B("div", {
			className: X.emptyCard,
			style: {
				height: t.itemHeight,
				width: t.itemWidth,
				opacity: e
			},
			children: /* @__PURE__ */ B(Ho, {
				size: Math.min(52, t.itemWidth - 12),
				className: X.emptyIcon
			})
		}, n))
	});
}
//#endregion
//#region src/spinner/timings.ts
var Js = 300, Ys = 2500, Xs = 1500, Zs = 250, Qs = 150, $s = 3, ec = 35, tc = {
	normal: 1500,
	quick: 1e3
};
//#endregion
//#region src/spinner/wheel.ts
function nc(e, t, n) {
	let r = [];
	for (let i = 0; i < t; i++) {
		let t;
		t = n ? ae(n, 1, d) : Math.round(Math.random() * d);
		let i = e[v(e, t) ?? 0];
		i && r.push(i);
	}
	return r;
}
function rc(e, t, n, r) {
	let a = nc(e.dropTable, t + 5, r).map((t) => ({
		...t,
		rarity: h(t.value, e.priceCents ?? 0),
		chance: i(t.weight ?? 0)
	}));
	return n && a.splice(t, 0, {
		...n,
		rarity: h(n.value, e.priceCents ?? 0),
		chance: a.find((e) => e.itemId === n.itemId)?.chance || i(n.weight ?? 0)
	}), a;
}
//#endregion
//#region src/battle/BattleSpinnerSlot.tsx
var ic = .45, ac = j(function({ item: e, isTarget: t, revealed: n, itemHeight: i, itemWidth: a, isHorizontal: o, slotMainSize: s, slotVisualOffset: c, labelGap: l, itemCenter: u, centerProgressDistance: d, containerCenter: p, reelOffset: m, lockDurationSec: h, isAnimating: g }) {
	let { theme: _, currency: v } = f(), y = t && n, b = re(+!!y), x = (e) => Math.max(0, Math.min(1, 1 - e / d)), C = ie(m, (e) => {
		let n = Math.abs(e + u - p);
		if (o) return `translate3d(0, ${c}px, 0) scale(${Rs({
			distance: n,
			itemWidth: a
		})})`;
		let r = Is(x(n));
		return `translate3d(0, ${t ? c + i / 2 * (1 - r) : c}px, 0) scale(${r})`;
	}), w = ie([m, b], (e) => {
		let n = e[0] ?? 0, r = e[1] ?? 0, i = Math.abs(n + u - p), s = o ? zs({
			distance: i,
			itemWidth: a
		}) : Ls(x(i)), c = Math.min(s, .65);
		return t ? c + (1 - c) * r : c;
	}), T = ie(m, (e) => Math.round(x(Math.abs(e + u - p)) * 10));
	N(() => {
		if (!t) {
			b.set(0);
			return;
		}
		let e = H(b, +!!y, {
			type: "tween",
			duration: Math.min(h, ic),
			ease: "easeOut"
		});
		return () => e.stop();
	}, [
		t,
		b,
		h,
		y
	]);
	let E = a <= 60;
	return /* @__PURE__ */ V(ne.div, {
		className: X.slot,
		"data-los-target": t ? "true" : void 0,
		style: {
			width: o ? s : "100%",
			height: o ? i : s,
			zIndex: y ? 15 : o ? void 0 : T,
			willChange: g ? "transform, opacity" : void 0
		},
		children: [t && !o ? /* @__PURE__ */ B(oc, {
			color: r(_.railHex, e.rarity),
			itemWidth: a,
			lockProgress: b
		}) : null, /* @__PURE__ */ V(ne.div, {
			className: X.slotCard,
			style: {
				width: a,
				gap: l,
				transform: C,
				transformOrigin: o ? "center center" : "center top",
				willChange: g ? "transform" : void 0
			},
			children: [/* @__PURE__ */ B(ne.div, {
				className: X.slotImageFrame,
				style: {
					width: a,
					height: i,
					opacity: w,
					willChange: y || g ? "opacity" : void 0
				},
				children: e.imageUrl ? /* @__PURE__ */ B("img", {
					"data-los-battle-card": !0,
					src: e.imageUrl,
					alt: e.name,
					loading: "eager",
					decoding: "async",
					width: a,
					height: i,
					className: Y(X.slotImage, y && X.slotImageRevealed),
					style: { borderRadius: a < 90 ? 4 : 8 }
				}) : /* @__PURE__ */ B("span", {
					"data-los-battle-card": !0,
					"aria-hidden": !0,
					className: X.slotImageMissing,
					style: { borderRadius: a < 90 ? 4 : 8 }
				})
			}), /* @__PURE__ */ B(ne.div, {
				style: { opacity: w },
				children: /* @__PURE__ */ B("span", {
					className: Y(X.slotValue, E && (t ? X.slotValueCompactTarget : X.slotValueCompact)),
					children: S(e.value, v, { compact: !0 })
				})
			})]
		})]
	});
});
function oc({ color: e, itemWidth: t, lockProgress: n }) {
	let r = ie(n, (e) => e * .8), i = Us({
		isHorizontal: !1,
		itemWidth: t
	});
	return /* @__PURE__ */ B(ne.div, {
		"aria-hidden": !0,
		className: Y(X.glow, X.glowVertical),
		style: {
			backgroundColor: e,
			height: i.height,
			width: i.width,
			opacity: r
		}
	});
}
function sc({ slotOffsets: e, slotMainSizes: t, viewportStart: n, viewportEnd: r, bufferPx: i, bufferStartPx: a = i, bufferEndPx: o = i }) {
	let s = Math.min(e.length, t.length);
	if (s <= 0) return null;
	let c = n - a, l = r + o, u = cc({
		slotOffsets: e,
		slotMainSizes: t,
		slotCount: s,
		startBoundary: c
	}), d = lc({
		slotOffsets: e,
		slotCount: s,
		endBoundary: l
	});
	if (u < 0 || d < 0 || u > d) {
		let n = e[0] ?? 0, r = s - 1, i = (e[r] ?? 0) + (t[r] ?? 0);
		return l < n ? {
			startIndex: 0,
			endIndex: 0
		} : c > i ? {
			startIndex: r,
			endIndex: r
		} : null;
	}
	return {
		startIndex: u,
		endIndex: d
	};
}
function cc({ slotOffsets: e, slotMainSizes: t, slotCount: n, startBoundary: r }) {
	let i = 0, a = n - 1, o = -1;
	for (; i <= a;) {
		let n = Math.floor((i + a) / 2);
		(e[n] ?? 0) + (t[n] ?? 0) < r ? i = n + 1 : (o = n, a = n - 1);
	}
	return o;
}
function lc({ slotOffsets: e, slotCount: t, endBoundary: n }) {
	let r = 0, i = t - 1, a = -1;
	for (; r <= i;) {
		let t = Math.floor((r + i) / 2);
		(e[t] ?? 0) > n ? i = t - 1 : (a = t, r = t + 1);
	}
	return a;
}
function uc({ visibleRange: e, targetIndex: t, slotCount: n, targetOverscanSlots: r = 1 }) {
	if (n <= 0) return [];
	let i = n - 1, a = hc(t - r, t + r, i);
	return gc([e ? hc(e.startIndex, e.endIndex, i) : a, a]);
}
function dc({ visibleRange: e, slotCount: t, stepSlots: n }) {
	if (!e || t <= 0 || n <= 1) return e;
	let r = t - 1;
	return hc(Math.floor(e.startIndex / n) * n, Math.ceil(e.endIndex / n) * n, r);
}
function fc({ targetIndex: e, slotCount: t, overscanSlots: n = 6 }) {
	return t <= 0 ? null : hc(3 - n, e + n, t - 1);
}
function pc(e) {
	let t = [], n = /* @__PURE__ */ new Set();
	for (let r of e) for (let e = r.startIndex; e <= r.endIndex; e += 1) n.has(e) || (n.add(e), t.push(e));
	return t;
}
function mc(e, t) {
	let n = e[0];
	if (n === void 0) return -1;
	if (t <= n) return 0;
	let r = e.length - 1, i = e[r];
	if (i !== void 0 && t >= i) return r;
	let a = 0, o = r;
	for (; a < o;) {
		let n = Math.floor((a + o) / 2);
		(e[n] ?? Infinity) < t ? a = n + 1 : o = n;
	}
	let s = a, c = Math.max(0, s - 1), l = e[c] ?? 0, u = e[s] ?? l;
	return t - l <= u - t ? c : s;
}
function hc(e, t, n) {
	return {
		startIndex: Math.max(0, Math.min(e, n)),
		endIndex: Math.max(0, Math.min(t, n))
	};
}
function gc(e) {
	let t = e.filter((e) => e.startIndex <= e.endIndex).sort((e, t) => e.startIndex - t.startIndex), n = [];
	for (let e of t) {
		let t = n[n.length - 1];
		if (!t || e.startIndex > t.endIndex + 1) {
			n.push({ ...e });
			continue;
		}
		t.endIndex = Math.max(t.endIndex, e.endIndex);
	}
	return n;
}
//#endregion
//#region src/battle/useBattleSpinnerMeasurement.ts
function _c(e, t, n) {
	let [r, i] = R(n);
	return F(() => {
		let n = e.current;
		if (!n) return;
		let r = () => {
			let e = n.getBoundingClientRect(), r = t === "horizontal" ? e.width : e.height;
			r > 0 && i(r);
		};
		if (r(), typeof ResizeObserver > "u") return;
		let a = new ResizeObserver(r);
		return a.observe(n), () => a.disconnect();
	}, [e, t]), r || n;
}
//#endregion
//#region src/battle/BattleSpinner.tsx
var vc = [
	.25,
	.8,
	.5,
	1
], yc = 160;
function bc({ box: e, revealedItem: t, prandGenerator: n, running: i, onRevealComplete: a, laneIndex: o, invertSound: s, orientation: c, containerSizeFallback: l, item: u, revealed: d, spinDelayMs: p, spinMs: m, showMs: h, spinItems: g, staggerMs: _, renderBufferSlots: v, renderBufferEndSlots: y, renderWindowStepSlots: b, glow: x = !0 }) {
	let { sounds: S, theme: C } = f(), w = c === "horizontal", T = L(null), E = L(null), D = _c(T, c, l), { itemHeight: O, itemWidth: k } = u, A = 3 + g, j = (m + o * _) / 1e3, ee = h / 1e3, [P] = R(() => e.dropTable.length ? rc(e, A, t, n) : null), F = P?.length ?? A + 2, te = Ms({
		isHorizontal: w,
		itemWidth: k
	}), z = I(() => Array.from({ length: F }, (e, t) => js({
		index: t,
		endingItemIdx: A,
		isHorizontal: w,
		itemHeight: O,
		itemWidth: k
	})), [
		F,
		A,
		w,
		O,
		k
	]), ae = I(() => As(z, te), [z, te]), oe = I(() => ae.map((e, t) => Ps({
		offset: e,
		index: t,
		endingItemIdx: A,
		isHorizontal: w,
		itemHeight: O,
		itemWidth: k,
		slotMainSize: z[t] ?? O
	})), [
		ae,
		A,
		w,
		O,
		k,
		z
	]), se = w ? D / 2 : 68 + O / 2, ce = se - (oe[A] ?? 0), le = se - (oe[3] ?? ae[3] ?? 0), U = w ? k + te : Fs(O), ue = I(() => {
		let e = F - 1;
		return (ae[e] ?? 0) + (z[e] ?? 0);
	}, [
		F,
		ae,
		z
	]), de = (I(() => z.reduce((e, t) => Math.max(e, t), 0), [z]) || (w ? k : O)) + te, fe = de * v, pe = de * y, me = M((e) => dc({
		visibleRange: sc({
			slotOffsets: ae,
			slotMainSizes: z,
			viewportStart: -e,
			viewportEnd: D - e,
			bufferPx: fe,
			bufferEndPx: pe
		}),
		slotCount: F,
		stepSlots: b
	}), [
		D,
		pe,
		fe,
		b,
		ae,
		z,
		F
	]), [he, ge] = R(() => me(d ? ce : le)), _e = L(he), W = M((e) => {
		let t = me(e), n = _e.current;
		(n?.startIndex !== t?.startIndex || n?.endIndex !== t?.endIndex) && (_e.current = t, ge(t));
	}, [me]), ve = I(() => P ? pc(uc({
		visibleRange: he,
		targetIndex: A,
		slotCount: F
	})).flatMap((e) => {
		let t = P[e];
		return t ? [{
			card: t,
			index: e
		}] : [];
	}) : [], [
		P,
		he,
		A,
		F
	]);
	N(() => {
		if (!P || typeof Image > "u") return;
		let e = fc({
			targetIndex: A,
			slotCount: F
		});
		if (!e) return;
		let t = /* @__PURE__ */ new Set();
		for (let n = e.startIndex; n <= e.endIndex; n += 1) {
			let e = P[n]?.imageUrl;
			!e || t.has(e) || (t.add(e), new Image().src = e);
		}
	}, [
		P,
		A,
		F
	]);
	let [ye, G] = R(!1);
	N(() => {
		if (!P || ye) return;
		let e = !1, t = () => {
			e || G(!0);
		};
		return Cc().then(() => {
			if (e) return;
			let n = E.current;
			if (!n) return t();
			let r = Array.from(n.querySelectorAll("img[data-los-battle-card]"));
			Promise.race([Promise.all(r.map(Sc)).catch(() => void 0), wc(yc)]).then(Cc).then(Cc).then(t);
		}), () => {
			e = !0;
		};
	}, [P, ye]);
	let [be, xe] = R("idle"), Se = L(!1), Ce = L(null), we = L(null);
	N(() => {
		i && (Se.current = !1, Ce.current = performance.now(), we.current &&= (clearTimeout(we.current), null), xe("spinning"));
	}, [i]), N(() => () => {
		we.current && clearTimeout(we.current);
	}, []);
	let Te = re(le), Ee = ie(Te, (e) => w ? `translate3d(${e}px, 0, 0)` : `translate3d(0, ${e}px, 0)`), De = L(0), Oe = L(null), ke = M((e) => {
		if (!P) return;
		let t = Date.now();
		if (t - De.current < 16) return;
		let n = mc(oe, se - e);
		n === Oe.current || n < 0 || n >= P.length || (Oe.current = n, De.current = t, S.playTickSound());
	}, [
		P,
		oe,
		se,
		S
	]), Ae = () => {
		if (Se.current) return;
		Se.current = !0;
		let e = P?.[A]?.rarity ?? 0;
		S.playRaritySound(s ? xc(e) : e), a(e);
	}, je = L(Ae);
	je.current = Ae, N(() => {
		if (be !== "spinning") {
			Te.set(le), W(le);
			return;
		}
		let e = p + m + o * _ - 50, t = H(Te.get(), ce, {
			type: "tween",
			duration: j,
			delay: p / 1e3,
			ease: vc,
			onUpdate: (e) => {
				Te.set(e), W(e), o === 0 && ke(e);
			},
			onComplete: () => {
				if (Se.current) return;
				let t = Ce.current, n = t === null ? e : performance.now() - t;
				if (n < e) {
					we.current = setTimeout(() => je.current(), e - n);
					return;
				}
				je.current();
			}
		});
		return () => t.stop();
	}, [
		be,
		Te,
		le,
		ce,
		j,
		p,
		m,
		_,
		o,
		ke,
		W
	]), N(() => {
		d && W(ce);
	}, [
		d,
		ce,
		W
	]);
	let K = re(+!!d), Me = ie(K, (e) => e * .8);
	if (N(() => {
		let e = H(K, +!!d, {
			type: "tween",
			duration: Math.min(ee, .45),
			ease: "easeOut"
		});
		return () => e.stop();
	}, [
		K,
		ee,
		d
	]), !P) return null;
	let Ne = P[A], Pe = Us({
		isHorizontal: !0,
		itemWidth: k
	});
	return /* @__PURE__ */ V("div", {
		ref: T,
		className: X.reelViewport,
		children: [
			x && w && d && Ne ? /* @__PURE__ */ B(ne.div, {
				"aria-hidden": !0,
				className: Y(X.glow, k <= 80 && X.glowSmall),
				style: {
					backgroundColor: r(C.railHex, Ne.rarity),
					height: Pe.height,
					width: Pe.width,
					top: Ws(k),
					opacity: Me
				}
			}) : null,
			ye ? null : /* @__PURE__ */ B(qs, {
				orientation: c,
				item: u
			}),
			/* @__PURE__ */ B("div", {
				className: Y(X.reelClip, w && X.reelClipHorizontal),
				children: /* @__PURE__ */ B(ne.div, {
					ref: E,
					"data-los-battle-reel": !0,
					"data-los-lane": o,
					className: Y(X.reel, !w && X.reelVertical),
					style: {
						...w ? {
							height: O,
							width: ue
						} : { height: ue },
						transform: Ee,
						willChange: be === "spinning" ? "transform" : void 0,
						opacity: ye ? 1 : .001
					},
					children: ve.map(({ card: e, index: t }) => /* @__PURE__ */ B("div", {
						"data-los-slot-index": t,
						className: X.slotAnchor,
						style: w ? {
							left: ae[t] ?? 0,
							top: 0
						} : {
							left: 0,
							top: ae[t] ?? 0,
							width: "100%"
						},
						children: /* @__PURE__ */ B(ac, {
							item: e,
							isTarget: t === A,
							revealed: t === A && d,
							itemHeight: O,
							itemWidth: k,
							isHorizontal: w,
							slotMainSize: z[t] ?? O,
							slotVisualOffset: Ns({
								index: t,
								endingItemIdx: A,
								isHorizontal: w,
								itemWidth: k
							}),
							labelGap: Gs({
								index: t,
								endingItemIdx: A,
								isHorizontal: w,
								itemWidth: k
							}),
							itemCenter: oe[t] ?? 0,
							centerProgressDistance: U,
							containerCenter: se,
							reelOffset: Te,
							lockDurationSec: ee,
							isAnimating: be === "spinning" || d
						})
					}, `${t}-${e.itemId}`))
				})
			})
		]
	});
}
function xc(e) {
	return e >= 4 ? 0 : e <= 1 ? 4 : e;
}
function Sc(e) {
	return e.complete && e.naturalWidth > 0 ? Promise.resolve() : typeof e.decode == "function" ? e.decode().catch(() => void 0) : new Promise((t) => {
		let n = () => {
			e.removeEventListener("load", n), e.removeEventListener("error", n), t();
		};
		e.addEventListener("load", n, { once: !0 }), e.addEventListener("error", n, { once: !0 });
	});
}
function Cc() {
	return new Promise((e) => {
		if (typeof requestAnimationFrame > "u") {
			setTimeout(e, 0);
			return;
		}
		requestAnimationFrame(() => e());
	});
}
function wc(e) {
	return new Promise((t) => {
		setTimeout(t, e);
	});
}
//#endregion
//#region src/battle/BattleSpinnerChrome.tsx
var Tc = {
	default: {
		left: {
			top: 25,
			bottom: 25,
			width: 18
		},
		right: {
			top: 25,
			bottom: 25,
			width: 18
		}
	},
	"desktop-compact": {
		left: {
			top: 0,
			bottom: 0,
			width: 37
		},
		right: {
			top: 0,
			bottom: 0,
			width: 37
		}
	},
	"mobile-2p": {
		left: {
			top: 0,
			height: 190,
			width: 37
		},
		right: {
			top: 0,
			height: 190,
			width: 37
		}
	},
	"mobile-3p": {
		left: {
			top: 5,
			height: 95,
			width: 12
		},
		right: {
			top: 0,
			height: 100,
			width: 12
		}
	},
	"mobile-grid": {
		left: {
			top: 0,
			height: 137,
			width: 12
		},
		right: {
			top: 0,
			height: 137,
			width: 12
		}
	}
};
function Ec({ orientation: e, variant: t }) {
	if (e === "vertical") return /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B("div", {
		"aria-hidden": !0,
		className: Y(X.fade, X.fadeTop)
	}), /* @__PURE__ */ B("div", {
		"aria-hidden": !0,
		className: Y(X.fade, X.fadeBottom)
	})] });
	let n = Tc[t];
	return /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B("div", {
		"aria-hidden": !0,
		className: Y(X.fade, X.fadeLeft),
		style: n.left
	}), /* @__PURE__ */ B("div", {
		"aria-hidden": !0,
		className: Y(X.fade, X.fadeRight),
		style: n.right
	})] });
}
//#endregion
//#region src/battle/battleRoundContext.ts
var Dc = A(null);
function Oc() {
	let e = ee(Dc);
	if (!e) throw Error("A battle lane needs a BattleRound around it");
	return e;
}
function kc(e) {
	let t = Oc(), n = t.landed.get(e) ?? null;
	return {
		landed: n !== null,
		rarity: n,
		item: t.laneItems[e] ?? null
	};
}
//#endregion
//#region src/battle/BattleLaneViewport.tsx
function Ac({ lane: e, orientation: t, item: n, bare: r = !1, className: i, style: a }) {
	let o = Oc(), { spinner: s } = o.layout, c = t ?? s.orientation, l = n ?? s.item, u = c === "horizontal", d = o.box, f = o.laneItems[e] ?? null, p = d !== null && f !== null && d.dropTable.length > 0, { laneLanded: h } = o, g = M((t) => h(e, t), [h, e]), { timings: _ } = o;
	return /* @__PURE__ */ V("div", {
		className: Y(X.viewport, u ? X.viewportHorizontal : X.viewportVertical, r && (u ? X.viewportBareHorizontal : X.viewportBareVertical), i),
		style: a,
		children: [r ? null : /* @__PURE__ */ B(Ec, {
			orientation: c,
			variant: s.chrome
		}), p ? /* @__PURE__ */ B(bc, {
			box: d,
			revealedItem: f,
			prandGenerator: o.generators[e] ?? m(o.seed, e),
			running: o.running,
			onRevealComplete: g,
			laneIndex: e,
			invertSound: o.invertSound,
			orientation: c,
			containerSizeFallback: u ? 190 : s.viewport.height,
			item: l,
			revealed: o.landed.has(e),
			spinDelayMs: _.spinDelayMs,
			spinMs: _.spinMs,
			showMs: _.showMs,
			spinItems: _.spinItems,
			staggerMs: _.staggerMs,
			renderBufferSlots: s.renderBufferSlots,
			renderBufferEndSlots: s.renderBufferEndSlots,
			renderWindowStepSlots: s.renderWindowStepSlots,
			glow: !r
		}, `${o.roundKey}:${e}`) : /* @__PURE__ */ B(qs, {
			orientation: c,
			item: l
		})]
	});
}
//#endregion
//#region src/battle/BattleLaneReel.tsx
function jc({ lane: e, orientation: t, item: n, framed: r = !1, className: i, style: a }) {
	let { theme: o } = f(), { layout: s } = Oc(), c = (t ?? s.spinner.orientation) === "horizontal";
	return /* @__PURE__ */ B("div", {
		className: Y(X.root, X.laneReel, i),
		style: {
			...o.cssVars,
			...a
		},
		"data-los-battle-lane": e,
		children: /* @__PURE__ */ B(Ac, {
			lane: e,
			orientation: t,
			item: n,
			bare: !r,
			className: X.laneViewport,
			style: c ? { height: s.spinner.viewport.height } : void 0
		})
	});
}
//#endregion
//#region src/battle/BattleOpenerDividers.tsx
function Mc({ layout: e }) {
	return e.playerCount <= 1 || e.dividerMode === "none" ? null : e.dividerMode === "center" ? /* @__PURE__ */ B(Nc, {
		leftPct: 50,
		topPct: 50
	}) : e.dividerMode === "two-column-rows" ? /* @__PURE__ */ B(z, { children: Array.from({ length: e.rows }, (t, n) => /* @__PURE__ */ B(Nc, {
		leftPct: 50,
		topPct: (n + .5) / e.rows * 100
	}, n)) }) : /* @__PURE__ */ B(z, { children: Array.from({ length: e.columns - 1 }, (t, n) => /* @__PURE__ */ B(Nc, {
		leftPct: (n + 1) / e.columns * 100,
		topPct: 50
	}, n)) });
}
function Nc({ leftPct: e, topPct: t }) {
	return /* @__PURE__ */ B("div", {
		"aria-hidden": !0,
		className: X.vsChip,
		style: {
			left: `${e}%`,
			top: `${t}%`
		},
		children: /* @__PURE__ */ B("div", {
			className: X.vsChipBox,
			children: /* @__PURE__ */ B(Ho, { size: 16 })
		})
	});
}
//#endregion
//#region src/react/LootConfigContext.ts
var Pc = A({});
function Fc() {
	return ee(Pc);
}
//#endregion
//#region ../sound/dist/index.js
var Ic = [
	"ui",
	"sfx",
	"music",
	"ambience"
], Lc = [
	"random",
	"shuffle",
	"sequence"
], Rc = (e) => typeof e == "object" && !!e && !Array.isArray(e);
function zc(e, t, n) {
	return Object.keys(e).filter((e) => e !== "__proto__" || (n(`${t}: skipped a "__proto__" key`), !1));
}
function Bc(e, t, n, r, i, a = () => !0) {
	if (!(n in e) || e[n] === void 0) return;
	let o = e[n];
	if (typeof o == "number" && Number.isFinite(o) && a(o)) {
		t[n] = o;
		return;
	}
	i(`${r}.${n}: dropped ${JSON.stringify(o) ?? String(o)}`);
}
var Vc = (e) => e >= 0;
function Hc(e) {
	return !Rc(e) || typeof e.url != "string" || typeof e.type != "string" ? null : {
		url: e.url,
		type: e.type
	};
}
function Uc(e, t, n) {
	if (!Rc(e) || !Array.isArray(e.sources)) return n(`${t}: dropped, not an asset with a list of sources`), null;
	let r = e.sources.map(Hc).filter((e) => e !== null);
	if (r.length < e.sources.length && n(`${t}: dropped a malformed source`), r.length === 0) return n(`${t}: dropped, no usable source`), null;
	let i = { sources: r };
	if (Bc(e, i, "durationMs", t, n, Vc), Bc(e, i, "lufs", t, n), Rc(e.cues)) {
		let r = {};
		for (let i of zc(e.cues, `${t}.cues`, n)) Bc(e.cues, r, i, `${t}.cues`, n, Vc);
		i.cues = r;
	}
	return i;
}
function Wc(e, t, n) {
	if (!Rc(e) || typeof e.asset != "string") return n(`${t}: dropped, no asset name`), null;
	let r = { asset: e.asset };
	return Bc(e, r, "weight", t, n, Vc), Bc(e, r, "gainDb", t, n), Bc(e, r, "startMs", t, n, Vc), Bc(e, r, "endMs", t, n, Vc), r;
}
function Gc(e, t, n) {
	if (!Rc(e) || !Array.isArray(e.variations)) return n(`${t}: dropped, no list of variations`), null;
	let r = { variations: e.variations.map((e, r) => Wc(e, `${t}.variations[${r}]`, n)).filter((e) => e !== null) };
	if (e.select !== void 0 && (Lc.includes(e.select) ? r.select = e.select : n(`${t}.select: dropped ${JSON.stringify(e.select)}`)), e.bus !== void 0 && (Ic.includes(e.bus) ? r.bus = e.bus : n(`${t}.bus: dropped ${JSON.stringify(e.bus)}`)), Bc(e, r, "gainDb", t, n), Bc(e, r, "pitchJitterCents", t, n, Vc), Bc(e, r, "gainJitterDb", t, n, Vc), Bc(e, r, "maxVoices", t, n, (e) => Number.isInteger(e) && e >= 1), Bc(e, r, "cooldownMs", t, n, Vc), Bc(e, r, "delayMs", t, n, Vc), Bc(e, r, "fadeInMs", t, n, Vc), Bc(e, r, "fadeOutMs", t, n, Vc), typeof e.loop == "boolean") r.loop = e.loop;
	else if (e.loop !== void 0) {
		let { startMs: i, endMs: a } = Rc(e.loop) ? e.loop : {};
		typeof i == "number" && typeof a == "number" && Number.isFinite(i) && Number.isFinite(a) && i >= 0 && a > i ? r.loop = {
			startMs: i,
			endMs: a
		} : n(`${t}.loop: dropped ${JSON.stringify(e.loop)}`);
	}
	return r;
}
function Kc(e, t) {
	let n = {
		schema: 1,
		assets: {},
		events: {}
	};
	if (!Rc(e)) return t("manifest: not an object, read as empty"), n;
	if (Rc(e.assets)) for (let r of zc(e.assets, "assets", t)) {
		let i = Uc(e.assets[r], `assets.${r}`, t);
		i && (n.assets[r] = i);
	}
	if (Rc(e.events)) for (let r of zc(e.events, "events", t)) {
		let i = Gc(e.events[r], `events.${r}`, t);
		i && (n.events[r] = i);
	}
	return n;
}
function qc() {
	return {
		last: -1,
		queue: [],
		cursor: 0
	};
}
var Jc = (e) => Math.max(0, e.weight ?? 1);
function Yc(e, t, n) {
	let r = e.map((e, t) => ({
		index: t,
		weight: Jc(e)
	})).filter((e) => e.index !== t && e.weight > 0), i = r.reduce((e, t) => e + t.weight, 0);
	if (i === 0) {
		let n = e[t];
		return n && Jc(n) > 0 ? t : Math.max(0, e.findIndex((e) => Jc(e) > 0));
	}
	let a = n() * i;
	for (let e of r) if (a -= e.weight, a < 0) return e.index;
	return r.at(-1)?.index ?? 0;
}
function Xc(e, t, n) {
	let r = e[t], i = e[n];
	r !== void 0 && i !== void 0 && (e[t] = i, e[n] = r);
}
function Zc(e, t, n) {
	let r = Array.from({ length: e }, (e, t) => t);
	for (let t = e - 1; t > 0; t--) {
		let e = Math.floor(n() * (t + 1));
		Xc(r, t, e);
	}
	return e > 1 && r[0] === t && Xc(r, 0, 1), r;
}
function Qc(e, t, n, r) {
	let i = e.length, a;
	return i <= 1 ? a = 0 : t === "sequence" ? a = (n.last + 1) % i : t === "shuffle" ? ((n.cursor >= n.queue.length || n.queue.length !== i) && (n.queue = Zc(i, n.last, r), n.cursor = 0), a = n.queue[n.cursor++] ?? 0) : a = Yc(e, n.last, r), n.last = a, a;
}
function $c(e, t, n) {
	return e.cooldownMs !== void 0 && t.lastStartMs !== void 0 && n - t.lastStartMs < e.cooldownMs ? { admit: !1 } : e.maxVoices !== void 0 && t.voices.length >= e.maxVoices ? t.voices.length === 0 ? { admit: !1 } : {
		admit: !0,
		steal: t.voices.reduce((e, t) => t.startedMs < e.startedMs ? t : e).id
	} : { admit: !0 };
}
function el(e, t) {
	return Object.hasOwn(e, t) ? e[t] : void 0;
}
function tl(e, t, n) {
	let r = /* @__PURE__ */ new Set(), i = e;
	for (; i && !r.has(i);) {
		r.add(i);
		for (let e of t) {
			let t = el(e.manifest.events, i);
			if (!t) continue;
			let { assets: n } = e.manifest, r = t.variations.filter((e) => el(n, e.asset) != null);
			if (!(t.variations.length > 0 && r.length === 0)) return {
				id: i,
				layer: e.name,
				mapping: {
					...t,
					variations: r
				},
				assets: n
			};
		}
		i = el(n, i)?.fallback;
	}
	return null;
}
function nl(e, t) {
	let n = el(e.assets, t.asset);
	if (!n) throw Error(`Sound asset "${t.asset}" is missing from layer "${e.layer}"`);
	return n;
}
var rl = 150, il = 2e4, al = 3e4, ol = 12, sl = [
	"ui",
	"sfx",
	"music",
	"ambience"
], cl = (e) => 10 ** (e / 20), ll = () => {
	if (typeof window > "u") return null;
	let e = window.AudioContext ?? window.webkitAudioContext;
	return e ? new e({ latencyHint: "interactive" }) : null;
}, ul = async (e) => {
	let t = new AbortController(), n = setTimeout(() => t.abort(), il), r = () => {
		clearTimeout(n), n = setTimeout(() => t.abort(), il);
	};
	try {
		let n = await fetch(e, { signal: t.signal });
		if (!n.ok) throw Error(`Sound ${e} answered ${n.status}`);
		if (!n.body) return await n.arrayBuffer();
		r();
		let i = n.body.getReader(), a = [], o = 0;
		for (;;) {
			let { done: e, value: t } = await i.read();
			if (e) break;
			r(), a.push(t), o += t.byteLength;
		}
		let s = new Uint8Array(o), c = 0;
		for (let e of a) s.set(e, c), c += e.byteLength;
		return s.buffer;
	} finally {
		clearTimeout(n);
	}
}, dl = (e) => Number.isFinite(e) ? Math.min(1, Math.max(0, e)) : null;
function fl(e, t = 0) {
	return /iPad|iPhone|iPod/.test(e) || /Macintosh/.test(e) && t > 1 ? !0 : /Safari/.test(e) && !/Chrome|Chromium|Edg|OPR|Firefox/.test(e);
}
function pl(e) {
	let { catalog: t, createContext: n = ll, fetchAudio: r = ul, nowMs: i = () => performance.now(), random: a = Math.random, onError: o = () => {} } = e, s = e.preferM4a ?? (typeof navigator < "u" && fl(navigator.userAgent, navigator.maxTouchPoints)), c = [], l = null, u = !1, d = null, f = /* @__PURE__ */ new Map(), p = !1, m = 1, h = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Set(), _ = /* @__PURE__ */ new Map(), v = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Map(), b = /* @__PURE__ */ new Map(), x = /* @__PURE__ */ new Set(), S = 1, C = !1, w = !1;
	function T(e, t) {
		try {
			o(e, t);
		} catch {}
	}
	let E = (e) => (t) => T(t, e);
	function D(e, t, n) {
		try {
			return n();
		} catch (n) {
			return T(n, e), t;
		}
	}
	let O = /* @__PURE__ */ new WeakMap();
	function k(e) {
		let t = e.manifest, n = typeof t == "object" && t ? O.get(t) : void 0;
		if (n) return {
			name: e.name,
			manifest: n
		};
		let r = Kc(t, (t) => T(Error(t), `manifest ${e.name}`));
		return typeof t == "object" && t && O.set(t, r), {
			name: e.name,
			manifest: r
		};
	}
	function A() {
		if (l || u) return l;
		try {
			let e = n();
			if (!e) return u = !0, null;
			let t = e.createGain();
			t.gain.value = p ? 0 : m;
			let r = e.createDynamicsCompressor();
			r.threshold.value = -2, r.knee.value = 0, r.ratio.value = 20, r.attack.value = .002, r.release.value = .15, t.connect(r), r.connect(e.destination);
			for (let n of sl) {
				let r = e.createGain();
				r.gain.value = h.get(n) ?? 1, r.connect(t), f.set(n, r);
			}
			return e.addEventListener("statechange", () => {
				if (l?.state === "running") for (let e of [...x]) e();
			}), d = t, l = e, l;
		} catch (e) {
			return T(e, "create"), f.clear(), u = !0, null;
		}
	}
	let j = () => l?.state === "running";
	function M(e, t) {
		let n = e.gain, r = l?.currentTime ?? 0, i = n.value;
		n.cancelScheduledValues(r), n.setValueAtTime(i, r), n.setTargetAtTime(t, r, .03);
	}
	function ee(e) {
		let t = b.get(e);
		return t || (t = {
			pick: qc(),
			lastStartMs: void 0,
			voices: []
		}, b.set(e, t)), t;
	}
	let N = (e) => e.sources[0]?.url ?? "";
	function P(e) {
		if (!s) return e.sources;
		let t = (e) => e.includes("mp4");
		return [...e.sources].sort((e, n) => Number(t(n.type)) - Number(t(e.type)));
	}
	function F(e, t = !1) {
		let n = N(e), a = _.get(n);
		if (a) return a;
		let o = v.get(n);
		if (!t && o !== void 0 && i() - o < al) return Promise.resolve(null);
		let s = (async () => {
			for (let t of P(e)) {
				let e = A();
				if (!e) return null;
				try {
					let i = await r(t.url), a = await e.decodeAudioData(i);
					return y.set(n, a), a;
				} catch (e) {
					T(e, `load ${t.url}`);
				}
			}
			return null;
		})();
		return _.set(n, s), s.then((e) => {
			if (e) {
				v.delete(n);
				return;
			}
			v.set(n, i()), _.get(n) === s && _.delete(n);
		}), s;
	}
	function I(e, t, n, r, o, s, c, u, d) {
		let p = l;
		if (!p) return null;
		let m = p.currentTime, h = d + (u.atMs ?? 0) / 1e3 + (t.delayMs ?? 0) / 1e3, g = 0;
		if (u.align) {
			let e = o.cues?.[u.align.cue] ?? 0;
			h = d + (u.align.atMs - e + (t.delayMs ?? 0)) / 1e3, h < d && (g = d - h, h = d);
		}
		if (h < m) {
			if (!c && m - h > rl / 1e3) return null;
			h = m;
		}
		let _ = p.createBufferSource();
		_.buffer = s, _.playbackRate.value = u.rate ?? 1, t.pitchJitterCents && (_.detune.value = (a() * 2 - 1) * t.pitchJitterCents);
		let v = t.gainJitterDb ? (a() * 2 - 1) * t.gainJitterDb : 0, y = cl(Math.min(ol, (r.gainDb ?? 0) + (t.gainDb ?? 0) + (u.gainDb ?? 0) + v)), b = y * (dl(u.level ?? 1) ?? 1), x = p.createGain();
		try {
			let e = u.fadeInMs ?? t.fadeInMs ?? 0;
			e > 0 ? (x.gain.setValueAtTime(0, h), x.gain.linearRampToValueAtTime(b, h + e / 1e3)) : x.gain.value = b, _.connect(x);
			let i = f.get(n);
			i && x.connect(i);
			let a = ((r.startMs ?? 0) + (u.offsetMs ?? 0)) / 1e3 + g;
			if (c) _.loop = !0, typeof t.loop == "object" && (_.loopStart = t.loop.startMs / 1e3, _.loopEnd = t.loop.endMs / 1e3), _.start(h, a);
			else if (r.endMs !== void 0) {
				let e = (r.endMs - (r.startMs ?? 0) - (u.offsetMs ?? 0)) / 1e3 - g;
				_.start(h, a, Math.max(0, e));
			} else _.start(h, a);
		} catch (e) {
			throw _.disconnect(), x.disconnect(), e;
		}
		let C = {
			id: S++,
			startedMs: i(),
			source: _,
			gain: x,
			baseLevel: y,
			startAt: h
		}, w = ee(e);
		return w.voices.push(C), _.onended = () => {
			w.voices = w.voices.filter((e) => e !== C), _.disconnect(), x.disconnect();
		}, C;
	}
	function L(e, t, n) {
		let r = l;
		if (!r) return;
		let i = r.currentTime;
		try {
			n > 0 ? (t.gain.gain.cancelScheduledValues(i), t.gain.gain.setValueAtTime(t.gain.gain.value, i), t.gain.gain.linearRampToValueAtTime(0, i + n / 1e3), t.source.stop(i + n / 1e3)) : t.source.stop(i);
		} catch (e) {
			T(e, "stop");
			try {
				t.source.stop(i);
			} catch (e) {
				T(e, "stop");
			}
		}
		let a = ee(e);
		a.voices = a.voices.filter((e) => e !== t);
	}
	function R(e, n = {}) {
		let r = { ...n };
		if (!A()) return null;
		let o = tl(e, c, t);
		if (!o || o.mapping.variations.length === 0) return null;
		let { mapping: s } = o, u = el(t, e) ?? el(t, o.id), d = !!(s.loop ?? u?.loop);
		if (g.has(e) || !d && p) return null;
		let f = !d && !j();
		if (f && !C) return null;
		let m = ee(e), h = i(), _ = $c(s, m, h);
		if (!_.admit) return null;
		let v = Qc(s.variations, s.select, m.pick, a), b = s.variations[v];
		if (!b) return null;
		let S = nl(o, b), w = s.bus ?? u?.bus ?? "sfx", T = y.get(N(S));
		if (!T && !d && !f && u?.late === "drop") return F(S), null;
		if (_.steal !== void 0) {
			let t = m.voices.find((e) => e.id === _.steal);
			t && L(e, t, 0);
		}
		m.lastStartMs = h;
		let E = null, O = !1, k = (t, n) => {
			O || E || (E = D(`start ${e}`, null, () => I(e, s, w, b, S, t, d, r, n)));
		}, M = l?.currentTime ?? 0, P = null, R = null, te = {
			stop: ({ fadeMs: t } = {}) => {
				O = !0, R && x.delete(R), E && L(e, E, t ?? s.fadeOutMs ?? 0);
			},
			setRate: (t) => D(`setRate ${e}`, void 0, () => {
				E && (E.source.playbackRate.value = t), r.rate = t;
			}),
			setLevel: (t, n = 0) => D(`setLevel ${e}`, void 0, () => {
				let i = dl(t);
				if (i === null) throw Error(`setLevel ${e}: ${t} is not a level`);
				t = i, r.level = t, !E && t > 0 && P?.();
				let a = l;
				if (!E || !a) return;
				let o = E.gain.gain, s = E.baseLevel * t, c = a.currentTime;
				o.cancelScheduledValues(c), n > 0 ? (o.setValueAtTime(o.value, c), o.linearRampToValueAtTime(s, c + n / 1e3)) : o.value = s;
			}),
			cancelIfNotStarted: () => {
				if (!E) {
					O = !0;
					return;
				}
				l && E.startAt > l.currentTime && L(e, E, 0);
			}
		};
		if (f) {
			let e = () => {
				x.delete(e), !(i() - h > rl) && F(S).then((e) => {
					e && j() && k(e, M);
				});
			};
			return x.add(e), R = e, F(S), te;
		}
		if (T && (j() || !d)) return k(T, M), te;
		if (d) {
			let e = () => {
				let t = y.get(N(S));
				!t || !j() || (x.delete(e), k(t, l?.currentTime ?? 0));
			};
			return x.add(e), R = e, P = () => void F(S, !0).then(e), P(), te;
		}
		return F(S).then((e) => {
			!e || !j() || k(e, M);
		}), te;
	}
	return {
		get state() {
			return u ? "unsupported" : j() ? "running" : "locked";
		},
		setLayers(e) {
			D("setLayers", void 0, () => {
				c = e.map(k);
			});
		},
		play: (e, t) => D(`play ${e}`, null, () => R(e, t)),
		schedule(e, { signal: t } = {}) {
			D("schedule", void 0, () => {
				if (t?.aborted) return;
				let n = e.map((e) => D(`play ${e.id}`, null, () => R(e.id, {
					atMs: e.atMs,
					gainDb: e.gainDb
				}))).filter((e) => e !== null);
				if (!t || n.length === 0) return;
				let r = () => {
					for (let e of n) D("cancel", void 0, e.cancelIfNotStarted);
				};
				t.addEventListener("abort", r, { once: !0 });
				let i = Math.max(0, ...e.map((e) => e.atMs).filter(Number.isFinite));
				setTimeout(() => t.removeEventListener("abort", r), i + rl + 5e3);
			});
		},
		resolve: (e) => D(`resolve ${e}`, null, () => tl(e, c, t)),
		activeVoiceCount(e) {
			return b.get(e)?.voices.length ?? 0;
		},
		sourcesFor: (e) => D(`sourcesFor ${e}`, null, () => {
			let n = tl(e, c, t), r = n?.mapping.variations[0];
			return !n || !r ? null : [...P(nl(n, r))];
		}),
		preload(e) {
			for (let n of e) D(`preload ${n}`, void 0, () => {
				let e = tl(n, c, t);
				if (e) for (let t of e.mapping.variations) F(nl(e, t));
			});
		},
		unlock() {
			D("unlock", void 0, () => {
				let e = A();
				!e || e.state === "running" || (C = !0, e.resume().catch(E("resume")).finally(() => {
					C = !1;
				}));
			});
		},
		setHidden(e) {
			D("setHidden", void 0, () => {
				l && (e ? w = l.state === "running" : w && l.state !== "running" && (w = !1, l.resume().catch(E("resume"))));
			});
		},
		setMuted(e) {
			D("setMuted", void 0, () => {
				p = e, d && M(d, p ? 0 : m);
			});
		},
		setMasterVolume(e) {
			D("setMasterVolume", void 0, () => {
				let t = dl(e);
				if (t === null) throw Error(`setMasterVolume: ${e} is not a volume`);
				m = t, d && !p && M(d, t);
			});
		},
		setBusVolume(e, t) {
			D(`setBusVolume ${e}`, void 0, () => {
				let n = dl(t);
				if (n === null) throw Error(`setBusVolume ${e}: ${t} is not a volume`);
				h.set(e, n);
				let r = f.get(e);
				r && M(r, n);
			});
		},
		setEventMuted(e, t) {
			t ? g.add(e) : g.delete(e);
		},
		debugMaster() {
			return A(), d;
		},
		debugBus(e) {
			return A(), f.get(e);
		}
	};
}
//#endregion
//#region src/sounds/openerSoundEngine.ts
var ml = Object.fromEntries(zo.map((e) => [e.key, {
	description: e.description,
	category: e.group,
	bus: "sfx",
	group: e.key.startsWith("battle.") ? "battle" : "opener",
	...e.fallback ? { fallback: e.fallback } : {},
	...e.key.endsWith(".spinner.tick") ? { late: "drop" } : {}
}])), hl = null, gl = {}, _l = [], vl = {
	muted: !1,
	gain: 1
}, yl = [], bl = /* @__PURE__ */ new Set(), xl = vl;
function Sl() {
	return xl;
}
function Cl(e) {
	return bl.add(e), () => {
		bl.delete(e);
	};
}
function wl() {
	let e = yl.filter((e) => e.level !== null), t = (e.findLast((e) => e.source === "opener") ?? e[e.length - 1])?.level ?? vl, n = t.muted !== xl.muted || t.gain !== xl.gain;
	if (xl = t, hl?.setMuted(t.muted), hl?.setMasterVolume(t.gain), n) for (let e of [...bl]) e();
}
function Tl(e) {
	let t = Number.isFinite(e.volume) ? e.volume : 50;
	return {
		muted: e.muted === !0 || t === 0,
		gain: e.volume === void 0 ? 1 : Vo(t)
	};
}
function El(e) {
	let t = {
		source: e,
		level: null
	};
	return yl.push(t), {
		set: (e) => {
			t.level = e ? Tl(e) : null, wl();
		},
		remove: () => {
			let e = yl.indexOf(t);
			e !== -1 && (yl.splice(e, 1), wl());
		}
	};
}
var Dl = null;
function Ol(e) {
	let t = () => {
		Dl?.(), e.unlock(), e.preload(Object.keys(ml));
	};
	document.addEventListener("pointerdown", t, !0), document.addEventListener("keydown", t, !0), Dl = () => {
		document.removeEventListener("pointerdown", t, !0), document.removeEventListener("keydown", t, !0), Dl = null;
	};
}
function kl() {
	hl?.setLayers([..._l].reverse().map((e, t) => ({
		name: `host-${t}`,
		manifest: e.manifest
	})));
}
function Al() {
	if (hl) return hl;
	let e = pl({
		catalog: ml,
		...gl
	});
	return hl = e, kl(), e.setMuted(xl.muted), e.setMasterVolume(xl.gain), typeof document < "u" && (Ol(e), document.addEventListener("visibilitychange", () => e.setHidden(document.hidden))), e;
}
function jl(e) {
	let t = Symbol("host sounds");
	return _l.push({
		key: t,
		manifest: e
	}), kl(), () => {
		let e = _l.findIndex((e) => e.key === t);
		e !== -1 && (_l.splice(e, 1), kl());
	};
}
//#endregion
//#region src/sounds/useOpenerSounds.ts
var Ml = {
	tick: "tick.mp3",
	badPrize: "bad-prize.mp3",
	rarePrize: "rare-prize.mp3",
	megaPrize: "mega-prize.mp3"
}, Nl = {
	tick: "opener.spinner.tick",
	badPrize: "opener.reveal.bad",
	rarePrize: "opener.reveal.rare",
	megaPrize: "opener.reveal.mega"
};
function Pl(e, t) {
	if (e === !1) return null;
	let n = t?.replace(/\/$/, ""), r = {
		...n ? {
			tick: `${n}/${Ml.tick}`,
			badPrize: `${n}/${Ml.badPrize}`,
			rarePrize: `${n}/${Ml.rarePrize}`,
			megaPrize: `${n}/${Ml.megaPrize}`
		} : {},
		...e
	};
	return Object.values(r).some(Boolean) ? r : null;
}
var Fl = {
	mp3: "audio/mpeg",
	m4a: "audio/mp4",
	mp4: "audio/mp4",
	aac: "audio/aac",
	webm: "audio/webm",
	ogg: "audio/ogg",
	opus: "audio/ogg",
	wav: "audio/wav"
};
function Il(e) {
	return Fl[/\.([a-z0-9]+)(?:[?#]|$)/i.exec(e)?.[1]?.toLowerCase() ?? ""] ?? "";
}
function Ll(e) {
	let t = {
		schema: 1,
		assets: {},
		events: {}
	};
	for (let [n, r] of Object.entries(Nl)) {
		let i = e[n];
		i && (t.assets[n] = { sources: [{
			url: i,
			type: Il(i)
		}] }, t.events[r] = { variations: [{ asset: n }] });
	}
	return t;
}
function Rl(e) {
	let t = {
		schema: 1,
		assets: {},
		events: {}
	};
	for (let [n, r] of Object.entries(e)) {
		if (typeof r == "object" && "off" in r) {
			r.off === !0 && (t.events[n] = { variations: [] });
			continue;
		}
		let e = typeof r == "string" ? r : r?.url;
		if (!e) continue;
		let i = typeof r == "object" ? r.gainDb : void 0;
		t.assets[n] = { sources: [{
			url: e,
			type: Il(e)
		}] }, t.events[n] = {
			variations: [{ asset: n }],
			...typeof i == "number" && Number.isFinite(i) ? { gainDb: Math.min(6, Math.max(-24, i)) } : {}
		};
	}
	return t;
}
function zl(e, t) {
	let n = L(null), r = e !== null, i = e?.muted, a = e?.volume;
	N(() => {
		let e = El(t);
		return n.current = e, () => {
			e.remove(), n.current = null;
		};
	}, [t]), N(() => {
		n.current?.set(r ? {
			muted: i,
			volume: a
		} : null);
	}, [
		r,
		i,
		a,
		t
	]);
}
function Bl(e, t) {
	return t === 2 || t === 3 ? `${e}.reveal.rare` : t >= 4 ? `${e}.reveal.mega` : `${e}.reveal.bad`;
}
function Vl(e) {
	return Object.values(e ?? {}).some((e) => typeof e == "string" || e !== void 0 && "url" in e);
}
function Hl({ sounds: e, soundBaseUrl: t, soundEvents: n, scope: r = "opener" }) {
	let i = Pl(e, t), a = i ? JSON.stringify(i) : null, o = e !== !1 && n && Object.keys(n).length > 0 ? JSON.stringify(n) : null, s = i !== null || o !== null && Vl(n), c = L(s);
	c.current = s;
	let l = L(e === !1);
	l.current = e === !1;
	let u = L(r);
	u.current = r;
	let d = s;
	return N(() => {
		d && Al();
	}, [d]), N(() => {
		let e = [];
		return a && e.push(jl(Ll(JSON.parse(a)))), o && e.push(jl(Rl(JSON.parse(o)))), () => {
			for (let t of e.reverse()) t();
		};
	}, [a, o]), I(() => ({
		get enabled() {
			return !l.current;
		},
		get configured() {
			return c.current;
		},
		get muted() {
			return Sl().muted;
		},
		get gain() {
			return Sl().gain;
		},
		subscribe: Cl,
		playTickSound: () => {
			c.current && Al().play(`${u.current}.spinner.tick`);
		},
		playRaritySound: (e) => {
			c.current && Al().play(Bl(u.current, e));
		},
		unlock: () => {
			if (!c.current) return;
			let e = Al();
			e.unlock();
			let t = u.current;
			e.preload([
				`${t}.spinner.tick`,
				`${t}.reveal.bad`,
				`${t}.reveal.rare`,
				`${t}.reveal.mega`
			]);
		}
	}), []);
}
//#endregion
//#region src/battle/battleLayout.ts
var Ul = 768, Wl = {
	itemWidth: 128,
	itemHeight: 176
}, Gl = {
	itemWidth: 138,
	itemHeight: 190
}, Kl = {
	itemWidth: 81,
	itemHeight: 112
}, ql = {
	itemWidth: 94,
	itemHeight: 130
}, Jl = {
	itemWidth: 58,
	itemHeight: 80
}, Yl = {
	itemWidth: 71,
	itemHeight: 98
}, Xl = { verticalInset: 24 }, Zl = {
	horizontalInset: 56,
	horizontalEndInset: 12
}, Ql = {
	horizontalInset: 12,
	horizontalEndInset: 12
}, $l = {
	compactEdgePointers: !0,
	compactEdgeInset: 42,
	compactEdgeEndInset: 6
}, eu = {
	...$l,
	compactEdgeInset: 6
}, tu = {
	renderBufferSlots: 0,
	renderBufferEndSlots: 2,
	renderWindowStepSlots: 2
}, nu = {
	renderBufferSlots: 2,
	renderBufferEndSlots: 2,
	renderWindowStepSlots: 1
}, ru = {
	width: "100%",
	height: 124,
	position: "absolute-top",
	top: 54
};
function iu(e) {
	return !e || e < 2 ? 2 : e >= 5 ? 6 : e;
}
function au(e) {
	let t = iu(e.playerCount), n = `ffa-${t}`;
	return e.viewport === "mobile" ? su(n, t) : ou(n, t);
}
function ou(e, t) {
	let n = {
		key: e,
		viewport: "desktop",
		playerCount: t,
		gap: 0,
		padding: 0
	};
	switch (e) {
		case "ffa-2": return {
			...n,
			columns: 2,
			rows: 1,
			height: 380,
			dividerMode: "adjacent",
			columnVariant: "default",
			headerAlign: "center",
			showHeaderTotal: !1,
			spinner: {
				orientation: "horizontal",
				viewport: {
					width: 552,
					height: 188,
					position: "flow",
					marginTop: 38
				},
				item: Wl,
				pointers: Zl,
				chrome: "default",
				...tu
			},
			results: { cardsPerRow: 4 }
		};
		case "ffa-3": return {
			...n,
			columns: 3,
			rows: 1,
			height: 440,
			dividerMode: "adjacent",
			columnVariant: "default",
			headerAlign: "center",
			showHeaderTotal: !1,
			spinner: {
				orientation: "vertical",
				viewport: {
					width: 402.67,
					height: 364,
					position: "flow"
				},
				item: Gl,
				pointers: Xl,
				chrome: "default",
				...tu
			},
			results: { cardsPerRow: 3 }
		};
		case "ffa-4": return {
			...n,
			columns: 4,
			rows: 1,
			height: 440,
			dividerMode: "adjacent",
			columnVariant: "default",
			headerAlign: "center",
			showHeaderTotal: !1,
			spinner: {
				orientation: "vertical",
				viewport: {
					width: 293,
					height: 364,
					position: "flow"
				},
				item: Gl,
				pointers: Xl,
				chrome: "default",
				...tu
			},
			results: { cardsPerRow: 2 }
		};
		case "ffa-6": return {
			...n,
			columns: 2,
			rows: 3,
			height: 726,
			dividerMode: "two-column-rows",
			columnVariant: "default",
			headerAlign: "right",
			showHeaderTotal: !1,
			spinner: {
				orientation: "horizontal",
				viewport: {
					width: 449,
					height: 137,
					position: "absolute-center"
				},
				item: Kl,
				pointers: Ql,
				chrome: "desktop-compact",
				...tu
			},
			results: { cardsPerRow: 1 }
		};
	}
}
function su(e, t) {
	let n = {
		key: e,
		viewport: "mobile",
		playerCount: t,
		headerAlign: "compact",
		showHeaderTotal: !0,
		results: { cardsPerRow: 2 }
	};
	switch (e) {
		case "ffa-2": return {
			...n,
			columns: 1,
			rows: 2,
			height: 439,
			gap: 0,
			padding: 0,
			dividerMode: "none",
			columnVariant: "mobile-2p",
			spinner: {
				orientation: "horizontal",
				viewport: {
					width: "100%",
					height: 152,
					position: "flow",
					marginTop: -5,
					marginX: -7
				},
				item: ql,
				pointers: {},
				chrome: "mobile-2p",
				...nu
			}
		};
		case "ffa-3": return {
			...n,
			columns: 1,
			rows: 3,
			height: 440,
			gap: 0,
			padding: 0,
			dividerMode: "none",
			columnVariant: "mobile-3p",
			spinner: {
				orientation: "horizontal",
				viewport: {
					width: 336,
					height: 104,
					position: "flow",
					marginTop: -14
				},
				item: Jl,
				pointers: eu,
				chrome: "mobile-3p",
				...nu
			}
		};
		case "ffa-4": return {
			...n,
			columns: 2,
			rows: 2,
			height: 420,
			gap: 6,
			padding: 6,
			dividerMode: "center",
			columnVariant: "mobile-grid",
			spinner: {
				orientation: "horizontal",
				viewport: ru,
				item: Yl,
				pointers: $l,
				chrome: "mobile-grid",
				...nu
			}
		};
		case "ffa-6": return {
			...n,
			columns: 2,
			rows: 3,
			height: 610,
			gap: 6,
			padding: 6,
			dividerMode: "two-column-rows",
			columnVariant: "mobile-grid",
			spinner: {
				orientation: "horizontal",
				viewport: ru,
				item: Yl,
				pointers: $l,
				chrome: "mobile-grid",
				...nu
			}
		};
	}
}
//#endregion
//#region src/battle/battleTimings.ts
var cu = 3e3, lu = [
	2,
	3,
	4,
	6
], uu = 250, du = 300, fu = {
	spinMs: Ys,
	quickSpinMs: Xs,
	staggerMs: 250,
	quickStaggerMs: 150,
	spinLeadMs: 250 + du,
	showMs: 1e3,
	holdMs: tc.normal,
	quickHoldMs: tc.quick
};
function pu(e) {
	let t = fu, n = e.fastSpin ? t.quickSpinMs : t.spinMs, r = e.fastSpin ? t.quickStaggerMs : t.staggerMs, i = e.fastSpin ? t.quickHoldMs : t.holdMs;
	return t.spinLeadMs + n + r * Math.max(0, e.playerCount - 1) + t.showMs + i;
}
function mu(e) {
	let t = fu, n = e.fastSpin ? t.quickSpinMs : t.spinMs, r = e.fastSpin ? t.quickStaggerMs : t.staggerMs;
	return t.spinLeadMs + n + r * Math.max(0, e.laneCount - 1) + t.showMs;
}
function hu(e) {
	return e.compact ? e.fastSpin ? 10 : 14 : 24;
}
//#endregion
//#region src/battle/BattleRound.tsx
function gu(e) {
	let t = Fc(), n = e.theme ?? t.theme, r = e.currency ?? t.currency ?? C, i = e.locale ?? t.locale, s = I(() => a(i), [i]), l = I(() => c(n), [n]), u = Hl({
		sounds: t.sounds,
		soundBaseUrl: t.soundBaseUrl,
		soundEvents: t.soundEvents,
		scope: "battle"
	}), d = e.sounds ?? u, f = e.quick ?? !1, p = e.compact ?? !1, h = e.laneItems.length, g = I(() => au({
		playerCount: h,
		viewport: p ? "mobile" : "desktop"
	}), [h, p]), _ = I(() => {
		let e = fu;
		return {
			spinDelayMs: 250,
			spinMs: f ? e.quickSpinMs : e.spinMs,
			showMs: e.showMs,
			spinItems: hu({
				fastSpin: f,
				compact: p
			}),
			staggerMs: f ? e.quickStaggerMs : e.staggerMs
		};
	}, [f, p]), v = e.seed, y = e.roundKey ?? v, b = I(() => Array.from({ length: h }, (e, t) => m(v, t)), [
		v,
		h,
		y
	]), [x, S] = R(() => ({
		key: y,
		lanes: /* @__PURE__ */ new Map()
	})), w = I(() => x.key === y ? x.lanes : /* @__PURE__ */ new Map(), [x, y]), T = e.onLaneSettled, E = M((e, t) => {
		S((n) => {
			let r = n.key === y ? n.lanes : /* @__PURE__ */ new Map();
			if (r.has(e)) return n;
			let i = new Map(r);
			return i.set(e, t), {
				key: y,
				lanes: i
			};
		}), T?.(e, t);
	}, [T, y]), D = h > 0 && w.size >= h, O = L(e.onRevealComplete);
	O.current = e.onRevealComplete;
	let k = L(null);
	N(() => {
		if (!D || k.current === y) return;
		let e = setTimeout(() => {
			k.current = y, O.current?.();
		}, du + _.showMs);
		return () => clearTimeout(e);
	}, [
		D,
		_.showMs,
		y
	]);
	let A = I(() => ({
		strings: s,
		theme: l,
		sounds: d,
		currency: r
	}), [
		s,
		l,
		d,
		r
	]), j = I(() => ({
		box: e.box,
		laneItems: e.laneItems,
		generators: b,
		seed: v,
		roundKey: y,
		running: e.running,
		invertSound: e.invertSound ?? !1,
		compact: p,
		layout: g,
		timings: _,
		landed: w,
		laneLanded: E
	}), [
		e.box,
		e.laneItems,
		b,
		v,
		y,
		e.running,
		e.invertSound,
		p,
		g,
		_,
		w,
		E
	]);
	return /* @__PURE__ */ B(o.Provider, {
		value: A,
		children: /* @__PURE__ */ B(Dc.Provider, {
			value: j,
			children: e.children
		})
	});
}
//#endregion
//#region src/battle/BattleRarityFrame.tsx
function _u({ orientation: e, variant: t, color: n, inset: r = 0, endInset: i, side: a = "both", className: o }) {
	let s = i ?? r;
	if (e === "vertical") return /* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: Y(X.frame, o),
		children: [a === "end" ? null : /* @__PURE__ */ B(bu, {
			className: Y(X.rail, X.railStartVertical),
			color: n,
			style: { left: r }
		}), a === "start" ? null : /* @__PURE__ */ B(bu, {
			className: Y(X.rail, X.railEndVertical),
			color: n,
			style: { right: s }
		})]
	});
	let c = t === "desktop" ? yu : vu, l = t === "desktop";
	return /* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: Y(X.frame, o),
		children: [a === "end" ? null : /* @__PURE__ */ B(c, {
			className: Y(X.rail, l ? X.railStartHorizontalFlipped : X.railStartHorizontal),
			color: n,
			style: { top: r }
		}), a === "start" ? null : /* @__PURE__ */ B(c, {
			className: Y(X.rail, l ? X.railEndHorizontal : X.railEndHorizontalFlipped),
			color: n,
			style: { bottom: s }
		})]
	});
}
function vu({ className: e, color: t, style: n }) {
	let r = Su();
	return /* @__PURE__ */ V("svg", {
		"aria-hidden": "true",
		className: e,
		width: "62",
		height: "9",
		viewBox: "0 0 62 9",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ B("path", {
			d: "M62 0.611684L36.1139 0.501953L31.0527 7.50195L25.929 0.503092M0 0.611395L12.6531 0.611684L25.929 0.503092L31.0527 4.75195L36.1139 0.503092",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ B(xu, {
			id: r,
			color: t,
			length: "62"
		})]
	});
}
function yu({ className: e, color: t, style: n }) {
	let r = Su();
	return /* @__PURE__ */ V("svg", {
		"aria-hidden": "true",
		className: e,
		width: "74",
		height: "14",
		viewBox: "0 0 74 14",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ B("path", {
			d: "M0.00390625 13.3119L30.6914 13.5L36.6914 1.49988L42.7655 13.498M73.5039 13.3124L58.5039 13.3119L42.7655 13.498L36.6914 4.49988L30.6914 13.498",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ B(xu, {
			id: r,
			color: t,
			length: "74"
		})]
	});
}
function bu({ className: e, color: t, style: n }) {
	let r = Su();
	return /* @__PURE__ */ V("svg", {
		"aria-hidden": "true",
		className: e,
		width: "14",
		height: "74",
		viewBox: "0 0 14 74",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ B("path", {
			d: "M0.688111 0.00390625L0.5 30.6914L12.5001 36.6914L0.501953 42.7655M0.687616 73.5039L0.688111 58.5039L0.501953 42.7655L9.50012 36.6914L0.501953 30.6914",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ B("defs", { children: /* @__PURE__ */ V("linearGradient", {
			id: r,
			x1: "6.75",
			y1: "0",
			x2: "6.75",
			y2: "74",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ B("stop", {
					stopColor: t,
					stopOpacity: "0"
				}),
				/* @__PURE__ */ B("stop", {
					offset: "0.5",
					stopColor: t
				}),
				/* @__PURE__ */ B("stop", {
					offset: "1",
					stopColor: t,
					stopOpacity: "0"
				})
			]
		}) })]
	});
}
function xu({ id: e, color: t, length: n }) {
	return /* @__PURE__ */ B("defs", { children: /* @__PURE__ */ V("linearGradient", {
		id: e,
		x1: n,
		y1: "4.15",
		x2: "0",
		y2: "4.15",
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ B("stop", {
				stopColor: t,
				stopOpacity: "0"
			}),
			/* @__PURE__ */ B("stop", {
				offset: "0.5",
				stopColor: t
			}),
			/* @__PURE__ */ B("stop", {
				offset: "1",
				stopColor: t,
				stopOpacity: "0"
			})
		]
	}) });
}
function Su() {
	return `los-battle-frame-${P().replace(/:/g, "")}`;
}
//#endregion
//#region src/battle/BattleSpinnerPointers.tsx
function Cu({ orientation: e, color: t, compact: n, config: r }) {
	return e === "horizontal" ? n ? r.compactEdgePointers ? /* @__PURE__ */ B(_u, {
		orientation: "horizontal",
		variant: "mobile",
		color: t,
		inset: r.compactEdgeInset ?? 42,
		endInset: r.compactEdgeEndInset ?? 6
	}) : /* @__PURE__ */ B(_u, {
		orientation: "horizontal",
		variant: "mobile",
		color: t,
		inset: 12
	}) : /* @__PURE__ */ B(_u, {
		orientation: "horizontal",
		variant: "desktop",
		color: t,
		inset: r.horizontalInset ?? 56,
		endInset: r.horizontalEndInset ?? 12
	}) : /* @__PURE__ */ B(_u, {
		orientation: "vertical",
		variant: "desktop",
		color: t,
		inset: r.verticalInset ?? 12
	});
}
//#endregion
//#region src/battle/BattleSeatColumn.tsx
function wu({ seatIndex: e, header: t, rowIndex: n, isLastInRow: i, isLastRow: a }) {
	let { theme: o } = f(), { layout: s, box: c, laneItems: l, landed: u } = Oc(), d = l[e] ?? null, p = u.has(e) && c && d ? r(o.railHex, h(d.value, c.priceCents)) : o.colors.border, { spinner: m, columnVariant: g, headerAlign: _ } = s, v = g === "mobile-grid", y = g === "mobile-2p" || g === "mobile-3p";
	return /* @__PURE__ */ B("div", {
		className: Y(X.column, i && X.columnLastInRow, a && X.columnLastRow, g !== "default" && X.columnGrid),
		style: Tu({
			columnVariant: g,
			rowIndex: n,
			isLastRow: a
		}),
		"data-los-battle-seat": e,
		children: /* @__PURE__ */ V("div", {
			className: Y(X.columnInner, v && X.columnInnerGrid, y && X.columnInnerCompact, _ === "right" && X.columnInnerBare),
			children: [
				/* @__PURE__ */ B("div", {
					className: Y(X.header, _ === "right" && X.headerRight, _ === "compact" && X.headerCompact),
					children: t
				}),
				/* @__PURE__ */ B(Cu, {
					orientation: m.orientation,
					color: p,
					compact: _ === "compact",
					config: m.pointers
				}),
				/* @__PURE__ */ B(Ac, {
					lane: e,
					className: Y(m.viewport.position === "absolute-top" && X.viewportAbsoluteTop, m.viewport.position === "absolute-center" && X.viewportAbsoluteCenter),
					style: Eu(m.viewport)
				})
			]
		})
	});
}
function Tu({ columnVariant: e, rowIndex: t, isLastRow: n }) {
	switch (e) {
		case "default": return { padding: 6 };
		case "mobile-2p": return { padding: `${t === 0 ? 6 : 3}px 6px ${n ? 6 : 3}px` };
		case "mobile-3p": return { padding: `${t === 0 ? 5 : 3}px 5px ${n ? 6 : 3}px` };
		case "mobile-grid": return { padding: 0 };
	}
}
function Eu(e) {
	let t = e.marginX ?? 0, n = {
		width: t < 0 && e.width === "100%" ? `calc(100% + ${-2 * t}px)` : e.width,
		height: e.height,
		maxWidth: t < 0 ? "none" : void 0
	};
	return e.position === "flow" && (n.marginTop = e.marginTop, n.marginLeft = t || void 0, n.marginRight = t || void 0), e.position === "absolute-top" && (n.top = e.top), n;
}
//#endregion
//#region src/battle/BattleOpener.tsx
function Du(e) {
	let t = L(null), [n, r] = R(null);
	F(() => {
		let e = t.current;
		if (!e) return;
		let n = () => r(e.offsetWidth);
		if (n(), typeof ResizeObserver > "u") return;
		let i = new ResizeObserver(n);
		return i.observe(e), () => i.disconnect();
	}, []);
	let i = e.compact ?? "auto", a = i === "auto" ? n !== null && n < 768 : i;
	return /* @__PURE__ */ B(gu, {
		box: e.box,
		laneItems: e.laneItems,
		seed: e.seed,
		running: e.running,
		quick: e.quick,
		invertSound: e.invertSound,
		compact: a,
		sounds: e.sounds,
		theme: e.theme,
		currency: e.currency,
		locale: e.locale,
		onLaneSettled: e.onLaneSettled,
		onRevealComplete: e.onRevealComplete,
		children: /* @__PURE__ */ B(Ou, {
			rootRef: t,
			measured: n !== null || i !== "auto",
			renderSeatHeader: e.renderSeatHeader,
			overlay: e.overlay,
			className: e.className,
			style: e.style
		})
	});
}
function Ou({ rootRef: e, measured: t, renderSeatHeader: n, overlay: r, className: i, style: a }) {
	let { theme: o } = f(), { layout: s, laneItems: c, landed: l, compact: u } = Oc(), d = c.length, p = {
		gridTemplateColumns: `repeat(${s.columns}, minmax(0, 1fr))`,
		height: s.height,
		gap: s.gap,
		padding: s.padding
	};
	return /* @__PURE__ */ V("div", {
		ref: e,
		className: Y(X.root, i),
		style: {
			...o.cssVars,
			...a
		},
		"data-los-battle-opener": !0,
		"data-los-battle-layout": s.key,
		"data-los-battle-viewport": s.viewport,
		children: [t ? /* @__PURE__ */ V("div", {
			className: X.grid,
			style: p,
			children: [c.map((e, t) => {
				let r = Math.floor(t / s.columns), i = l.has(t);
				return /* @__PURE__ */ B(wu, {
					seatIndex: t,
					header: n?.(t, {
						compact: u,
						settled: i,
						layout: s
					}),
					rowIndex: r,
					isLastInRow: (t + 1) % s.columns === 0 || t === d - 1,
					isLastRow: r === s.rows - 1
				}, t);
			}), /* @__PURE__ */ B(Mc, { layout: s })]
		}) : null, r]
	});
}
//#endregion
//#region src/battle/BattleResultsGrid.tsx
function ku(e) {
	let t = Fc(), n = I(() => c(e.theme ?? t.theme), [e.theme, t.theme]), r = e.currency ?? t.currency ?? C, i = I(() => a(e.locale ?? t.locale), [e.locale, t.locale]), o = L(null), [s, l] = R(null);
	F(() => {
		let e = o.current;
		if (!e) return;
		let t = () => l(e.offsetWidth);
		if (t(), typeof ResizeObserver > "u") return;
		let n = new ResizeObserver(t);
		return n.observe(e), () => n.disconnect();
	}, []);
	let u = e.compact ?? "auto", d = u === "auto" ? s !== null && s < 768 : u, f = au({
		playerCount: e.lanes.length,
		viewport: d ? "mobile" : "desktop"
	}).results.cardsPerRow, p = I(() => Array.from({ length: e.roundCount }, (e, t) => t), [e.roundCount]), m = (t, a) => {
		let o = t.items[a] ?? null;
		return o ? /* @__PURE__ */ B(Au, {
			item: o,
			priceCents: e.roundPriceCents[a] ?? 0,
			theme: n,
			currency: r
		}, a) : /* @__PURE__ */ V("div", {
			className: Y(X.resultCard, X.resultPlaceholder),
			title: `${i.battleRound} ${a + 1}`,
			children: [/* @__PURE__ */ B("p", {
				className: X.resultPlaceholderLabel,
				children: i.battleRound.toUpperCase()
			}), /* @__PURE__ */ B("p", {
				className: X.resultPlaceholderNumber,
				children: String(a + 1).padStart(2, "0")
			})]
		}, a);
	};
	return /* @__PURE__ */ B("div", {
		ref: o,
		className: Y(X.root, e.className),
		style: {
			...n.cssVars,
			...e.style
		},
		"data-los-battle-results": !0,
		children: s === null && u === "auto" ? null : d ? /* @__PURE__ */ B("div", {
			className: X.resultsMobile,
			children: e.lanes.map((t, n) => /* @__PURE__ */ V("div", {
				className: X.resultsMobileSeat,
				children: [/* @__PURE__ */ V("div", {
					className: X.resultsMobileHeader,
					children: [e.renderSeatHeader(n, { compact: !0 }), /* @__PURE__ */ B("span", {
						className: X.resultsMobileTotal,
						children: t.totalCents > 0 ? S(t.totalCents, r) : "-"
					})]
				}), /* @__PURE__ */ B("div", {
					className: X.resultsMobileStrip,
					children: p.map((e) => m(t, e))
				})]
			}, n))
		}) : /* @__PURE__ */ B("div", {
			className: X.results,
			style: { gridTemplateColumns: `repeat(${e.lanes.length}, minmax(0, 1fr))` },
			children: e.lanes.map((t, n) => /* @__PURE__ */ V("div", {
				className: X.resultsSeat,
				children: [/* @__PURE__ */ V("div", {
					className: X.resultsHeader,
					children: [e.renderSeatHeader(n, { compact: !1 }), /* @__PURE__ */ B("div", {
						className: X.resultsTotal,
						children: t.totalCents > 0 ? S(t.totalCents, r) : "-"
					})]
				}), /* @__PURE__ */ B("div", {
					className: X.resultsCards,
					style: { gridTemplateColumns: `repeat(${f}, minmax(0, 1fr))` },
					children: p.map((e) => m(t, e))
				})]
			}, n))
		})
	});
}
function Au({ item: e, priceCents: t, theme: n, currency: i }) {
	let a = r(n.railHex, h(e.value, t));
	return /* @__PURE__ */ V(ne.div, {
		className: X.resultCard,
		style: { borderColor: a },
		initial: {
			opacity: 0,
			scale: .92
		},
		animate: {
			opacity: 1,
			scale: 1
		},
		transition: {
			type: "tween",
			duration: .35,
			ease: "easeOut"
		},
		title: e.name,
		children: [
			e.imageUrl ? /* @__PURE__ */ B("img", {
				className: X.resultCardImage,
				src: e.imageUrl,
				alt: e.name,
				loading: "eager",
				decoding: "async"
			}) : /* @__PURE__ */ B("span", {
				"aria-hidden": !0,
				className: Y(X.resultCardImage, X.resultCardImageMissing)
			}),
			/* @__PURE__ */ B("p", {
				className: X.resultCardName,
				children: e.name
			}),
			/* @__PURE__ */ B("span", {
				className: X.resultCardValue,
				style: { color: a },
				children: S(e.value, i, { compact: !0 })
			})
		]
	});
}
//#endregion
//#region src/battle/BattleStartingOverlay.tsx
var ju = 240;
function Mu({ endsAtMs: e, now: t = Date.now, onFinished: n, children: r, className: i }) {
	let { strings: a } = f(), [o, s] = R(() => Math.max(0, e - t())), c = L(!1);
	N(() => {
		c.current = !1;
		let r = () => {
			let r = Math.max(0, e - t());
			s(r), r <= 0 && !c.current && (c.current = !0, n());
		};
		r();
		let i = setInterval(r, 50);
		return () => clearInterval(i);
	}, [
		e,
		t,
		n
	]);
	let l = Math.ceil(o / 1e3), u = l > 0 ? String(l) : a.battleGo, d = o <= ju;
	return /* @__PURE__ */ V(ne.div, {
		className: Y(X.starting, i),
		"data-los-battle-starting": !0,
		initial: !1,
		animate: {
			filter: d ? "blur(18px)" : "blur(0px)",
			opacity: +!d,
			scale: d ? 1.015 : 1
		},
		transition: {
			duration: d ? ju / 1e3 : 0,
			ease: "easeInOut"
		},
		children: [
			/* @__PURE__ */ B("span", {
				className: X.startingLabel,
				children: a.battleStartsIn
			}),
			/* @__PURE__ */ B("div", {
				className: X.startingCount,
				"aria-live": "polite",
				children: /* @__PURE__ */ B(ne.span, {
					className: Y(X.startingDigit, l <= 0 && X.startingGo),
					initial: {
						scale: 1.6,
						opacity: 0
					},
					animate: {
						scale: 1,
						opacity: 1
					},
					transition: {
						type: "tween",
						duration: .25,
						ease: "easeOut"
					},
					children: u
				}, u)
			}),
			/* @__PURE__ */ B("span", {
				className: Y(X.startingLabel, X.startingLuck),
				children: a.battleGoodLuck
			}),
			r ? /* @__PURE__ */ B("div", {
				className: X.startingSeats,
				children: r
			}) : null
		]
	});
}
//#endregion
//#region src/core/machine.ts
var Nu = 700;
function Pu(e) {
	let { openBox: t, onBeforeOpen: n, revealStartDelayMs: r = 700, minQuantity: i = 1, maxQuantity: a = 5, onEvent: o } = e, s = (e) => Math.max(i, Math.min(a, Math.floor(e) || i)), c = {
		phase: "idle",
		quantity: s(e.defaultQuantity ?? i),
		isQuickReveal: e.defaultQuickReveal ?? !1,
		entries: [],
		lastResponse: null,
		claimStatus: "none",
		pendingClaim: null,
		claim: null,
		claimError: null,
		sale: null,
		sellError: null,
		error: null,
		openCount: 0
	}, l = /* @__PURE__ */ new Set(), u = null, d = 0, f = !1, p = (e) => o?.(e), m = (e) => {
		c = {
			...c,
			...e
		};
		for (let e of l) e();
	}, h = () => {
		u !== null && (clearTimeout(u), u = null);
	}, g = (e) => {
		c.phase === "revealing" && (m({
			phase: "results",
			openCount: c.openCount + 1
		}), e && p({ type: "skipped" }), p({
			type: "reveal_complete",
			response: c.lastResponse,
			skipped: e
		}));
	};
	return {
		getState: () => c,
		subscribe: (e) => (l.add(e), () => l.delete(e)),
		open: async (i = c.quantity) => {
			if (f || c.phase !== "idle") return;
			let a = s(i), o = ++d;
			if (n) {
				let e;
				try {
					e = await n(a);
				} catch {
					e = !1;
				}
				if (e === !1) {
					p({
						type: "open_vetoed",
						quantity: a
					});
					return;
				}
				if (o !== d || c.phase !== "idle") return;
			}
			m({
				phase: "requesting",
				quantity: a,
				entries: [],
				claimStatus: "none",
				pendingClaim: null,
				claim: null,
				claimError: null,
				sale: null,
				sellError: null,
				error: null
			}), p({
				type: "open_start",
				quantity: a
			});
			let l;
			try {
				l = await t(a);
			} catch (e) {
				if (o !== d) return;
				m({
					phase: "idle",
					error: e
				}), p({
					type: "error",
					error: e
				});
				return;
			}
			if (o !== d) return;
			p({
				type: "opened",
				response: l
			});
			let h = () => {
				u = null;
				let t = l.status !== "claimed" && !!e.claimReveal && !e.settlesOnReveal?.(l);
				m({
					phase: "revealing",
					entries: l.entries,
					lastResponse: l,
					claimStatus: l.status === "claimed" ? "claimed" : t ? "unclaimed" : "none",
					pendingClaim: t ? {
						openGroupId: l.openGroupId,
						costCents: l.costCents
					} : null,
					claim: l.claim
				}), p({
					type: "reveal_start",
					response: l
				});
			};
			r > 0 ? u = setTimeout(h, r) : h();
		},
		skip: () => g(!0),
		completeReveal: () => g(!1),
		claim: async () => {
			if (f || !e.claimReveal || c.phase !== "results" || c.claimStatus !== "unclaimed") return;
			let t = c.pendingClaim;
			if (!t) return;
			let n = d;
			m({
				claimStatus: "claiming",
				claimError: null,
				sellError: null
			}), p({
				type: "claim_start",
				openGroupId: t.openGroupId
			});
			let r;
			try {
				r = await e.claimReveal(t);
			} catch (e) {
				if (n !== d) return;
				m({
					claimStatus: "unclaimed",
					claimError: e
				}), p({
					type: "claim_error",
					error: e
				});
				return;
			}
			n === d && (m({
				claimStatus: "claimed",
				pendingClaim: null,
				claim: r
			}), p({
				type: "claimed",
				claim: r
			}));
		},
		sellBack: async () => {
			if (f || !e.sellBackReveal || c.phase !== "results" || c.claimStatus !== "unclaimed") return;
			let t = c.pendingClaim;
			if (!t) return;
			let n = d;
			m({
				claimStatus: "selling",
				claimError: null,
				sellError: null
			}), p({
				type: "sell_back_start",
				openGroupId: t.openGroupId
			});
			let r;
			try {
				r = await e.sellBackReveal(t);
			} catch (e) {
				if (n !== d) return;
				m({
					claimStatus: "unclaimed",
					sellError: e
				}), p({
					type: "sell_back_error",
					error: e
				});
				return;
			}
			n === d && (m({
				claimStatus: "sold",
				pendingClaim: null,
				claim: r,
				sale: r
			}), p({
				type: "sold_back",
				sale: r
			}));
		},
		restore: (e) => {
			f || c.phase !== "idle" || c.pendingClaim || (m({
				phase: "results",
				entries: e.entries,
				claimStatus: "unclaimed",
				pendingClaim: {
					openGroupId: e.openGroupId,
					costCents: e.costCents
				},
				claim: null,
				claimError: null,
				sale: null,
				sellError: null,
				error: null
			}), p({
				type: "restored",
				reveal: e
			}));
		},
		reset: () => {
			c.claimStatus !== "unclaimed" && c.claimStatus !== "claiming" && c.claimStatus !== "selling" && (d++, h(), (c.phase !== "idle" || c.error !== null || c.entries.length !== 0) && (m({
				phase: "idle",
				entries: [],
				claimStatus: "none",
				pendingClaim: null,
				claim: null,
				claimError: null,
				sale: null,
				sellError: null,
				error: null
			}), p({ type: "reset" })));
		},
		setQuantity: (e) => {
			let t = s(e);
			t !== c.quantity && (c.phase === "idle" || c.phase === "results") && m({ quantity: t });
		},
		setQuickReveal: (e) => {
			e !== c.isQuickReveal && m({ isQuickReveal: e });
		},
		dispose: () => {
			f = !0, d++, h(), l.clear();
		},
		isDisposed: () => f
	};
}
//#endregion
//#region src/core/quantities.ts
var Fu = [
	1,
	2,
	3,
	4,
	5
];
function Iu(e) {
	let { descriptor: t } = e;
	if (!t.supportsBulk) return [1];
	let n = Math.min(e.maxQuantity ?? 36, t.bulkLimit ?? 5, 36), r = (e.quantities ?? Fu).filter((e) => Number.isInteger(e) && e >= 1 && e <= n).sort((e, t) => e - t), i = [...new Set(r)];
	return i.length > 0 ? i : [1];
}
function Lu(e, t) {
	if (t === void 0 || e.length <= t) return e;
	let n = e.reduce((e, t) => e === void 0 || t.item.value > e.item.value ? t : e, void 0);
	return n ? [n] : [];
}
//#endregion
//#region src/core/revealExit.ts
function Ru({ revealExit: e, isQuickReveal: t, actions: n }) {
	let r = null, i = () => {
		r &&= (clearTimeout(r), null);
	};
	return {
		completeReveal: () => {
			i();
			let a = t ? e.lingerMs.quick : e.lingerMs.normal;
			if (a === 0) {
				n.finishReveal();
				return;
			}
			r = setTimeout(() => {
				r = null, n.finishReveal();
			}, a);
		},
		skipReveal: (e) => {
			e?.(), i(), n.skipReveal();
		},
		cancel: i
	};
}
//#endregion
//#region src/core/types.ts
function zu(e) {
	return e.demo === !0;
}
function Bu(e) {
	if (typeof e != "object" || !e) return !1;
	let t = e;
	return typeof t.code == "string" && typeof t.message == "string";
}
//#endregion
//#region src/react/lootQueryClient.ts
var Vu;
function Hu() {
	return Vu ??= new oe({ defaultOptions: {
		queries: {
			retry: !1,
			refetchOnWindowFocus: !1,
			refetchOnReconnect: !1,
			staleTime: 3e4
		},
		mutations: { retry: !1 }
	} }), Vu;
}
var Uu = /* @__PURE__ */ new WeakMap(), Wu = 0;
function Gu(e) {
	if (!e) return null;
	let t = Uu.get(e);
	return t === void 0 && (Wu += 1, t = Wu, Uu.set(e, t)), t;
}
function Ku() {
	return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36);
}
var Z = {
	panel: "_panel_1nqtp_1",
	toggle: "_toggle_1nqtp_11",
	chevron: "_chevron_1nqtp_30",
	chevronOpen: "_chevronOpen_1nqtp_35",
	body: "_body_1nqtp_39",
	row: "_row_1nqtp_46",
	label: "_label_1nqtp_52",
	value: "_value_1nqtp_57",
	seedInput: "_seedInput_1nqtp_63",
	entries: "_entries_1nqtp_78",
	entryRow: "_entryRow_1nqtp_87",
	muted: "_muted_1nqtp_94"
}, qu = "los:clientSeed", Ju = 36;
function Yu() {
	return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID().split("-")[0] ?? "seed" : Math.random().toString(36).slice(2, 10);
}
function Xu(e) {
	return e.slice(0, 36);
}
function Zu() {
	if (typeof window > "u") return null;
	try {
		let e = window.localStorage.getItem(qu);
		return e ? Xu(e) : null;
	} catch {
		return null;
	}
}
function Qu({ clientSeed: e, onClientSeedChange: t }) {
	let n = e !== void 0, [r, i] = R(() => Zu() ?? Yu());
	N(() => {
		if (!(n || typeof window > "u")) try {
			window.localStorage.setItem(qu, r);
		} catch {}
	}, [n, r]);
	let a = M((e) => {
		let r = Xu(e);
		t?.(r), n || i(r);
	}, [n, t]);
	return [n ? Xu(e) : r, a];
}
//#endregion
//#region src/fairness/ProvablyFairPanel.tsx
function $u() {
	return (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
}
function ed({ client: e, lastResponse: t, clientSeed: n, onClientSeedChange: r, locked: i = !1, defaultOpen: a = !1, className: o }) {
	let { strings: s } = f(), [c, l] = R(a), u = P(), d = t?.fairness ?? null, p = ce({
		queryKey: [
			"loot-os",
			"seed",
			Gu(e),
			$u()
		],
		queryFn: async () => await e?.getSeed?.($u()) ?? null,
		enabled: c && !d && !!e?.getSeed,
		staleTime: Infinity
	}, Hu()), m = d?.serverSeedHash ?? p.data?.seedHash ?? null;
	return /* @__PURE__ */ V("div", {
		className: Y(Z.panel, o),
		children: [/* @__PURE__ */ V("button", {
			type: "button",
			className: Z.toggle,
			"aria-expanded": c,
			"aria-controls": u,
			onClick: () => l((e) => !e),
			children: [
				/* @__PURE__ */ B("span", {
					"aria-hidden": !0,
					children: "ⓘ"
				}),
				s.provablyFair,
				/* @__PURE__ */ B("span", {
					"aria-hidden": !0,
					className: Y(Z.chevron, c && Z.chevronOpen),
					children: "▾"
				})
			]
		}), c && /* @__PURE__ */ V("div", {
			className: Z.body,
			id: u,
			children: [
				/* @__PURE__ */ V("div", {
					className: Z.row,
					children: [/* @__PURE__ */ B("span", {
						className: Z.label,
						children: s.serverSeedHash
					}), /* @__PURE__ */ B("span", {
						className: Z.value,
						children: m ?? "…"
					})]
				}),
				/* @__PURE__ */ V("div", {
					className: Z.row,
					children: [/* @__PURE__ */ B("label", {
						className: Z.label,
						htmlFor: `${u}-seed`,
						children: s.clientSeed
					}), /* @__PURE__ */ B("input", {
						id: `${u}-seed`,
						className: Z.seedInput,
						value: n,
						maxLength: 36,
						disabled: i,
						onChange: (e) => r(e.target.value)
					})]
				}),
				d ? /* @__PURE__ */ V(z, { children: [
					/* @__PURE__ */ V("div", {
						className: Z.row,
						children: [/* @__PURE__ */ B("span", {
							className: Z.label,
							children: s.salt
						}), /* @__PURE__ */ B("span", {
							className: Z.value,
							children: d.salt
						})]
					}),
					/* @__PURE__ */ V("div", {
						className: Z.row,
						children: [/* @__PURE__ */ B("span", {
							className: Z.label,
							children: s.seedDate
						}), /* @__PURE__ */ B("span", {
							className: Z.value,
							children: d.seedDate
						})]
					}),
					/* @__PURE__ */ V("div", {
						className: Z.row,
						children: [/* @__PURE__ */ V("span", {
							className: Z.label,
							children: [
								s.nonce,
								" / ",
								s.result
							]
						}), /* @__PURE__ */ B("ul", {
							className: Z.entries,
							children: (t?.entries ?? []).map((e) => /* @__PURE__ */ V("li", {
								className: Z.entryRow,
								children: [/* @__PURE__ */ V("span", { children: ["#", e.nonce] }), /* @__PURE__ */ B("span", { children: e.result })]
							}, e.openId))
						})]
					})
				] }) : /* @__PURE__ */ B("span", {
					className: Z.muted,
					children: s.noOpensYet
				})
			]
		})]
	});
}
//#endregion
//#region src/demo/demoOpen.ts
function td() {
	if (typeof crypto < "u" && typeof crypto.getRandomValues == "function") {
		let e = /* @__PURE__ */ new Uint32Array(1), t = Math.floor(4294967296 / d) * d, n = 0;
		do
			crypto.getRandomValues(e), n = e[0] ?? 0;
		while (n >= t);
		return n % d;
	}
	return Math.floor(Math.random() * d);
}
function nd(e) {
	return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? `${e}_${crypto.randomUUID()}` : `${e}_${Math.random().toString(36).slice(2)}`;
}
function rd(e, t, n) {
	let r = [];
	for (let n = 0; n < t; n++) {
		let t = td(), i = v(e.dropTable, t) ?? 0, a = e.dropTable[i];
		a && r.push({
			openId: nd("demo_open"),
			nonce: n,
			result: t,
			itemIndex: i,
			item: a
		});
	}
	return {
		demo: !0,
		openGroupId: nd("demo_group"),
		boxId: e.id,
		boxVersion: e.version,
		costCents: e.priceCents * t,
		dropTableHash: e.dropTableHash,
		status: "unclaimed",
		claim: null,
		entries: r,
		fairness: {
			seedDate: (/* @__PURE__ */ new Date()).toISOString().slice(0, 10),
			serverSeedHash: "demo",
			clientSeed: n,
			salt: "demo",
			nonces: r.map((e) => e.nonce)
		}
	};
}
function id(e, t) {
	return {
		openGroupId: e.openGroupId,
		costCents: e.costCents,
		balanceAfterCents: 0,
		claimedAt: (/* @__PURE__ */ new Date()).toISOString(),
		items: t.map((e) => ({
			openId: e.openId,
			inventoryItemId: nd("demo_inv"),
			item: e.item,
			isLimited: e.item.isLimited ?? !1
		}))
	};
}
function ad(e, t) {
	let n = id(e, t), r = t.reduce((e, t) => e + t.item.value, 0);
	return {
		...n,
		balanceAfterCents: n.balanceAfterCents + r,
		soldCents: r,
		soldAt: (/* @__PURE__ */ new Date()).toISOString()
	};
}
var Q = {
	opener: "_opener_pm16a_3",
	band: "_band_pm16a_11",
	bandDesktop: "_bandDesktop_pm16a_24",
	bandMobile: "_bandMobile_pm16a_28",
	stage: "_stage_pm16a_35",
	brandMark: "_brandMark_pm16a_46",
	brandName: "_brandName_pm16a_58",
	railLayer: "_railLayer_pm16a_78",
	wheelArea: "_wheelArea_pm16a_88",
	spinner: "_spinner_pm16a_102",
	spinnerRow: "_spinnerRow_pm16a_113",
	spinnerColumn: "_spinnerColumn_pm16a_118",
	laneRow2: "_laneRow2_pm16a_123",
	laneRowHorizontal: "_laneRowHorizontal_pm16a_130",
	laneRowVertical: "_laneRowVertical_pm16a_134",
	lane: "_lane_pm16a_123",
	laneHorizontal: "_laneHorizontal_pm16a_143",
	laneVertical: "_laneVertical_pm16a_147",
	laneItems: "_laneItems_pm16a_151",
	laneItemsHorizontal: "_laneItemsHorizontal_pm16a_157",
	laneItemsVertical: "_laneItemsVertical_pm16a_161",
	card: "_card_pm16a_166",
	cardImage: "_cardImage_pm16a_174",
	itemLabel: "_itemLabel_pm16a_182",
	itemLabelHidden: "_itemLabelHidden_pm16a_192",
	itemLabelInner: "_itemLabelInner_pm16a_196",
	itemLabelValue: "_itemLabelValue_pm16a_204",
	itemLabelName: "_itemLabelName_pm16a_210",
	fade: "_fade_pm16a_223",
	fadeLeft: "_fadeLeft_pm16a_230",
	fadeRight: "_fadeRight_pm16a_238",
	fadeTop: "_fadeTop_pm16a_246",
	fadeBottom: "_fadeBottom_pm16a_254",
	railRoot: "_railRoot_pm16a_263",
	railSvg: "_railSvg_pm16a_270",
	railTop: "_railTop_pm16a_274",
	railBottom: "_railBottom_pm16a_280",
	railLeft: "_railLeft_pm16a_286",
	railRight: "_railRight_pm16a_292"
};
//#endregion
//#region src/spinner/SpinnerWheel.tsx
function od({ item: e }) {
	let { currency: t } = f();
	return /* @__PURE__ */ V("div", {
		className: Q.itemLabelInner,
		children: [/* @__PURE__ */ B("span", {
			className: Q.itemLabelValue,
			children: S(e.value, t, { compact: !0 })
		}), /* @__PURE__ */ B("p", {
			className: Q.itemLabelName,
			children: e.name
		})]
	});
}
function sd({ index: e, getBoxItemsByIndex: t, animationPhase: n, setAnimationPhase: r, isRowOpen: i, geometry: a, timing: o, sounds: s, selectedOpenQuantity: c, isMobile: d, rarityRgb: f, selectedItemIndexRef: p, onRevealComplete: m, onItemSettled: h, renderItemLabel: g }) {
	let { itemWidth: _, gap: v, containerWidth: y, containerHeight: b, startingOffset: x, endingOffset: S, spinSnapOffsets: C } = a, { animationDuration: w, spinStartDelaySec: T, staggerDelay: E, popupDuration: D } = o, { playTickSound: O, playRaritySound: k, lastTickTimeRef: A } = s, j = t(e), M = () => {
		let t = j?.[35];
		t && (h?.(t.rarity, e), k(t.rarity));
	}, ee = w + e * E, N = !d;
	return /* @__PURE__ */ B(ne.div, {
		className: Y(Q.lane, i ? Q.laneHorizontal : Q.laneVertical),
		"data-los-lane": e,
		initial: {
			transform: i ? `translateX(${x}px)` : `translateY(${x}px)`,
			opacity: 0
		},
		animate: n === "initialSpin" ? {
			transform: i ? `translateX(${S + (C[e] ?? 0)}px)` : `translateY(${S + (C[e] ?? 0)}px)`,
			opacity: 1
		} : {
			transform: i ? `translateX(${S}px)` : `translateY(${S}px)`,
			opacity: 1
		},
		transition: n === "initialSpin" ? {
			type: "tween",
			duration: w,
			delay: T,
			ease: [
				.25,
				.8,
				.5,
				1
			],
			opacity: {
				duration: .3,
				ease: "easeOut",
				delay: T
			}
		} : {
			type: "tween",
			duration: 300 / 1e3,
			ease: "easeOut",
			delay: e * E
		},
		style: { willChange: "transform, opacity" },
		onUpdate: (t) => {
			if (n !== "initialSpin" || !j || e !== 0) return;
			let r = Date.now();
			if (r - A.current < 16) return;
			A.current = r;
			let i = (t.transform ?? "").match(/translate[XY]\((-?\d+\.?\d*)px\)/);
			if (!i?.[1]) return;
			let a = Number.parseFloat(i[1]), o = d ? y / 2 : (c === 1 ? y : b) / 2, s = Math.round((o - a - _ / 2) / (_ + v));
			p.current !== s && s >= 0 && s < j.length && (p.current = s, O());
		},
		onAnimationComplete: () => {
			n === "initialSpin" ? r("snap") : n === "snap" && M();
		},
		children: /* @__PURE__ */ B("div", {
			className: Y(Q.laneItems, i ? Q.laneItemsHorizontal : Q.laneItemsVertical),
			style: { gap: `${v}px` },
			children: j?.map((t, n) => /* @__PURE__ */ V(ne.div, {
				className: Q.card,
				style: {
					height: `${_}px`,
					width: `${_}px`,
					willChange: n === 35 ? "transform" : "transform, opacity"
				},
				animate: n === 35 ? { scale: [
					1,
					1.12,
					1.08
				] } : {
					scale: [1, .9],
					opacity: [1, .25]
				},
				transition: {
					type: "tween",
					duration: D,
					ease: "easeOut",
					delay: ee
				},
				onAnimationComplete: () => {
					!N && n === 35 && e === c - 1 && m?.();
				},
				children: [/* @__PURE__ */ B(ne.img, {
					src: t.imageUrl ?? "",
					alt: `${t.name}`,
					loading: "eager",
					decoding: "async",
					width: _,
					height: _,
					sizes: `${_}px`,
					className: Q.cardImage,
					style: {
						borderRadius: _ < 90 ? "4px" : "8px",
						zIndex: 1,
						willChange: n === 35 ? "filter" : "auto"
					},
					initial: n === 35 ? { filter: u(f, t.rarity, "0px", "0") } : void 0,
					animate: n === 35 ? { filter: l(f, t.rarity) } : void 0,
					transition: n === 35 ? {
						duration: 300 / 1e3,
						ease: "easeOut",
						delay: ee
					} : void 0
				}), N && /* @__PURE__ */ B(ne.div, {
					className: Y(Q.itemLabel, n !== 35 && Q.itemLabelHidden),
					initial: c > 1 ? {
						opacity: 0,
						y: -50
					} : void 0,
					animate: n === 35 ? {
						y: [-50, 0],
						opacity: [0, 1]
					} : {},
					transition: {
						type: "keyframes",
						duration: D,
						delay: ee
					},
					onAnimationComplete: () => {
						e === c - 1 && n === 35 && m && m();
					},
					children: g ? g(t) : /* @__PURE__ */ B(od, { item: t })
				})]
			}, `spinner-${e}-item-${n}-${t.itemId ?? t.name}`))
		})
	});
}
//#endregion
//#region src/spinner/useSpinnerWheelItems.ts
function cd({ box: e, revealedItems: t, prandGenerator: n, itemWidth: r, gap: i, containerWidth: a, containerHeight: o, selectedOpenQuantity: s, isMobile: c }) {
	let l = I(() => t.slice(0, s).map((t) => rc(e, 35, t, n)), [
		e,
		n,
		t,
		s
	]), u = (e) => l[e] ?? null, d = (e) => {
		switch (e) {
			case 2: return c ? { gap: 56 } : {
				marginLeft: "22%",
				marginRight: "22%"
			};
			case 3: return c ? { gap: 32 } : {
				marginLeft: "15%",
				marginRight: "15%"
			};
			case 4: return c ? { gap: 24 } : {
				marginLeft: "10%",
				marginRight: "10%"
			};
			case 5: return c ? { gap: 20 } : {
				marginLeft: "5%",
				marginRight: "5%"
			};
			default: return {};
		}
	}, f = I(() => {
		let e = [];
		for (let t = 0; t < s; t++) {
			let n = Math.floor(Math.random() * 2) === 0;
			e[t] = r / 4 * Math.random() * (n ? -1 : 1) + r / 4 * (n ? -1 : 1);
		}
		return e;
	}, [r, s]), { startingOffset: p, endingOffset: m } = I(() => {
		let e = c ? a / 2 : (s === 1 ? a : o) / 2, t = r * 4 + i * 3 - r / 2, n = r * 36 + i * 35 - r / 2;
		return {
			startingOffset: e - t,
			endingOffset: e - n
		};
	}, [
		s,
		a,
		o,
		r,
		i,
		c
	]);
	return {
		getBoxItemsByIndex: u,
		getMultiOpenSpacing: d,
		spinSnapOffsets: f,
		startingOffset: p,
		endingOffset: m
	};
}
//#endregion
//#region src/spinner/MotionSpinner.tsx
function ld({ className: e, gap: t = 0, box: n, isQuickReveal: r = !1, revealedItems: i, prandGenerator: a, itemWidth: o, containerWidth: s, containerHeight: c, selectedOpenQuantity: l, isMobile: u, sounds: d, rarityRgb: f, onRevealComplete: p, onItemSettled: m, renderItemLabel: h }) {
	let [g, _] = R("initialSpin"), v = l === 1 || u, y = L(null), b = L(0), x = I(() => r ? Xs / 1e3 : Ys / 1e3, [r]), S = I(() => r ? 150 / 1e3 : 250 / 1e3, [r]), { getBoxItemsByIndex: C, getMultiOpenSpacing: w, spinSnapOffsets: T, startingOffset: E, endingOffset: D } = cd({
		box: n,
		revealedItems: i,
		prandGenerator: a,
		itemWidth: o,
		gap: t,
		containerWidth: s,
		containerHeight: c,
		selectedOpenQuantity: l,
		isMobile: u
	}), O = I(() => ({
		itemWidth: o,
		gap: t,
		containerWidth: s,
		containerHeight: c,
		startingOffset: E,
		endingOffset: D,
		spinSnapOffsets: T
	}), [
		o,
		t,
		s,
		c,
		E,
		D,
		T
	]), k = I(() => ({
		animationDuration: x,
		spinStartDelaySec: .25,
		staggerDelay: S,
		popupDuration: 1
	}), [x, S]), A = I(() => ({
		playTickSound: d.playTickSound,
		playRaritySound: d.playRaritySound,
		lastTickTimeRef: b
	}), [d.playTickSound, d.playRaritySound]);
	return /* @__PURE__ */ V("div", {
		className: Y(Q.spinner, v ? Q.spinnerRow : Q.spinnerColumn, e),
		children: [C(0) && /* @__PURE__ */ B("div", {
			className: Y(Q.laneRow2, u ? Q.laneRowHorizontal : Q.laneRowVertical),
			style: w(l),
			children: Array.from({ length: l }, (e, t) => /* @__PURE__ */ B(sd, {
				index: t,
				getBoxItemsByIndex: C,
				animationPhase: g,
				setAnimationPhase: _,
				isRowOpen: v,
				geometry: O,
				timing: k,
				sounds: A,
				selectedOpenQuantity: l,
				isMobile: u,
				rarityRgb: f,
				selectedItemIndexRef: y,
				onRevealComplete: p,
				onItemSettled: m,
				renderItemLabel: h
			}, `spinner-${t}`))
		}), v ? /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B("div", { className: Y(Q.fade, Q.fadeLeft) }), /* @__PURE__ */ B("div", { className: Y(Q.fade, Q.fadeRight) })] }) : /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B("div", { className: Y(Q.fade, Q.fadeTop) }), /* @__PURE__ */ B("div", { className: Y(Q.fade, Q.fadeBottom) })] })]
	});
}
//#endregion
//#region src/spinner/SpinnerPointerRail.tsx
function ud({ orientation: e, color: t, inset: n = 10, className: r }) {
	return e === "vertical" ? /* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: Y(Q.railRoot, r),
		children: [/* @__PURE__ */ B(fd, {
			className: Y(Q.railSvg, Q.railLeft),
			color: t,
			style: { left: n }
		}), /* @__PURE__ */ B(fd, {
			className: Y(Q.railSvg, Q.railRight),
			color: t,
			style: { right: n }
		})]
	}) : /* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: Y(Q.railRoot, r),
		children: [/* @__PURE__ */ B(dd, {
			className: Y(Q.railSvg, Q.railTop),
			color: t,
			style: { top: n }
		}), /* @__PURE__ */ B(dd, {
			className: Y(Q.railSvg, Q.railBottom),
			color: t,
			style: { bottom: n }
		})]
	});
}
function dd({ className: e, color: t, style: n }) {
	let r = pd();
	return /* @__PURE__ */ V("svg", {
		"aria-hidden": "true",
		className: e,
		width: "74",
		height: "14",
		viewBox: "0 0 74 14",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ B("path", {
			d: "M0.00390625 13.3119L30.6914 13.5L36.6914 1.49988L42.7655 13.498M73.5039 13.3124L58.5039 13.3119L42.7655 13.498L36.6914 4.49988L30.6914 13.498",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ B("defs", { children: /* @__PURE__ */ V("linearGradient", {
			id: r,
			x1: "74",
			y1: "7",
			x2: "0",
			y2: "7",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ B("stop", {
					stopColor: t,
					stopOpacity: "0"
				}),
				/* @__PURE__ */ B("stop", {
					offset: "0.5",
					stopColor: t
				}),
				/* @__PURE__ */ B("stop", {
					offset: "1",
					stopColor: t,
					stopOpacity: "0"
				})
			]
		}) })]
	});
}
function fd({ className: e, color: t, style: n }) {
	let r = pd();
	return /* @__PURE__ */ V("svg", {
		"aria-hidden": "true",
		className: e,
		width: "14",
		height: "74",
		viewBox: "0 0 14 74",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ B("path", {
			d: "M0.688111 0.00390625L0.5 30.6914L12.5001 36.6914L0.501953 42.7655M0.687616 73.5039L0.688111 58.5039L0.501953 42.7655L9.50012 36.6914L0.501953 30.6914",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ B("defs", { children: /* @__PURE__ */ V("linearGradient", {
			id: r,
			x1: "7",
			y1: "0",
			x2: "7",
			y2: "74",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ B("stop", {
					stopColor: t,
					stopOpacity: "0"
				}),
				/* @__PURE__ */ B("stop", {
					offset: "0.5",
					stopColor: t
				}),
				/* @__PURE__ */ B("stop", {
					offset: "1",
					stopColor: t,
					stopOpacity: "0"
				})
			]
		}) })]
	});
}
function pd() {
	return `los-spinner-rail-${P().replace(/:/g, "")}`;
}
//#endregion
//#region src/spinner/SpinnerOpener.tsx
var md = 768;
function hd(e) {
	switch (e) {
		case 1: return 220;
		case 2: return 160;
		case 3: return 115;
		case 4: return 80;
		case 5: return 72;
		default: return 150;
	}
}
function gd(e) {
	switch (e) {
		case 1: return 32;
		case 2: return 24;
		case 3: return 16;
		case 4: return 12;
		case 5: return 6;
		default: return 32;
	}
}
function _d({ boxData: e, entries: t, quantity: n, isQuickReveal: i, prandGenerator: a, onRevealComplete: o }) {
	let { theme: s, sounds: c, renderItemLabel: l } = f(), u = L(null), d = L(null), [p, m] = R(null), [g, _] = R(0), [v, y] = R(0);
	F(() => {
		let e = u.current;
		if (!e) return;
		let t = () => m(e.offsetWidth);
		if (t(), typeof ResizeObserver > "u") return;
		let n = new ResizeObserver(t);
		return n.observe(e), () => n.disconnect();
	}, []);
	let b = p === null ? null : p < md;
	F(() => {
		let e = d.current;
		if (!e) return;
		let t = () => {
			_(e.offsetWidth), y(e.offsetHeight);
		};
		if (t(), typeof ResizeObserver > "u") return;
		let n = new ResizeObserver(t);
		return n.observe(e), () => n.disconnect();
	}, [b]);
	let S = I(() => t.map((e) => e.item), [t]), C = I(() => t.length ? Math.max(...t.map((t) => h(t.item.value, e.priceCents ?? 0))) : null, [t, e.priceCents]), [w, T] = R(!1);
	N(() => {
		T(!1);
	}, [t]);
	let E = M((e) => {
		C !== null && e >= C && T(!0);
	}, [C]), D = w && C !== null ? r(s.railHex, C) : r(s.railHex, null), O = I(() => ({
		priceCents: e.priceCents,
		dropTable: e.dropTable
	}), [e.priceCents, e.dropTable]), k = e.opener?.logoSvg, A = e.opener?.brandName?.trim(), j = I(() => k ? /* @__PURE__ */ B("img", {
		className: Q.brandMark,
		src: x(k),
		alt: "",
		"aria-hidden": "true"
	}) : A ? /* @__PURE__ */ B("span", {
		className: Q.brandName,
		"aria-hidden": "true",
		children: A
	}) : null, [k, A]);
	return /* @__PURE__ */ B("div", {
		className: Q.opener,
		ref: u,
		children: b === null ? null : b ? /* @__PURE__ */ B("div", {
			className: Y(Q.band, Q.bandMobile),
			children: /* @__PURE__ */ V("div", {
				className: Q.stage,
				children: [
					j,
					/* @__PURE__ */ B("div", {
						className: Q.railLayer,
						children: /* @__PURE__ */ B(ud, {
							orientation: "horizontal",
							color: D,
							inset: -4
						})
					}),
					/* @__PURE__ */ B("div", {
						className: Q.wheelArea,
						ref: d,
						children: /* @__PURE__ */ B(ld, {
							gap: gd(n),
							box: O,
							revealedItems: S,
							isQuickReveal: i,
							prandGenerator: a,
							itemWidth: hd(n),
							containerWidth: g,
							containerHeight: v,
							selectedOpenQuantity: n,
							isMobile: !0,
							sounds: c,
							rarityRgb: s.rarityRgb,
							onRevealComplete: o,
							onItemSettled: E,
							renderItemLabel: l
						})
					})
				]
			})
		}) : /* @__PURE__ */ B("div", {
			className: Y(Q.band, Q.bandDesktop),
			children: /* @__PURE__ */ V("div", {
				className: Q.stage,
				children: [
					j,
					/* @__PURE__ */ B("div", {
						className: Q.railLayer,
						children: /* @__PURE__ */ B(ud, {
							orientation: n === 1 ? "horizontal" : "vertical",
							color: D
						})
					}),
					/* @__PURE__ */ B("div", {
						className: Q.wheelArea,
						ref: d,
						children: /* @__PURE__ */ B(ld, {
							gap: n > 1 ? 56 : 32,
							box: O,
							revealedItems: S,
							isQuickReveal: i,
							prandGenerator: a,
							itemWidth: 190,
							containerWidth: g,
							containerHeight: v,
							selectedOpenQuantity: n,
							isMobile: !1,
							sounds: c,
							rarityRgb: s.rarityRgb,
							onRevealComplete: o,
							onItemSettled: E,
							renderItemLabel: l
						})
					})
				]
			})
		})
	});
}
//#endregion
//#region src/openers/SpinnerRevealOpener.tsx
function vd({ boxData: e, reveal: t, onRevealComplete: n }) {
	return /* @__PURE__ */ B(_d, {
		boxData: e,
		entries: t.entries,
		quantity: t.quantity,
		isQuickReveal: t.isQuickReveal,
		prandGenerator: t.prandGenerator,
		onRevealComplete: n
	});
}
//#endregion
//#region src/openers/registry.ts
var yd = { spinner: E({
	Opener: vd,
	loopTarget: "loop",
	supportsBulk: !0,
	bulkLimit: 36,
	revealLimit: 5,
	revealExit: { lingerMs: tc }
}) }, bd = "spinner";
function xd(e) {
	if (e) {
		let t = D(e) ?? (Object.hasOwn(yd, e) ? yd[e] : void 0);
		if (t) return t;
	}
	return yd[bd];
}
//#endregion
//#region src/react/hooks.ts
function Sd({ client: e, boxId: t }) {
	let n = ce({
		queryKey: [
			"loot-os",
			"box",
			Gu(e),
			t
		],
		queryFn: () => {
			if (!e) throw Error("[loot-os] no API client configured");
			return e.getBox(t);
		},
		enabled: !!e
	}, Hu()), { refetch: r } = n, i = M(() => void r(), [r]);
	return {
		box: n.data ?? null,
		loading: !!e && n.isFetching,
		error: n.isFetching ? null : n.error ?? null,
		reload: i
	};
}
function Cd({ client: e, boxId: t, clientSeed: n, expectedVersion: r }) {
	let i = se({
		mutationKey: [
			"loot-os",
			"open",
			Gu(e),
			t
		],
		mutationFn: (i) => {
			if (!e) throw Error("[loot-os] no API client configured");
			return e.openBox({
				boxId: t,
				clientSeed: n,
				amount: i.quantity,
				expectedVersion: r,
				idempotencyKey: i.idempotencyKey
			});
		}
	}, Hu()), { mutateAsync: a } = i;
	return {
		open: M(async (t = 1) => {
			if (!e) return null;
			try {
				return await a({
					quantity: t,
					idempotencyKey: Ku()
				});
			} catch {
				return null;
			}
		}, [e, a]),
		opening: i.isPending,
		response: i.data ?? null,
		error: i.error ?? null
	};
}
//#endregion
//#region src/react/useOpenerMachine.ts
function wd(e) {
	return te(e.subscribe, e.getState, e.getState);
}
function Td(e) {
	let t = L(e);
	t.current = e;
	let n = L(null);
	n.current === null && (n.current = () => Pu({
		openBox: (e) => t.current.openBox(e),
		claimReveal: e.claimReveal ? (e) => {
			let n = t.current.claimReveal;
			if (!n) throw Error("[loot-os] claimReveal config removed mid-flight");
			return n(e);
		} : void 0,
		sellBackReveal: e.sellBackReveal ? (e) => {
			let n = t.current.sellBackReveal;
			if (!n) throw Error("[loot-os] sellBackReveal config removed mid-flight");
			return n(e);
		} : void 0,
		onBeforeOpen: (e) => t.current.onBeforeOpen?.(e),
		onEvent: (e) => t.current.onEvent?.(e),
		settlesOnReveal: (e) => t.current.settlesOnReveal?.(e) ?? !1,
		revealStartDelayMs: e.revealStartDelayMs,
		minQuantity: e.minQuantity,
		maxQuantity: e.maxQuantity,
		defaultQuantity: e.defaultQuantity,
		defaultQuickReveal: e.defaultQuickReveal
	}));
	let r = n.current, [i, a] = R(r);
	return N(() => {
		if (i.isDisposed()) {
			a(r());
			return;
		}
		return () => i.dispose();
	}, [i, r]), {
		machine: i,
		state: wd(i)
	};
}
//#endregion
//#region src/react/useResolvedClient.ts
var Ed = async (e) => {
	let { LootClient: t } = await import("@loot-os/client");
	return new t(e);
};
function Dd({ client: e, createClient: t, publishableKey: n, baseUrl: r, sessionToken: i, onSessionExpired: a }) {
	let [o, s] = R(null), [c, l] = R(null), u = L(a), d = L(0);
	F(() => {
		d.current += 1;
	}, [
		e,
		t,
		n,
		r
	]), F(() => {
		u.current = a;
	}, [a]), N(() => {
		let i = d.current, a = () => i === d.current;
		if (s(null), l(null), e || !n) return;
		let o = t ?? Ed;
		Promise.resolve(o({
			publishableKey: n,
			baseUrl: r,
			sessionToken: null,
			onSessionExpired: async () => {
				if (!a() || !u.current) return null;
				let e = await u.current();
				return a() ? e : null;
			}
		})).then((e) => {
			a() && s({
				instance: e,
				buildId: i,
				createClient: t,
				publishableKey: n,
				baseUrl: r
			});
		}).catch((e) => {
			a() && l(e);
		});
	}, [
		e,
		t,
		n,
		r
	]);
	let f = o && o.buildId === d.current && o.createClient === t && o.publishableKey === n && o.baseUrl === r ? o.instance : null, p = e ?? f;
	return N(() => {
		p?.setSessionToken?.(i ?? null);
	}, [p, i]), {
		client: p,
		error: c
	};
}
var Od = {
	scroller: "_scroller_ujyfz_3",
	track: "_track_ujyfz_13",
	trackAnimated: "_trackAnimated_ujyfz_19",
	losIdleCardScroll: "_losIdleCardScroll_ujyfz_1",
	loop: "_loop_ujyfz_24",
	slot: "_slot_ujyfz_31",
	floatY: "_floatY_ujyfz_37",
	losFloatY: "_losFloatY_ujyfz_1",
	floatYDelay1: "_floatYDelay1_ujyfz_41",
	floatYSmall: "_floatYSmall_ujyfz_45",
	losFloatYSmall: "_losFloatYSmall_ujyfz_1",
	floatYSmallDelay1: "_floatYSmallDelay1_ujyfz_49",
	fadeLeft: "_fadeLeft_ujyfz_53",
	fadeRight: "_fadeRight_ujyfz_70"
}, kd = 12;
function Ad(e, t) {
	let n = e % 2 == 1;
	return t ? n ? Od.floatYSmallDelay1 ?? "" : Od.floatYSmall ?? "" : n ? Od.floatYDelay1 ?? "" : Od.floatY ?? "";
}
function jd({ slots: e, itemWidth: t, gap: n = 0, isMobile: r = !1, direction: i = "left", className: a }) {
	let o = I(() => {
		if (e.length === 0) return 0;
		let t = Math.max(2, Math.ceil(kd / e.length));
		return t % 2 == 0 ? t : t + 1;
	}, [e.length]), s = e.length * (t + n), c = Math.max(1.5, e.length * (r ? 2.5 : 8));
	return /* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: Y(Od.scroller, a),
		children: [
			/* @__PURE__ */ B("div", {
				className: Y(Od.track, e.length > 0 && Od.trackAnimated),
				style: {
					gap: `${n}px`,
					"--los-idle-scroll-distance": `-${s}px`,
					"--los-idle-scroll-duration": `${c}s`,
					animationDirection: i === "left" ? "normal" : "reverse"
				},
				children: Array.from({ length: o }, (i, a) => /* @__PURE__ */ B("div", {
					className: Od.loop,
					style: { gap: `${n}px` },
					children: e.map((e, n) => /* @__PURE__ */ B("div", {
						className: Y(Od.slot, Ad(n, r)),
						style: {
							width: `${t}px`,
							height: `${t}px`
						},
						children: e
					}, `loop-${a}-${n}`))
				}, a))
			}),
			/* @__PURE__ */ B("div", { className: Od.fadeLeft }),
			/* @__PURE__ */ B("div", { className: Od.fadeRight })
		]
	});
}
var Md = j(jd), $ = {
	root: "_root_dj4df_5",
	phase: "_phase_dj4df_46",
	losPhaseFadeIn: "_losPhaseFadeIn_dj4df_1",
	hostIdle: "_hostIdle_dj4df_73",
	hostControls: "_hostControls_dj4df_86",
	idleHero: "_idleHero_dj4df_93",
	brandLogo: "_brandLogo_dj4df_101",
	brandName: "_brandName_dj4df_107",
	boxImage: "_boxImage_dj4df_118",
	boxName: "_boxName_dj4df_125",
	boxPrice: "_boxPrice_dj4df_132",
	idleScrollerArea: "_idleScrollerArea_dj4df_138",
	idleCard: "_idleCard_dj4df_146",
	idleCardImage: "_idleCardImage_dj4df_155",
	controls: "_controls_dj4df_164",
	controlsRow: "_controlsRow_dj4df_173",
	quantityGroup: "_quantityGroup_dj4df_182",
	quantityButton: "_quantityButton_dj4df_194",
	quantityButtonActive: "_quantityButtonActive_dj4df_210",
	primaryButton: "_primaryButton_dj4df_215",
	secondaryButton: "_secondaryButton_dj4df_244",
	toggleLabel: "_toggleLabel_dj4df_265",
	priceTag: "_priceTag_dj4df_274",
	revealArea: "_revealArea_dj4df_281",
	revealStage: "_revealStage_dj4df_290",
	demoAnchor: "_demoAnchor_dj4df_300",
	demoBadge: "_demoBadge_dj4df_305",
	errorBanner: "_errorBanner_dj4df_327",
	loading: "_loading_dj4df_338",
	fairnessArea: "_fairnessArea_dj4df_347",
	openerLoading: "_openerLoading_dj4df_373",
	stageOwned: "_stageOwned_dj4df_386"
};
//#endregion
//#region src/shell/DemoTag.tsx
function Nd({ demo: e, children: t }) {
	let { strings: n } = f();
	return e ? /* @__PURE__ */ V("span", {
		className: $.demoAnchor,
		children: [t, /* @__PURE__ */ B("span", {
			className: $.demoBadge,
			children: n.demoBadge
		})]
	}) : /* @__PURE__ */ B(z, { children: t });
}
//#endregion
//#region ../icons/src/icons/audio-off.ts
var Pd = {
	id: "audio-off",
	name: "Audio Off",
	category: "media",
	styles: {
		rounded: { svg: "<path d=\"M16.77 19.57Q16.49 19.74 16.22 19.9T15.65 20.18Q15.27 20.35 14.89 20.18T14.35 19.61Q14.2 19.23 14.39 18.87T14.95 18.33Q15.05 18.28 15.14 18.23T15.33 18.13L12 14.8V17.57Q12 18.25 11.39 18.51T10.3 18.3L7 15H4Q3.58 15 3.29 14.71T3 14V10Q3 9.58 3.29 9.29T4 9H6.2L2.1 4.9Q1.82 4.62 1.82 4.2T2.1 3.5 2.8 3.22 3.5 3.5L20.5 20.5Q20.78 20.78 20.78 21.2T20.5 21.9 19.8 22.18 19.1 21.9ZM19 11.97Q19 9.89 17.9 8.18T14.95 5.62Q14.57 5.45 14.4 5.08T14.35 4.34Q14.5 3.94 14.89 3.77T15.68 3.77Q18.1 4.85 19.55 7.05T21 11.97Q21 12.79 20.85 13.61T20.43 15.17Q20.23 15.72 19.82 15.86T19.06 15.87 18.5 15.42 18.49 14.67Q18.77 14.02 18.89 13.36T19 11.97M14.78 8.42Q15.6 8.95 16.05 10T16.5 12V12.25Q16.5 12.37 16.47 12.5 16.42 12.83 16.12 12.92T15.57 12.77L14.3 11.5Q14.15 11.35 14.07 11.16T14 10.78V8.85Q14 8.55 14.26 8.41T14.77 8.42M9.75 6.95Q9.6 6.8 9.6 6.6T9.75 6.25L10.3 5.7Q10.77 5.23 11.39 5.49T12 6.43V8Q12 8.35 11.7 8.47T11.15 8.35Z\"/>" },
		sharp: { svg: "<path d=\"M19.8 22.6L16.78 19.58Q16.16 19.98 15.46 20.27T14.01 20.73V18.68Q14.36 18.56 14.7 18.43T15.34 18.13L12 14.8V20L7 15H3V9H6.2L1.4 4.2 2.8 2.8 21.2 21.2ZM19.6 16.8L18.15 15.35Q18.57 14.57 18.79 13.73T19 11.98Q19 9.63 17.62 7.78T14 5.28V3.23Q17.1 3.93 19.05 6.37T21 11.97Q21 13.29 20.64 14.52T19.6 16.8M16.25 13.45L14 11.2V7.95Q15.18 8.5 15.84 9.6T16.5 12Q16.5 12.38 16.44 12.74T16.25 13.45M12 9.2L9.4 6.6 12 4Z\"/>" },
		outline: { svg: "<path d=\"M16.77 19.57Q16.49 19.74 16.22 19.9T15.65 20.18Q15.27 20.35 14.89 20.18T14.35 19.61Q14.2 19.23 14.39 18.87T14.95 18.33Q15.05 18.28 15.14 18.23T15.33 18.13L12 14.8V17.57Q12 18.25 11.39 18.51T10.3 18.3L7 15H4Q3.58 15 3.29 14.71T3 14V10Q3 9.58 3.29 9.29T4 9H6.2L2.1 4.9Q1.82 4.62 1.82 4.2T2.1 3.5 2.8 3.22 3.5 3.5L20.5 20.5Q20.78 20.78 20.78 21.2T20.5 21.9 19.8 22.18 19.1 21.9ZM19 11.97Q19 9.89 17.9 8.18T14.95 5.62Q14.57 5.45 14.4 5.08T14.35 4.34Q14.5 3.94 14.89 3.77T15.68 3.77Q18.1 4.85 19.55 7.05T21 11.97Q21 12.79 20.85 13.61T20.43 15.17Q20.23 15.72 19.82 15.86T19.06 15.87 18.5 15.42 18.49 14.67Q18.77 14.02 18.89 13.36T19 11.97M14.78 8.42Q15.6 8.95 16.05 10T16.5 12V12.25Q16.5 12.37 16.47 12.5 16.42 12.83 16.12 12.92T15.57 12.77L14.3 11.5Q14.15 11.35 14.07 11.16T14 10.78V8.85Q14 8.55 14.26 8.41T14.77 8.42M9.75 6.95Q9.6 6.8 9.6 6.6T9.75 6.25L10.3 5.7Q10.77 5.23 11.39 5.49T12 6.43V8Q12 8.35 11.7 8.47T11.15 8.35ZM10 15.15V12.8L8.2 11H5V13H7.85ZM9.1 11.9\"/>" },
		duotone: { svg: "<g opacity=\".32\"><path d=\"M16.77 19.57Q16.49 19.74 16.22 19.9T15.65 20.18Q15.27 20.35 14.89 20.18T14.35 19.61Q14.2 19.23 14.39 18.87T14.95 18.33Q15.05 18.28 15.14 18.23T15.33 18.13L12 14.8V17.57Q12 18.25 11.39 18.51T10.3 18.3L7 15H4Q3.58 15 3.29 14.71T3 14V10Q3 9.58 3.29 9.29T4 9H6.2L2.1 4.9Q1.82 4.62 1.82 4.2T2.1 3.5 2.8 3.22 3.5 3.5L20.5 20.5Q20.78 20.78 20.78 21.2T20.5 21.9 19.8 22.18 19.1 21.9ZM19 11.97Q19 9.89 17.9 8.18T14.95 5.62Q14.57 5.45 14.4 5.08T14.35 4.34Q14.5 3.94 14.89 3.77T15.68 3.77Q18.1 4.85 19.55 7.05T21 11.97Q21 12.79 20.85 13.61T20.43 15.17Q20.23 15.72 19.82 15.86T19.06 15.87 18.5 15.42 18.49 14.67Q18.77 14.02 18.89 13.36T19 11.97M14.78 8.42Q15.6 8.95 16.05 10T16.5 12V12.25Q16.5 12.37 16.47 12.5 16.42 12.83 16.12 12.92T15.57 12.77L14.3 11.5Q14.15 11.35 14.07 11.16T14 10.78V8.85Q14 8.55 14.26 8.41T14.77 8.42M9.75 6.95Q9.6 6.8 9.6 6.6T9.75 6.25L10.3 5.7Q10.77 5.23 11.39 5.49T12 6.43V8Q12 8.35 11.7 8.47T11.15 8.35Z\"/></g><path d=\"M16.77 19.57Q16.49 19.74 16.22 19.9T15.65 20.18Q15.27 20.35 14.89 20.18T14.35 19.61Q14.2 19.23 14.39 18.87T14.95 18.33Q15.05 18.28 15.14 18.23T15.33 18.13L12 14.8V17.57Q12 18.25 11.39 18.51T10.3 18.3L7 15H4Q3.58 15 3.29 14.71T3 14V10Q3 9.58 3.29 9.29T4 9H6.2L2.1 4.9Q1.82 4.62 1.82 4.2T2.1 3.5 2.8 3.22 3.5 3.5L20.5 20.5Q20.78 20.78 20.78 21.2T20.5 21.9 19.8 22.18 19.1 21.9ZM19 11.97Q19 9.89 17.9 8.18T14.95 5.62Q14.57 5.45 14.4 5.08T14.35 4.34Q14.5 3.94 14.89 3.77T15.68 3.77Q18.1 4.85 19.55 7.05T21 11.97Q21 12.79 20.85 13.61T20.43 15.17Q20.23 15.72 19.82 15.86T19.06 15.87 18.5 15.42 18.49 14.67Q18.77 14.02 18.89 13.36T19 11.97M14.78 8.42Q15.6 8.95 16.05 10T16.5 12V12.25Q16.5 12.37 16.47 12.5 16.42 12.83 16.12 12.92T15.57 12.77L14.3 11.5Q14.15 11.35 14.07 11.16T14 10.78V8.85Q14 8.55 14.26 8.41T14.77 8.42M9.75 6.95Q9.6 6.8 9.6 6.6T9.75 6.25L10.3 5.7Q10.77 5.23 11.39 5.49T12 6.43V8Q12 8.35 11.7 8.47T11.15 8.35ZM10 15.15V12.8L8.2 11H5V13H7.85ZM9.1 11.9\"/>" }
	},
	animation: () => Promise.reject(/* @__PURE__ */ Error("icon animations are not bundled"))
}, Fd = {
	id: "audio-on",
	name: "Audio On",
	category: "media",
	styles: {
		rounded: { svg: "<path d=\"M19 11.97Q19 9.89 17.9 8.18T14.95 5.62Q14.57 5.45 14.4 5.08T14.35 4.34Q14.5 3.94 14.89 3.77T15.68 3.77Q18.1 4.85 19.55 7.06T21 11.97 19.55 16.88 15.67 20.17Q15.27 20.34 14.88 20.17T14.34 19.6Q14.22 19.22 14.39 18.86T14.94 18.32Q16.79 17.47 17.89 15.76T18.99 11.97M7 15H4Q3.58 15 3.29 14.71T3 14V10Q3 9.58 3.29 9.29T4 9H7L10.3 5.7Q10.77 5.23 11.39 5.49T12 6.43V17.58Q12 18.26 11.39 18.52T10.3 18.3ZM16.5 12Q16.5 13.05 16.03 13.99T14.78 15.53Q14.53 15.68 14.27 15.54T14 15.1V8.85Q14 8.55 14.26 8.41T14.77 8.42Q15.55 9.04 16.02 9.99T16.49 11.99\"/>" },
		sharp: { svg: "<path d=\"M14 20.73V18.68Q16.25 18.03 17.62 16.18T19 11.98 17.62 7.78 14 5.28V3.23Q17.1 3.93 19.05 6.37T21 11.97 19.05 17.58 14 20.73M3 15V9H7L12 4V20L7 15ZM14 16V7.95Q15.18 8.5 15.84 9.6T16.5 12Q16.5 13.27 15.84 14.36T14 16\"/>" },
		outline: { svg: "<path d=\"M19 11.97Q19 9.89 17.9 8.18T14.95 5.62Q14.57 5.45 14.4 5.08T14.35 4.34Q14.5 3.94 14.89 3.77T15.68 3.77Q18.1 4.85 19.55 7.06T21 11.97 19.55 16.88 15.67 20.17Q15.27 20.34 14.88 20.17T14.34 19.6Q14.22 19.22 14.39 18.86T14.94 18.32Q16.79 17.47 17.89 15.76T18.99 11.97M7 15H4Q3.58 15 3.29 14.71T3 14V10Q3 9.58 3.29 9.29T4 9H7L10.3 5.7Q10.77 5.23 11.39 5.49T12 6.43V17.58Q12 18.26 11.39 18.52T10.3 18.3ZM16.5 12Q16.5 13.05 16.03 13.99T14.78 15.53Q14.53 15.68 14.27 15.54T14 15.1V8.85Q14 8.55 14.26 8.41T14.77 8.42Q15.55 9.04 16.02 9.99T16.49 11.99M10 8.85L7.85 11H5V13H7.85L10 15.15ZM7.5 12\"/>" },
		duotone: { svg: "<g opacity=\".32\"><path d=\"M15.68 3.77L16.83 4.38 17.86 5.13 18.76 6.03 19.55 7.06 20.18 8.2 20.64 9.39 20.91 10.65 21 11.97 20.91 13.29 20.64 14.55 20.18 15.74 19.55 16.88 18.76 17.91 17.86 18.81 16.82 19.56 15.67 20.17 15.27 20.25 14.88 20.17 14.55 19.94 14.34 19.6 14.29 19.23 14.39 18.86 14.61 18.55 15.82 17.84 16.6 17.25 17.29 16.56 17.89 15.76 18.37 14.88 18.71 13.96 18.92 12.99 19 11.97 18.93 10.95 18.73 9.98 18.38 9.06 17.9 8.18 17.3 7.38 16.61 6.68 15.83 6.1 14.62 5.4 14.4 5.08 14.3 4.71 14.35 4.34 14.56 4 14.89 3.77 15.28 3.69ZM11.39 5.49L11.85 5.86 12 6.43V17.58L11.85 18.16 11.39 18.52 10.81 18.59 10.3 18.3 7 15H4L3.61 14.93 3.29 14.71 3.07 14.39 3 14V10L3.07 9.61 3.29 9.29 3.61 9.07 4 9H7L10.3 5.7 10.81 5.41ZM14.77 8.42L15.47 9.12 16.02 9.99 16.37 10.96 16.5 12 16.38 13.02 16.03 13.99 15.48 14.85 14.78 15.53 14.53 15.61 14.27 15.54 14.07 15.36 14 15.1V8.85L14.06 8.59 14.26 8.41 14.52 8.34Z\"/></g><path d=\"M19 11.97Q19 9.89 17.9 8.18T14.95 5.62Q14.57 5.45 14.4 5.08T14.35 4.34Q14.5 3.94 14.89 3.77T15.68 3.77Q18.1 4.85 19.55 7.06T21 11.97 19.55 16.88 15.67 20.17Q15.27 20.34 14.88 20.17T14.34 19.6Q14.22 19.22 14.39 18.86T14.94 18.32Q16.79 17.47 17.89 15.76T18.99 11.97M7 15H4Q3.58 15 3.29 14.71T3 14V10Q3 9.58 3.29 9.29T4 9H7L10.3 5.7Q10.77 5.23 11.39 5.49T12 6.43V17.58Q12 18.26 11.39 18.52T10.3 18.3ZM16.5 12Q16.5 13.05 16.03 13.99T14.78 15.53Q14.53 15.68 14.27 15.54T14 15.1V8.85Q14 8.55 14.26 8.41T14.77 8.42Q15.55 9.04 16.02 9.99T16.49 11.99M10 8.85L7.85 11H5V13H7.85L10 15.15ZM7.5 12\"/>" }
	},
	animation: () => Promise.reject(/* @__PURE__ */ Error("icon animations are not bundled"))
}, Id = { toggle: "_toggle_bio0t_1" };
//#endregion
//#region src/shell/useSoundToggle.ts
function Ld() {
	let { sounds: e, strings: t, onSoundMutedChange: n } = f(), { muted: r } = y(e);
	return !n || !e.configured ? null : {
		label: t.muteSounds,
		muted: r,
		setMuted: n
	};
}
//#endregion
//#region src/shell/SoundToggle.tsx
function Rd({ muted: e }) {
	let t = (e ? Pd : Fd).styles.rounded.svg;
	return /* @__PURE__ */ B("svg", {
		"aria-hidden": "true",
		width: "20",
		height: "20",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		xmlns: "http://www.w3.org/2000/svg",
		dangerouslySetInnerHTML: { __html: t }
	});
}
function zd() {
	let e = Ld();
	return e ? /* @__PURE__ */ B("button", {
		type: "button",
		className: Id.toggle,
		"aria-pressed": e.muted,
		"aria-label": e.label,
		onClick: () => e.setMuted(!e.muted),
		children: /* @__PURE__ */ B(Rd, { muted: e.muted })
	}) : null;
}
var Bd = {
	results: "_results_1ypk9_1",
	grid: "_grid_1ypk9_10",
	item: "_item_1ypk9_19",
	itemImage: "_itemImage_1ypk9_32",
	itemName: "_itemName_1ypk9_39",
	itemValue: "_itemValue_1ypk9_51",
	total: "_total_1ypk9_57",
	totalValue: "_totalValue_1ypk9_62",
	claimError: "_claimError_1ypk9_67",
	actions: "_actions_1ypk9_73",
	autoClaimLabel: "_autoClaimLabel_1ypk9_81",
	itemImageWrap: "_itemImageWrap_1ypk9_90",
	itemImageSubstitute: "_itemImageSubstitute_1ypk9_97",
	substituteBadge: "_substituteBadge_1ypk9_101",
	itemNotice: "_itemNotice_1ypk9_117",
	itemActions: "_itemActions_1ypk9_125",
	itemButton: "_itemButton_1ypk9_133",
	itemStatus: "_itemStatus_1ypk9_152"
};
//#endregion
//#region src/results/ResultsItemCard.tsx
function Vd({ entry: e, claimed: t, action: n, onWithdraw: r, buttonClassName: i }) {
	let { strings: a } = f();
	return n?.status === "withdrawn" ? /* @__PURE__ */ B("p", {
		className: Bd.itemStatus,
		children: a.withdrawRequested
	}) : !r || e.item.isGemSubstitute === !0 ? null : /* @__PURE__ */ B("button", {
		type: "button",
		className: i,
		onClick: () => r(t),
		children: a.withdrawItem
	});
}
function Hd({ entry: e, claimed: t, action: n, onWithdraw: r }) {
	let { strings: i } = f();
	return n?.status === "withdrawn" ? null : e.item.isGemSubstitute !== !0 && t.isLimited && r ? /* @__PURE__ */ B("p", {
		className: Bd.itemNotice,
		children: i.limitedItemNotice
	}) : null;
}
function Ud(e) {
	let { strings: t } = f(), { entry: n, claimed: r, action: i, onWithdraw: a } = e;
	if (i?.status === "withdrawn") return /* @__PURE__ */ B(Vd, { ...e });
	let o = n.item.isGemSubstitute === !0;
	return !a || o ? null : /* @__PURE__ */ V(z, { children: [r.isLimited ? /* @__PURE__ */ B("p", {
		className: Bd.itemNotice,
		children: t.limitedItemNotice
	}) : null, /* @__PURE__ */ B("div", {
		className: Bd.itemActions,
		children: /* @__PURE__ */ B(Vd, {
			...e,
			buttonClassName: Bd.itemButton
		})
	})] });
}
function Wd({ entry: e, claimed: t, action: n, onWithdraw: r }) {
	let { strings: i, currency: a } = f(), o = e.item.isGemSubstitute === !0;
	return /* @__PURE__ */ V("div", {
		className: Bd.item,
		children: [
			/* @__PURE__ */ V("div", {
				className: Bd.itemImageWrap,
				children: [/* @__PURE__ */ B("img", {
					className: Y(Bd.itemImage, o && Bd.itemImageSubstitute),
					src: e.item.imageUrl,
					alt: e.item.name,
					loading: "eager",
					decoding: "async"
				}), o ? /* @__PURE__ */ B("span", {
					className: Bd.substituteBadge,
					children: i.substituteBadge
				}) : null]
			}),
			/* @__PURE__ */ B("p", {
				className: Bd.itemName,
				children: e.item.name
			}),
			/* @__PURE__ */ B("span", {
				className: Bd.itemValue,
				children: S(e.item.value, a, { compact: !0 })
			}),
			t ? /* @__PURE__ */ B(Ud, {
				entry: e,
				claimed: t,
				action: n,
				onWithdraw: r
			}) : null
		]
	});
}
//#endregion
//#region src/results/ResultsView.tsx
function Gd({ entries: e, claimStatus: t = "none", claimCostCents: n, claimErrorMessage: r, sellErrorMessage: i, onClaim: a, onSellBack: o, onAutoClaimChange: s, onOpenAgain: c, settledAction: l, claimedItems: u, itemActions: d, onWithdrawItem: p, buttonClassName: m, secondaryButtonClassName: h, showItems: g = !0, demo: _ = !1, showActions: v = !0 }) {
	let { strings: y, currency: b } = f(), x = I(() => [...e].sort((e, t) => t.item.value - e.item.value), [e]), C = I(() => new Map((u ?? []).map((e) => [e.openId, e])), [u]), w = I(() => x.flatMap((e) => {
		let t = C.get(e.openId);
		return t ? [{
			entry: e,
			claimed: t,
			action: d?.[t.inventoryItemId]
		}] : [];
	}), [
		x,
		C,
		d
	]), T = I(() => e.reduce((e, t) => e + t.item.value, 0), [e]), E = t === "unclaimed" || t === "claiming" || t === "selling", D = t === "claiming" || t === "selling", O = !!o && T > 0, k = r ?? i ?? null;
	return /* @__PURE__ */ V("div", {
		className: Bd.results,
		children: [
			g ? /* @__PURE__ */ B("div", {
				className: Bd.grid,
				children: x.map((e) => {
					let t = C.get(e.openId);
					return /* @__PURE__ */ B(Wd, {
						entry: e,
						claimed: t,
						action: t ? d?.[t.inventoryItemId] : void 0,
						onWithdraw: p
					}, e.openId);
				})
			}) : null,
			e.length > 1 && /* @__PURE__ */ V("div", {
				className: Bd.total,
				children: [
					y.totalValue,
					":",
					" ",
					/* @__PURE__ */ B("span", {
						className: Bd.totalValue,
						children: S(T, b)
					})
				]
			}),
			v && k ? /* @__PURE__ */ B("div", {
				className: Bd.claimError,
				children: k
			}) : null,
			v ? E ? /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ V("div", {
				className: Bd.actions,
				children: [
					/* @__PURE__ */ V("button", {
						type: "button",
						className: m,
						disabled: D,
						onClick: a,
						children: [t === "claiming" ? y.claiming : y.claim, n != null && t !== "claiming" ? /* @__PURE__ */ V(z, { children: [" ", S(n, b)] }) : null]
					}),
					O ? /* @__PURE__ */ V("button", {
						type: "button",
						className: h,
						disabled: D,
						onClick: o,
						children: [t === "selling" ? y.sellingBack : y.sellBack, t === "selling" ? null : /* @__PURE__ */ V(z, { children: [" ", S(T, b)] })]
					}) : null,
					/* @__PURE__ */ B(zd, {})
				]
			}), s ? /* @__PURE__ */ V("label", {
				className: Bd.autoClaimLabel,
				children: [/* @__PURE__ */ B("input", {
					type: "checkbox",
					defaultChecked: !1,
					onChange: (e) => s(e.target.checked)
				}), y.autoClaimLabel]
			}) : null] }) : /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ V("div", {
				className: Bd.actions,
				children: [
					g ? null : w.map(({ entry: e, claimed: t, action: n }) => /* @__PURE__ */ B(Vd, {
						entry: e,
						claimed: t,
						action: n,
						onWithdraw: p,
						buttonClassName: h
					}, e.openId)),
					/* @__PURE__ */ B(Nd, {
						demo: _,
						children: /* @__PURE__ */ B("button", {
							type: "button",
							className: m,
							onClick: l?.onClick ?? c,
							children: l?.label ?? y.openAgain
						})
					}),
					/* @__PURE__ */ B(zd, {})
				]
			}), g ? null : w.map(({ entry: e, claimed: t, action: n }) => /* @__PURE__ */ B(Hd, {
				entry: e,
				claimed: t,
				action: n,
				onWithdraw: p
			}, e.openId))] }) : null
		]
	});
}
//#endregion
//#region src/shell/OpenerShell.tsx
var Kd = {
	canSkip: !0,
	custom: null
};
function qd({ boxData: e, descriptor: t, loading: n, machine: r, state: i, exit: a, quantities: o, quickRevealMode: s, isDemoMode: c, errorMessage: l, claimErrorMessage: d, sellErrorMessage: p, prandGenerator: m, onOpenClick: g, onDemoOpenClick: _, onAutoClaimChange: v, onSellBack: y, itemActions: b, onWithdrawItem: C, renderIdle: w, renderResults: E, renderControls: D, settledAction: O, prepaid: A = !1, fairnessPanel: j, className: M, style: ee }) {
	let { strings: N, theme: P, currency: F } = f(), te = Ld(), H = T(i.phase), [ne, re] = R(Kd), ie = I(() => e ? e.dropTable.filter((e) => e.weight > 0).map((t) => {
		let n = h(t.value, e.priceCents ?? 0);
		return /* @__PURE__ */ B("div", {
			className: $.idleCard,
			children: /* @__PURE__ */ B("img", {
				className: $.idleCardImage,
				style: { filter: u(P.rarityRgb, n, "10px", "0.4") },
				src: t.imageUrl,
				alt: t.name,
				loading: "lazy",
				decoding: "async"
			})
		}, t.itemId);
	}) : [], [e, P.rarityRgb]), ae = i.phase === "requesting", oe = o.at(-1) ?? 1, se = A || o.length <= 1 ? [] : o, ce = () => e ? /* @__PURE__ */ V("div", {
		className: $.controls,
		children: [l ? /* @__PURE__ */ B("div", {
			className: $.errorBanner,
			children: l
		}) : null, /* @__PURE__ */ V("div", {
			className: $.controlsRow,
			children: [
				A || oe <= 1 ? null : /* @__PURE__ */ B("fieldset", {
					className: $.quantityGroup,
					"aria-label": N.quantity,
					children: se.map((e) => /* @__PURE__ */ B("button", {
						type: "button",
						className: Y($.quantityButton, e === i.quantity && $.quantityButtonActive),
						"aria-pressed": e === i.quantity,
						disabled: ae,
						onClick: () => r.setQuantity(e),
						children: e
					}, e))
				}),
				/* @__PURE__ */ B(Nd, {
					demo: c,
					children: /* @__PURE__ */ V("button", {
						type: "button",
						className: $.primaryButton,
						disabled: ae,
						onClick: g,
						children: [N.open, A ? null : /* @__PURE__ */ V(z, { children: ["\xA0", /* @__PURE__ */ B("span", {
							className: $.priceTag,
							children: S(e.priceCents * i.quantity, F)
						})] })]
					})
				}),
				s === "toggle" ? /* @__PURE__ */ V("label", {
					className: $.toggleLabel,
					children: [/* @__PURE__ */ B("input", {
						type: "checkbox",
						checked: i.isQuickReveal,
						onChange: (e) => r.setQuickReveal(e.target.checked)
					}), N.quickReveal]
				}) : null,
				/* @__PURE__ */ B(zd, {})
			]
		})]
	}) : null, le = (e) => ({
		boxData: e,
		open: g,
		quantity: i.quantity,
		setQuantity: r.setQuantity,
		quantities: se,
		quickReveal: s === "toggle" ? {
			on: i.isQuickReveal,
			set: r.setQuickReveal
		} : void 0,
		demo: c,
		demoOpen: _,
		requesting: ae,
		errorMessage: l ?? null,
		prepaid: A,
		sound: te ?? void 0
	}), U = () => r.reset(), ue = c || i.lastResponse !== null && zu(i.lastResponse), de = Lu(i.entries, t.revealLimit), fe = () => ({
		entries: i.entries,
		claimStatus: i.claimStatus,
		claimCostCents: A ? null : i.pendingClaim?.costCents ?? null,
		claim: () => void r.claim(),
		sellBack: y,
		setAutoClaim: v,
		claimErrorMessage: d ?? null,
		sellErrorMessage: p ?? null,
		claimedItems: i.claimStatus === "claimed" ? i.claim?.items ?? [] : [],
		openAgain: U,
		settledAction: O,
		demo: ue
	}), pe = () => a.skipReveal(ne.onBeforeSkip), me = (e) => {
		if (!D) return null;
		let t = H === "pre" ? {
			phase: H,
			idle: le(e)
		} : H === "during" ? {
			phase: H,
			skip: ne.canSkip ? pe : null
		} : {
			phase: H,
			results: fe()
		};
		return /* @__PURE__ */ B("div", {
			className: $.hostControls,
			children: D(t)
		});
	}, he = () => n || !e ? /* @__PURE__ */ B("div", {
		className: $.loading,
		children: N.loading
	}) : w ? /* @__PURE__ */ B("div", {
		className: $.hostIdle,
		children: w(le(e))
	}) : /* @__PURE__ */ V(z, { children: [
		/* @__PURE__ */ V("div", {
			className: $.idleHero,
			children: [
				e.opener?.logoSvg ? /* @__PURE__ */ B("img", {
					className: $.brandLogo,
					src: x(e.opener.logoSvg),
					alt: "",
					"aria-hidden": "true"
				}) : e.opener?.brandName?.trim() ? /* @__PURE__ */ B("span", {
					className: $.brandName,
					children: e.opener.brandName.trim()
				}) : null,
				e.imageUrl ? /* @__PURE__ */ B("img", {
					className: $.boxImage,
					src: e.imageUrl,
					alt: e.name,
					loading: "eager",
					decoding: "async"
				}) : null,
				/* @__PURE__ */ B("h2", {
					className: $.boxName,
					children: e.name
				}),
				A ? null : /* @__PURE__ */ B("span", {
					className: $.boxPrice,
					children: S(e.priceCents, F)
				})
			]
		}),
		/* @__PURE__ */ B("div", {
			className: $.idleScrollerArea,
			children: /* @__PURE__ */ B(Md, {
				slots: ie,
				itemWidth: 104,
				gap: 12
			})
		}),
		D ? null : ce()
	] }), ge = () => t.ActionRow ? /* @__PURE__ */ B(t.ActionRow, {
		controls: ne,
		onSkip: pe
	}) : ne.canSkip ? /* @__PURE__ */ B("button", {
		type: "button",
		className: $.secondaryButton,
		onClick: pe,
		children: N.skip
	}) : null, _e = (e, n) => /* @__PURE__ */ B(k, {
		fallback: /* @__PURE__ */ B("div", {
			className: $.openerLoading,
			children: N.loading
		}),
		children: /* @__PURE__ */ B(t.Opener, {
			boxData: e,
			reveal: {
				entries: n?.phase === "pre" ? [] : de,
				quantity: Math.min(de.length || i.quantity, t.revealLimit ?? oe),
				isQuickReveal: i.isQuickReveal,
				prandGenerator: m
			},
			onRevealComplete: a.completeReveal,
			onControlsStateChange: re,
			phase: n?.phase,
			controls: n?.controls
		}, n?.run)
	}), W = () => e ? /* @__PURE__ */ V("div", {
		className: $.revealArea,
		children: [/* @__PURE__ */ B("div", {
			className: $.revealStage,
			children: _e(e)
		}), D ? null : /* @__PURE__ */ V("div", {
			className: $.controlsRow,
			children: [/* @__PURE__ */ B(zd, {}), ge()]
		})]
	}) : null, ve = (e) => /* @__PURE__ */ B(Gd, {
		showItems: e,
		showActions: !D,
		entries: i.entries,
		claimStatus: i.claimStatus,
		claimCostCents: A ? null : i.pendingClaim?.costCents ?? null,
		claimErrorMessage: d,
		sellErrorMessage: p,
		onClaim: () => void r.claim(),
		onSellBack: y,
		onAutoClaimChange: v,
		onOpenAgain: U,
		settledAction: O,
		claimedItems: i.claimStatus === "claimed" ? i.claim?.items : void 0,
		itemActions: b,
		onWithdrawItem: C,
		buttonClassName: $.primaryButton,
		secondaryButtonClassName: $.secondaryButton,
		demo: ue
	}), ye = () => E ? /* @__PURE__ */ B(z, { children: E(fe()) }) : ve(!0), G = L(0), be = L(H);
	return be.current === "post" && H === "pre" && (G.current += 1), be.current = H, /* @__PURE__ */ V("div", {
		className: Y("los-root", $.root, M),
		style: ee,
		"data-los-host-idle": w && t.stage !== "all" && H === "pre" && e && !n ? "" : void 0,
		"data-los-host-controls": D ? "" : void 0,
		children: [
			t.stage === "all" ? /* @__PURE__ */ B("div", {
				className: $.phase,
				"data-los-phase": H,
				children: (() => {
					if (n || !e) return /* @__PURE__ */ B("div", {
						className: $.loading,
						children: N.loading
					});
					let t = D ? null : H === "pre" ? ce() : H === "during" ? /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B(zd, {}), ge()] }) : E ? E(fe()) : ve(!1);
					return /* @__PURE__ */ B("div", {
						className: Y($.revealStage, $.stageOwned),
						children: _e(e, {
							run: G.current,
							phase: H,
							controls: t
						})
					});
				})()
			}) : /* @__PURE__ */ V("div", {
				className: $.phase,
				"data-los-phase": H,
				children: [
					H === "pre" && he(),
					H === "during" && W(),
					H === "post" && ye()
				]
			}, H),
			e && !n ? me(e) : null,
			j ? /* @__PURE__ */ B("div", {
				className: $.fairnessArea,
				children: j
			}) : null
		]
	});
}
//#endregion
//#region src/LootBoxOpener.tsx
function Jd(e) {
	let t = Fc(), n = e.publishableKey ?? t.publishableKey, r = e.baseUrl ?? t.baseUrl, i = e.sessionToken ?? t.sessionToken ?? null, s = e.sessionPending ?? t.sessionPending ?? !1, l = e.onSessionExpired ?? t.onSessionExpired, u = e.client ?? t.client, d = e.createClient ?? t.createClient, f = e.theme ?? t.theme, p = e.sounds ?? t.sounds, m = e.soundBaseUrl ?? t.soundBaseUrl, h = e.locale ?? t.locale, g = e.currency ?? t.currency ?? C, _ = I(() => a(h), [h]), v = e.soundEvents ?? t.soundEvents;
	zl(e.soundMuted !== void 0 || e.soundVolume !== void 0 ? {
		muted: e.soundMuted ?? t.soundMuted,
		volume: e.soundVolume ?? t.soundVolume
	} : null, "opener");
	let y = Hl({
		sounds: p,
		soundBaseUrl: m,
		soundEvents: v
	}), { client: x, error: S } = Dd({
		client: u,
		createClient: d,
		publishableKey: n,
		baseUrl: r,
		sessionToken: i,
		onSessionExpired: l
	}), { box: w, loading: T, error: E } = Sd({
		client: x,
		boxId: e.boxId
	}), D = e.opener, O = I(() => w && D ? {
		...w,
		opener: D
	} : w, [w, D]), k = O?.opener?.kind, A = O?.opener?.theme, j = I(() => xd(k), [k]);
	N(() => j.preload?.(), [j]);
	let ee = I(() => c(b(f, A)), [f, A]), [P, F] = Qu({
		clientSeed: e.clientSeed,
		onClientSeedChange: e.onClientSeedChange
	}), te = !s && !i && !u, z = e.quantities, V = e.maxQuantity, H = I(() => Iu({
		quantities: z,
		maxQuantity: V,
		descriptor: j
	}), [
		z,
		V,
		j
	]), ne = H.at(-1) ?? 1, re = L({
		client: x,
		box: O,
		clientSeed: P,
		isDemoMode: te
	});
	re.current = {
		client: x,
		box: O,
		clientSeed: P,
		isDemoMode: te
	};
	let { mutateAsync: ie } = se({
		mutationKey: [
			"loot-os",
			"open",
			Gu(x)
		],
		mutationFn: (e) => {
			let t = re.current;
			if (!t.box) throw Error("[loot-os] box not loaded yet");
			if (!t.client) throw Error("[loot-os] no API client configured");
			return t.client.openBox({
				boxId: t.box.id,
				clientSeed: t.clientSeed,
				amount: e.quantity,
				expectedVersion: t.box.version,
				idempotencyKey: e.idempotencyKey
			});
		}
	}, Hu()), ae = L(!1), oe = M(async (e) => {
		let t = re.current;
		if (!t.box) throw Error("[loot-os] box not loaded yet");
		let n = ae.current;
		return ae.current = !1, t.isDemoMode || n ? rd(t.box, e, t.clientSeed) : ie({
			quantity: e,
			idempotencyKey: Ku()
		});
	}, [ie]), le = L(null), { mutateAsync: U } = se({
		mutationKey: [
			"loot-os",
			"claim",
			Gu(x)
		],
		mutationFn: async (e) => {
			let t = re.current;
			if (!t.client) throw Error("[loot-os] no API client configured");
			let { claim: n } = await t.client.claimReveal({
				openGroupId: e.openGroupId,
				expectedPurchaseAmount: e.costCents
			});
			return n;
		}
	}, Hu()), ue = M(async (e) => re.current.isDemoMode ? id(e, le.current?.getState().entries ?? []) : U(e), [U]), { mutateAsync: de } = se({
		mutationKey: [
			"loot-os",
			"sell-back",
			Gu(x)
		],
		mutationFn: async (e) => {
			let t = re.current;
			if (!t.client?.sellBackReveal) throw Error("[loot-os] the API client cannot sell back");
			let { sale: n } = await t.client.sellBackReveal({
				openGroupId: e.openGroupId,
				expectedPurchaseAmount: e.costCents
			});
			return n;
		}
	}, Hu()), fe = M(async (e) => re.current.isDemoMode ? ad(e, le.current?.getState().entries ?? []) : de(e), [de]), pe = te || typeof x?.sellBackReveal == "function", [me, he] = R({}), ge = L(e);
	ge.current = e;
	let { machine: _e, state: W } = Td({
		openBox: oe,
		claimReveal: ue,
		sellBackReveal: fe,
		onBeforeOpen: M((e) => ge.current.onOpenStart?.(e, { demo: re.current.isDemoMode || ae.current }), []),
		onEvent: M((e) => {
			let t = ge.current;
			switch (e.type) {
				case "open_start":
				case "restored":
				case "reset":
					he({});
					break;
				case "opened":
					t.onOpened?.(e.response);
					break;
				case "reveal_complete":
					t.onRevealComplete?.(e.response);
					break;
				case "claimed":
					t.onClaimed?.(e.claim);
					break;
				case "sold_back":
					t.onSoldBack?.(e.sale);
					break;
				case "claim_error":
				case "sell_back_error":
				case "error": Bu(e.error) && e.error.code === "insufficient_balance" && t.onInsufficientBalance?.(e.error), t.onError?.(e.error);
			}
		}, []),
		settlesOnReveal: M((e) => zu(e) && !re.current.isDemoMode, []),
		maxQuantity: ne,
		defaultQuantity: e.defaultQuantity,
		defaultQuickReveal: e.quickReveal === !0
	});
	le.current = _e;
	let [ve, ye] = R(0);
	N(() => {
		s && ye((e) => e + 1);
	}, [s]);
	let G = ce({
		queryKey: [
			"loot-os",
			"unclaimedReveal",
			Gu(x),
			ve
		],
		queryFn: async () => await x?.getUnclaimedReveal?.() ?? null,
		enabled: !s && !te && !!x?.getUnclaimedReveal,
		staleTime: 0,
		gcTime: 0
	}, Hu()), be = L(!1);
	N(() => {
		let e = G.data;
		be.current || !e || (be.current = !0, _e.restore(e));
	}, [G.data, _e]);
	let xe = s || G.isLoading;
	N(() => {
		typeof e.quickReveal == "boolean" && _e.setQuickReveal(e.quickReveal);
	}, [_e, e.quickReveal]);
	let Se = I(() => Ru({
		revealExit: j.revealExit,
		isQuickReveal: W.isQuickReveal,
		actions: {
			finishReveal: () => _e.completeReveal(),
			skipReveal: () => _e.skip()
		}
	}), [
		_e,
		W.isQuickReveal,
		j
	]);
	N(() => {
		W.phase !== "revealing" && Se.cancel();
	}, [W.phase, Se]), N(() => () => Se.cancel(), [Se]);
	let Ce = M(() => {
		y.unlock(), _e.open();
	}, [_e, y]), we = M(() => {
		y.unlock(), ae.current = !0, _e.open().finally(() => {
			ae.current = !1;
		});
	}, [_e, y]), Te = !te && !s && !e.prepaid, Ee = M(() => void _e.sellBack(), [_e]), De = M((e) => {
		he((t) => ({
			...t,
			[e.inventoryItemId]: { status: "withdrawn" }
		})), ge.current.onWithdrawRequested?.(e);
	}, []), Oe = W.error ?? E ?? S, ke = Oe ? Bu(Oe) ? Oe.code === "insufficient_balance" ? _.errorInsufficientBalance : Oe.code === "account_locked" ? _.errorAccountLocked : Oe.message || _.errorGeneric : _.errorGeneric : null, Ae = W.claimError ? Bu(W.claimError) && W.claimError.code === "insufficient_balance" ? _.errorInsufficientBalance : Bu(W.claimError) && W.claimError.code === "account_locked" ? _.errorAccountLocked : _.errorClaimFailed : null, je = W.sellError ? Bu(W.sellError) && W.sellError.code === "insufficient_balance" ? _.errorInsufficientBalance : Bu(W.sellError) && W.sellError.code === "account_locked" ? _.errorAccountLocked : _.errorSellBackFailed : null, K = !te && typeof e.onWithdrawRequested == "function", Me = !te && typeof x?.updateMySettings == "function", { mutate: Ne } = se({
		mutationKey: [
			"loot-os",
			"settings",
			Gu(x)
		],
		mutationFn: async (e) => await re.current.client?.updateMySettings?.(e) ?? null
	}, Hu()), Pe = M((e) => {
		Ne({ autoClaim: e });
	}, [Ne]), Fe = I(() => ({
		strings: _,
		theme: ee,
		sounds: y,
		onSoundMutedChange: t.onSoundMutedChange,
		currency: g,
		renderItemLabel: e.renderItemLabel
	}), [
		_,
		ee,
		y,
		t.onSoundMutedChange,
		g,
		e.renderItemLabel
	]), Ie = e.showFairness ?? !0 ? /* @__PURE__ */ B(ed, {
		client: x,
		lastResponse: W.lastResponse,
		clientSeed: P,
		onClientSeedChange: F,
		locked: W.phase === "revealing" || W.phase === "requesting"
	}) : null;
	return /* @__PURE__ */ B(o.Provider, {
		value: Fe,
		children: /* @__PURE__ */ B(qd, {
			boxData: O,
			descriptor: j,
			loading: T || xe,
			machine: _e,
			state: W,
			exit: Se,
			quantities: H,
			quickRevealMode: e.quickReveal ?? !1,
			isDemoMode: te,
			errorMessage: ke,
			claimErrorMessage: Ae,
			sellErrorMessage: je,
			onOpenClick: Ce,
			onDemoOpenClick: Te ? we : void 0,
			onSellBack: pe ? Ee : void 0,
			itemActions: me,
			onWithdrawItem: K ? De : void 0,
			onAutoClaimChange: Me ? Pe : void 0,
			renderIdle: e.renderIdle,
			renderResults: e.renderResults,
			renderControls: e.renderControls,
			settledAction: e.settledAction,
			prepaid: e.prepaid,
			fairnessPanel: Ie,
			className: e.className,
			style: {
				...ee.cssVars,
				...e.style
			}
		})
	});
}
//#endregion
//#region src/react/LootProvider.tsx
function Yd({ children: e, ...t }) {
	zl(t.soundMuted !== void 0 || t.soundVolume !== void 0 ? {
		muted: t.soundMuted,
		volume: t.soundVolume
	} : null, "provider");
	let n = I(() => t, [
		t.publishableKey,
		t.baseUrl,
		t.sessionToken,
		t.sessionPending,
		t.onSessionExpired,
		t.client,
		t.createClient,
		t.theme,
		t.sounds,
		t.soundBaseUrl,
		t.soundEvents,
		t.soundMuted,
		t.soundVolume,
		t.onSoundMutedChange,
		t.locale,
		t.currency
	]);
	return /* @__PURE__ */ B(Pc.Provider, {
		value: n,
		children: e
	});
}
//#endregion
export { Ul as BATTLE_OPENER_COMPACT_BREAKPOINT_PX, lu as BATTLE_PLAYER_COUNTS, fu as BATTLE_REEL_TIMINGS, du as BATTLE_SETTLE_MS, uu as BATTLE_SPIN_START_DELAY_MS, cu as BATTLE_START_COUNTDOWN_MS, jc as BattleLaneReel, Du as BattleOpener, ku as BattleResultsGrid, gu as BattleRound, Mu as BattleStartingOverlay, qu as CLIENT_SEED_STORAGE_KEY, C as DEFAULT_CURRENCY, bd as DEFAULT_OPENER_KIND, Fu as DEFAULT_QUANTITIES, g as DEFAULT_RARITY_RAIL_HEX, p as DEFAULT_RARITY_RGB, w as DEFAULT_STRINGS, Jd as LootBoxOpener, Yd as LootProvider, Ju as MAX_CLIENT_SEED_LENGTH, Ys as MOTION_ANIMATION_DURATION, ec as MOTION_ENDING_ITEM_IDX, Xs as MOTION_QUICK_ANIMATION_DURATION, Qs as MOTION_QUICK_STAGGER_DELAY, tc as MOTION_REVEAL_LINGER_MS, Js as MOTION_SECOND_PHASE_ANIMATION_DURATION, Zs as MOTION_STAGGER_DELAY, $s as MOTION_STARTING_ITEM_IDX, yd as OPENER_DESCRIPTORS, ed as ProvablyFairPanel, d as RESULT_RANGE, Nu as REVEAL_START_DELAY_MS, au as battleOpenerLayout, m as battleReelGenerator, pu as battleRevealIntervalMs, mu as battleRoundRevealMs, hu as battleSpinItems, Pu as createOpenerMachine, Ru as createOpenerRevealExit, t as currencyFractionDigits, e as currencyUnitName, E as defineOpenerDescriptor, S as formatAmount, n as formatAmountWithUnit, rc as generateItemWheel, nc as generateRandomItems, i as getItemChance, h as getItemRarity, T as getOpenerPhase, u as getRarityGlowFilter, l as getRarityGlowFilterByRarity, r as getSpinnerRailColor, _ as hashSeed, zu as isDemoOpenResponse, Bu as isLootApiErrorLike, b as mergeLootTheme, iu as normalizeBattlePlayerCount, O as registerOpener, s as resolveKindTokens, xd as resolveOpenerDescriptor, Pl as resolveOpenerSoundUrls, a as resolveStrings, c as resolveTheme, v as selectFromDropTable, kc as useBattleLane, Qu as useClientSeed, Sd as useLootBox, Fc as useLootProviderConfig, Cd as useOpenBox, Td as useOpenerMachine, wd as useOpenerMachineState, Hl as useOpenerSounds };

//# sourceMappingURL=index.js.map